
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("djmKw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $23c487fbdabb1bfd$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");

/* RendererComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $fVUfS = parcelRequire("fVUfS");


var $3yh4a = parcelRequire("3yh4a");


var $9wGTI = parcelRequire("9wGTI");


var $2XqLN = parcelRequire("2XqLN");





var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $6g1oe = parcelRequire("6g1oe");


var $1cgiE = parcelRequire("1cgiE");


var $4FxUL = parcelRequire("4FxUL");


var $ibzAc = parcelRequire("ibzAc");


var $67O0h = parcelRequire("67O0h");


var $1iSzD = parcelRequire("1iSzD");


var $i6Ps3 = parcelRequire("i6Ps3");


var $fgQGl = parcelRequire("fgQGl");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $kLzei = parcelRequire("kLzei");


var $6M71K = parcelRequire("6M71K");


var $6GQtz = parcelRequire("6GQtz");


var $04e9M = parcelRequire("04e9M");


var $lmNXu = parcelRequire("lmNXu");


var $edEsl = parcelRequire("edEsl");


var $fyKZ5 = parcelRequire("fyKZ5");


var $1a6Dn = parcelRequire("1a6Dn");


var $hrAmX = parcelRequire("hrAmX");


var $kBU5m = parcelRequire("kBU5m");


var $3WO8q = parcelRequire("3WO8q");

var $eXfot = parcelRequire("eXfot");

var $gxhb8 = parcelRequire("gxhb8");


var $9UKrO = parcelRequire("9UKrO");


var $dtVue = parcelRequire("dtVue");


var $c4QoG = parcelRequire("c4QoG");


var $4IoVL = parcelRequire("4IoVL");


var $32x2E = parcelRequire("32x2E");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");





var $ge2sX = parcelRequire("ge2sX");


var $lEf66 = parcelRequire("lEf66");

/**
 * @generated SignedSource<<b5a4dd941d120420d75e69b29ad22e08>>
 * @relayHash 06bc7ae3e2e497941f8d1738171f8bb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5ef6663bccf7015c3707545cb7bee1684c03826006312c2775240be1421634d
const $0878b4ab72f17c58$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "GlobalOperationsUserPermissionTypeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "GlobalOperationsUserPermissionTypeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "06bc7ae3e2e497941f8d1738171f8bb4",
            "id": "f5ef6663bccf7015c3707545cb7bee1684c03826006312c2775240be1421634d",
            "metadata": {},
            "name": "GlobalOperationsUserPermissionTypeQuery",
            "operationKind": "query",
            "text": "query GlobalOperationsUserPermissionTypeQuery{user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
        }
    };
}();
$0878b4ab72f17c58$var$node.hash = "b07108af76c48e11bbcd733ba0612fcf";
var $0878b4ab72f17c58$export$2e2bcd8739ae039 = $0878b4ab72f17c58$var$node;


var $5OVTZ = parcelRequire("5OVTZ");


var $c0rhi = parcelRequire("c0rhi");

const $2d2df6655155416b$export$60b2889c65284218 = async ()=>{
    await (0, $ge2sX.getSessionData)();
    // External Collaborators should not have access to view user profile
    const { data: userPermissionData } = await (0, $c0rhi.queryInterop)({
        query: (0, $0878b4ab72f17c58$export$2e2bcd8739ae039),
        errorPolicy: 'all',
        __callerPackage__: "@confluence/global-operations"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return new Error('PERMISSION ERROR');
    });
    const isExternalCollaborator = (0, $lEf66.getUserPermissionFromQuery)(userPermissionData) === (0, $5OVTZ.SitePermissionType).EXTERNAL;
    return !isExternalCollaborator;
};



var $habRv = parcelRequire("habRv");


var $5dnlf = parcelRequire("5dnlf");


var $jlIaF = parcelRequire("jlIaF");


var $4qzKl = parcelRequire("4qzKl");


var $gXsSh = parcelRequire("gXsSh");


var $3Btfb = parcelRequire("3Btfb");





var $hSHWm = parcelRequire("hSHWm");

function $2e0df58e89030dfc$export$c5356dc8cba0700d(WrappedComponent) {
    function WithCoreInvitesContext(props) {
        const coreInvitesContext = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...coreInvitesContext,
            ...props
        });
    }
    WithCoreInvitesContext.displayName = `withCoreInvitesContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithCoreInvitesContext;
}






var $gXrHX = parcelRequire("gXrHX");

function $134fa45286a9b1d7$export$adde0c9097009696(WrappedComponent) {
    function WithExternalShareContext(props) {
        const externalShareContext = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...externalShareContext,
            ...props
        });
    }
    WithExternalShareContext.displayName = `withExternalShareContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithExternalShareContext;
}



var $d9tcB = parcelRequire("d9tcB");


var $f0NfR = parcelRequire("f0NfR");


var $gqqjz = parcelRequire("gqqjz");


var $1SPMi = parcelRequire("1SPMi");


var $fySJw = parcelRequire("fySJw");


var $gCz4s = parcelRequire("gCz4s");


var $6mKj3 = parcelRequire("6mKj3");


var $iP9x4 = parcelRequire("iP9x4");


var $k77lQ = parcelRequire("k77lQ");







const $1312f8b4a0711d1a$export$58eac04eb6213951 = ()=>(0, $9wGTI.fg)('platform_renderer_unsupported_content_tracking') ? (0, $fyKZ5.UNSUPPORTED_CONTENT_THRESHOLDS) : undefined;



var $69aHU = parcelRequire("69aHU");


var $6s78L = parcelRequire("6s78L");

function $fea184a73c848235$var$_defineProperty(e, r, t) {
    return (r = $fea184a73c848235$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fea184a73c848235$var$_toPropertyKey(t) {
    var i = $fea184a73c848235$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fea184a73c848235$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fea184a73c848235$var$borderWidthYellowToken = "var(--ds-border-width-selected, 2px)";
const $fea184a73c848235$var$inlineCommentStylesCompiledTokenized = null;
const $fea184a73c848235$var$inlineCommentStylesCompiledLegacy = null; // ADS migration: wrapper gated by confluence_frontend_tokenize_border (COMMENTS-6463)
const $fea184a73c848235$var$InlineCommentWrapperLegacy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        ...props,
        className: (0, $gMc0m.default)([
            "_1l8y1vck _1dl4kb7n _js1815vq _7cal15vq _uvvh15vq _1j7g15vq _1ms4ysn8 _1kcxysn8 _1mo87mnp _ns0l7mnp _ekpmt94y _wnmjt94y _119fstnw _19sjstnw _12bk1q9c _7hvd1q9c _8gwlt94y _1grmt94y _1d8v277m _c7b9277m _3rap8y3s _15xb130s _1wwitlke _1x0s1773 _qm06avcr _1rlolxrw _ko0y277m _igj38y3s _lft0130s"
        ])
    }));
$fea184a73c848235$var$InlineCommentWrapperLegacy.displayName = 'InlineCommentWrapperLegacy';
const $fea184a73c848235$var$InlineCommentWrapperTokenized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        ...props,
        className: (0, $gMc0m.default)([
            "_1l8y1vck _1dl4kb7n _js1815vq _7cal15vq _uvvh15vq _1j7g15vq _1ms4ysn8 _1kcxysn8 _1mo87mnp _ns0l7mnp _ekpmt94y _wnmjt94y _119fstnw _19sjstnw _12bk1q9c _7hvd1q9c _8gwlt94y _1grmt94y _1d8v1i04 _c7b91i04 _3rap8y3s _15xb130s _1wwitlke _1x0s1773 _qm06avcr _1rlolxrw _ko0y1i04 _igj38y3s _lft0130s"
        ])
    }));
$fea184a73c848235$var$InlineCommentWrapperTokenized.displayName = 'InlineCommentWrapperTokenized';
const $fea184a73c848235$var$InlineCommentWrapper = (0, $3yh4a.componentWithFG)('confluence_frontend_tokenize_border', $fea184a73c848235$var$InlineCommentWrapperTokenized, $fea184a73c848235$var$InlineCommentWrapperLegacy);
const $fea184a73c848235$var$styles = {
    renderContentButton: "_bfhksm61 _1bsb1osq"
};
const $fea184a73c848235$var$_RERENDER_STATE_NONE = '';
const $fea184a73c848235$var$_RERENDER_STATE_REQUESTED = 'requested';
class $fea184a73c848235$var$RendererComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { adf: adf, sessionData: sessionData, contentType: contentType } = this.props;
        if (adf && sessionData?.isLicensed) (0, $edEsl.registerGlobalMediaViewedListener)({
            contentType: contentType
        });
        (0, $fySJw.getConnectDataListener)().init({
            emit: (localId, data)=>this.state.referentialityDataSourceProvider.createOrUpdate(localId, data)
        });
        const taskBatcher = new (0, $gxhb8.TaskBatcher)((0, $6mKj3.expVal)('confluence_frontend_task_batching_interval', 'value', 3000));
        taskBatcher.onFlush(this._onBatchTaskUpdate);
        this.setState({
            taskBatcher: taskBatcher
        });
    }
    /**
   * Needed to force an update of Atlaskit Renderer to wake-up TWP code inside that opens expand based on hash in the case where it hasn't changed.
   * The alternative of using getDerivedStateFromProps required multiple steps which didn't work with RTL testing.
   * Settled on normally discouraged setState inside of componentDidUpdate with an eslint-disable to get through Bamboo.
   */ /**
   * When the objectId of the renderer changes, we want to reset the `shouldFetchContent` state variable so we don't
   * cause unnecessary refetches; Calling setState behind a condition that will only happen on page transitions
   */ componentDidUpdate(prevProps) {
        const { objectId: objectId } = this.props;
        const { rerender: rerender } = this.state;
        if (rerender === $fea184a73c848235$var$_RERENDER_STATE_REQUESTED) // eslint-disable-next-line
        this.setState({
            rerender: $fea184a73c848235$var$_RERENDER_STATE_NONE
        });
        if (objectId !== prevProps.objectId) // eslint-disable-next-line
        this.setState({
            shouldRefetchContent: false
        });
    }
    componentWillUnmount() {
        const { adf: adf, sessionData: sessionData } = this.props;
        if (adf && sessionData?.isLicensed) (0, $edEsl.removeGlobalMediaViewedListener)();
    }
    render() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).performance.mark('CFP-63.view.page.classic.renderer.rendered');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            const dataProviders = this.getProviders(flags);
            return this.renderRenderer(this.getExtensionHandlers(false), dataProviders);
        });
    }
    constructor(...args){
        super(...args);
        $fea184a73c848235$var$_defineProperty(this, "state", {
            _root: undefined,
            rerender: $fea184a73c848235$var$_RERENDER_STATE_NONE,
            referentialityDataSourceProvider: new (0, $1cgiE.DataSourceProvider)(),
            taskBatcher: undefined,
            shouldRefetchContent: false
        });
        $fea184a73c848235$var$_defineProperty(this, "_handleActionToggle", (objectKey, state)=>{
            // add the task action to be batched/updated in the batch before firing the request
            this.state.taskBatcher?.add({
                objectKey: objectKey,
                state: state
            });
        });
        $fea184a73c848235$var$_defineProperty(this, "_onBatchTaskUpdate", (batch)=>{
            const { objectId: objectId, isPreviewMode: isPreviewMode } = this.props;
            const updateBatch = batch.map((update)=>{
                const { objectKey: objectKey, state: state } = update;
                const status = state === 'DONE' ? 'CHECKED' : 'UNCHECKED';
                return {
                    taskId: objectKey.localId,
                    status: status
                };
            });
            const taskBatch = {
                contentId: objectId,
                tasks: updateBatch,
                trigger: 'VIEW_PAGE'
            };
            if (!isPreviewMode) (0, $6s78L.mutateInterop)({
                mutation: (0, $eXfot.SetBatchedTaskStatusMutation),
                variables: taskBatch,
                __callerPackage__: "@confluence-classic/confluence-fabric-editor"
            }).then(()=>{
                this.setState({
                    shouldRefetchContent: true
                });
            }).catch((error)=>{
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        source: 'page',
                        action: 'batchTaskUpdate',
                        actionSubject: 'checkbox',
                        attributes: {
                            error: error.message || String(error),
                            stack: error.stack
                        }
                    });
                });
            });
        });
        $fea184a73c848235$var$_defineProperty(this, "_handleProfileCardActions", (userId)=>{
            const { push: push } = this.props;
            const atlassianPeopleProfileUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, null, (0, $jlIaF.CONTEXT_PATH));
            return [
                {
                    label: this.props.intl.formatMessage({
                        id: "view.profile"
                    }),
                    link: atlassianPeopleProfileUrl,
                    callback: ()=>{
                        push((0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, null, (0, $jlIaF.CONTEXT_PATH)));
                    }
                }
            ];
        });
        $fea184a73c848235$var$_defineProperty(this, "getExpandHash", ()=>{
            if (this.state.rerender === $fea184a73c848235$var$_RERENDER_STATE_REQUESTED) return '';
            else return this.props.getHash();
        });
        $fea184a73c848235$var$_defineProperty(this, "getExtensionHandlers", (shouldIncludeMacroHandlers)=>{
            const { adf: adf, objectId: objectId, spaceKey: spaceKey, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, appearance: appearance, isPreviewMode: isPreviewMode = false } = this.props;
            const { referentialityDataSourceProvider: referentialityDataSourceProvider } = this.state;
            return (0, $k77lQ.getExtensionHandlers)({
                adf: adf,
                contentId: objectId,
                appearance: appearance,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview,
                showTemplateInputInPreview: showTemplateInputInPreview,
                spaceKey: spaceKey,
                shouldIncludeMacroHandlers: shouldIncludeMacroHandlers,
                shouldIncludeMacroWithReferencesHandlers: true,
                referentialityDataSourceProvider: referentialityDataSourceProvider,
                fromFabricEditor: true,
                isPreviewMode: isPreviewMode
            });
        });
        $fea184a73c848235$var$_defineProperty(this, "getEventHandlers", ()=>{
            const { matchRoute: matchRoute, push: push } = this.props;
            return {
                ...(0, $lmNXu.createSmartCardEventHandler)({
                    matchRoute: matchRoute,
                    push: push
                })
            };
        });
        $fea184a73c848235$var$_defineProperty(this, "_setRoot", (ref)=>this.setState({
                _root: ref
            })); /* getting type issues with ProfilecardProvider in atlaskit with ProfileCardProvider from next.
           This helps resolve the type errors */ 
        $fea184a73c848235$var$_defineProperty(this, "getProfilecardProvider", (cloudId, getActions, featureFlags)=>{
            return (0, $9UKrO.getProfileCardProvider)(cloudId, getActions, featureFlags);
        });
        $fea184a73c848235$var$_defineProperty(this, "getProviders", (0, $2XqLN.default)((flags)=>{
            const { intl: intl, accountId: accountId, contentType: contentType, cloudId: cloudId, environment: environment, objectId: objectId, spaceKey: spaceKey, isExternalShareRequest: isExternalShareRequest, sessionData: sessionData, showTemplateInputInPreview: showTemplateInputInPreview, showTemplateVariablesInPreview: showTemplateVariablesInPreview, openCoreInvites: openCoreInvites, userRole: userRole, mediaToken: mediaToken, shareToken: shareToken } = this.props;
            const { featureFlags: featureFlags, activationId: activationId } = sessionData;
            const isTemplateMedia = showTemplateVariablesInPreview || showTemplateInputInPreview;
            const mediaProvider = isTemplateMedia ? (0, $c4QoG.createRendererTemplateMediaProvider)({
                spaceKey: spaceKey,
                templateIds: [
                    objectId
                ]
            }) : (0, $4IoVL.createRendererMediaProvider)({
                contentId: objectId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShareRequest,
                mediaToken: mediaToken,
                shareToken: shareToken
            });
            const providerFactory = (0, $4FxUL.default).create({
                mediaProvider: mediaProvider,
                taskDecisionProvider: Promise.resolve(new (0, $3WO8q.ConfluenceTaskDecisionProvider)(intl, flags, objectId, this._handleActionToggle)),
                cardProvider: Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)())
            });
            if (cloudId && accountId) providerFactory.setProvider('mentionProvider', (0, $dtVue.createMentionsConfig)(cloudId, accountId, undefined, undefined, openCoreInvites, userRole).then((config)=>config.mentionResource).catch((err)=>{
                return Promise.reject();
            }));
            const hasAccess = sessionData?.accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || sessionData?.accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
            if (cloudId) providerFactory.setProvider('emojiProvider', (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
                cloudId: cloudId,
                userId: accountId,
                allowAnonymousAccess: true
            }));
            if (cloudId && hasAccess) // If global view user profile is enabled then user can view profile card
            // Making promise void as in the worst case the
            (0, $2d2df6655155416b$export$60b2889c65284218)().then((hasViewUserProfilePermission)=>{
                if (hasViewUserProfilePermission) providerFactory.setProvider('profilecardProvider', this.getProfilecardProvider(cloudId, this._handleProfileCardActions, featureFlags));
            });
            if (isTemplateMedia) {
                const contextIdentifierProvider = async ()=>{
                    const templateObjectId = JSON.stringify({
                        templateId: objectId,
                        spaceKey: spaceKey
                    });
                    return Promise.resolve({
                        containerId: spaceKey || '',
                        objectId: templateObjectId,
                        product: 'confluence'
                    });
                };
                providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider());
            } else if (spaceKey) providerFactory.setProvider('contextIdentifierProvider', Promise.resolve({
                containerId: spaceKey,
                objectId: objectId,
                product: 'confluence'
            }));
            (0, $69aHU.populateExtensionProviders)(providerFactory, {
                intl: intl,
                contentId: objectId,
                containerId: spaceKey || '',
                accountId: accountId,
                cloudId: cloudId,
                spaceKey: spaceKey,
                contentType: contentType,
                environment: environment,
                featureFlags: featureFlags,
                extensionHandlers: this.getExtensionHandlers(true),
                showTemplateInputInPreview: showTemplateInputInPreview,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview,
                activationId: activationId
            });
            return providerFactory;
        }));
        $fea184a73c848235$var$_defineProperty(this, "decodeHash", (hash)=>{
            let decodedHash = '';
            try {
                // try to decode the hash
                decodedHash = decodeURIComponent(hash);
            } catch  {
                // if hash is not encoded, it will throw a URI Malformed error,
                // which we will then return the original hash
                decodedHash = hash;
            }
            return decodedHash;
        });
        $fea184a73c848235$var$_defineProperty(this, "handleClicksInRenderer", (event)=>{
            /**
       * Covering a corner case:
       * If the user
       * - has followed a deep link to a header inside an expand
       * - then closes that expand
       * - then clicks a TOC link to the same header
       * the renderer code will not see a change in the deep link has, so it won't run which leaves the user scrolled
       * to a closed expand element.
       * This code detects the above situation and sets the rerender state property to begin a double re-render of the
       * renderer (once with no hash and once with the original hash). This lets the renderer code see a change so it
       * opens the expand.
       */ const deepLinkHash = event.target.hash;
            if (deepLinkHash === `#${this.getExpandHash()}`) {
                const tocTarget = document.getElementById(this.decodeHash(this.getExpandHash()));
                if (tocTarget) {
                    const expandParent = tocTarget.closest("[data-node-type='expand']"); // If the TOC link points to a header inside a closed expand
                    if (expandParent && expandParent.getAttribute('data-expanded') === 'false') this.setState({
                        rerender: $fea184a73c848235$var$_RERENDER_STATE_REQUESTED
                    });
                }
            }
        });
        $fea184a73c848235$var$_defineProperty(this, "renderRenderer", (extensionHandlers, dataProviders)=>{
            const { adf: adf, id: id, className: className, style: style, allowInlineComments: allowInlineComments, ignoreHeadingAnchorLinksFeatureFlag: ignoreHeadingAnchorLinksFeatureFlag, renderWhenReady: renderWhenReady, onComplete: onComplete, objectId: objectId, sessionData: sessionData, allowPlaceholderText: allowPlaceholderText = false, annotationProvider: annotationProvider, allowAnnotations: allowAnnotations = false, UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment = true, UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing = true, spaceKey: spaceKey, isExternalShareRequest: isExternalShareRequest, mediaToken: mediaToken } = this.props;
            const { shouldRefetchContent: shouldRefetchContent } = this.state;
            if (!adf) return null;
             // Allow disabling the feature for previews.
            const allowHeadingAnchorLinks = !ignoreHeadingAnchorLinksFeatureFlag;
            const { offsetTop: offsetTop } = this.props;
            const stickyHeaders = offsetTop !== undefined && {
                offsetTop: offsetTop
            };
            const { featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled } = sessionData; // used for renderer's annotation provider
            const localRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
            const shouldSSRsmartLinks = (0, $i6Ps3.isPageSSRd)() && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
            const mediaSSR = (0, $iP9x4.getMediaSSRModeAndAuthConfigMemoized)({
                contentId: objectId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShareRequest,
                mediaToken: mediaToken
            });
            const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1SPMi.RendererAnalyticsListener), {
                objectId: objectId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $habRv.WithAnnotationsWrapper), {
                annotationProvider: annotationProvider,
                rendererRef: localRef,
                adfDocument: this.props.navigationPolicy?.shimAdfUrls(adf) ?? adf,
                updateDocument: ()=>{},
                isNestedRender: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
                appearance: this.props.appearance,
                contentMode: this.props.contentMode,
                document: this.props.navigationPolicy?.shimAdfUrls(adf) ?? adf,
                adfStage: "stage0",
                dataProviders: dataProviders,
                eventHandlers: this.getEventHandlers(),
                extensionHandlers: extensionHandlers,
                featureFlags: {},
                portal: this.state._root,
                onComplete: onComplete,
                allowColumnSorting: true,
                allowHeadingAnchorLinks: {
                    allowNestedHeaderLinks: allowHeadingAnchorLinks,
                    activeHeadingId: this.decodeHash(this.getExpandHash())
                },
                allowAltTextOnImages: true,
                media: {
                    allowLinking: true,
                    allowCaptions: true,
                    featureFlags: (0, $kBU5m.getMediaFeatureFlags)(featureFlags),
                    ...(0, $6mKj3.expVal)('confluence_frontend_fix_macro_media_flickering', 'isEnabled', false) ? {
                        ssr: mediaSSR
                    } : {}
                },
                stickyHeaders: stickyHeaders,
                useSpecBasedValidator: true,
                allowCopyToClipboard: true,
                allowWrapCodeBlock: true,
                analyticsEventSeverityTracking: (0, $fyKZ5.ANALYTICS_EVENT_SEVERITY_TRACKING),
                allowSelectAllTrap: true,
                unsupportedContentLevelsTracking: (0, $1312f8b4a0711d1a$export$58eac04eb6213951)(),
                allowPlaceholderText: allowPlaceholderText,
                allowCustomPanels: true,
                smartLinks: {
                    hideHoverPreview: false,
                    ssr: shouldSSRsmartLinks
                },
                allowAnnotations: allowAnnotations,
                annotationProvider: annotationProvider,
                UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment,
                UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing
            })));
            const rendererContent = (0, $9wGTI.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                xcss: $fea184a73c848235$var$styles.renderContentButton,
                onClick: this.handleClicksInRenderer
            }, content) : // eslint-disable-next-line
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                onClick: this.handleClicksInRenderer
            }, content);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fea184a73c848235$var$InlineCommentWrapper, {
                id: id,
                "data-inline-comments-target": allowInlineComments ? 'true' : 'false',
                className: className,
                ref: this._setRoot,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    ...style,
                    '--content-renderer-inline-comment-marker-start': this.props.intl.formatMessage(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $5dnlf.messages).contentRendererInlineCommentMarkerStart),
                    '--content-renderer-inline-comment-marker-end': this.props.intl.formatMessage(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $5dnlf.messages).contentRendererInlineCommentMarkerEnd)
                },
                "data-test-appearance": this.props.appearance
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
                ...(0, $kLzei.getSmartCardRenderers)(),
                isAdminHubAIEnabled: isAdminHubAIEnabled
            }, rendererContent), renderWhenReady && renderWhenReady(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgQGl.ContentRefetchHandler), (0, $gCz4s.getContentRefetchHandlerProps)({
                contentId: objectId,
                shouldRefetch: shouldRefetchContent,
                updateShouldRefetchContent: this.setState,
                updateShouldRefetchContentContext: this
            })));
        });
    }
}
const $fea184a73c848235$export$7a850de5bcc76388 = (0, $aXWIB.injectIntl)((0, $3Btfb.withNavigationPolicy)($fea184a73c848235$var$RendererComponent));
class $fea184a73c848235$var$RendererComponentWithBanner extends (0, $42omo.PureComponent) {
    render() {
        const { allowStickyHeaders: allowStickyHeaders } = this.props;
        if (allowStickyHeaders === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fea184a73c848235$export$7a850de5bcc76388, this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $hrAmX.BannerStateContainer),
                (0, $1a6Dn.FloatingBannerStateContainer)
            ]
        }, (bannerState, floatingBanners)=>{
            const offsetTop = bannerState.getTotalHeight() + floatingBanners.getFloatingHeight();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fea184a73c848235$export$7a850de5bcc76388, {
                offsetTop: offsetTop,
                ...this.props
            });
        });
    }
}
var $fea184a73c848235$export$2e2bcd8739ae039 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})((0, $2e0df58e89030dfc$export$c5356dc8cba0700d)((0, $134fa45286a9b1d7$export$adde0c9097009696)((0, $f0NfR.withSessionData)((0, $gXsSh.withRoutesContext)($fea184a73c848235$var$RendererComponentWithBanner)))));


var $23c487fbdabb1bfd$export$2e2bcd8739ae039 = (props)=>{
    const { userId: userId, cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fea184a73c848235$export$2e2bcd8739ae039), {
        ...props,
        accountId: userId,
        cloudId: cloudId,
        environment: environment
    });
};

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("8YePs", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("kLzei", function(module, exports) {
/* getSmartCardRenderers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $5spQU = parcelRequire("5spQU");


var $i5WUp = parcelRequire("i5WUp");


var $di8q4 = parcelRequire("di8q4");


var $9wGTI = parcelRequire("9wGTI");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $1431e51c33a3f61c$var$emojiWrapperStyles = null;
const $1431e51c33a3f61c$var$SmartCardEmojiWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1o8l _1bah1h6o _1ul97vkz"
        ])
    }, children); // Custom render wrapper for AISnippet providing session data
const $1431e51c33a3f61c$var$AISnippetRenderer = (props)=>{
    const { displayName: displayName, userId: userId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isAIFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    if (!isAdminHubAIEnabled || !isAIFeatureEnabled || !(0, $6mKj3.expVal)('confluence-ai-linking-ai-snippets', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i5WUp.AISnippetWithRelayEnvironment), {
        ...props,
        userId: userId ?? undefined,
        displayName: displayName ?? undefined
    });
};
const $1431e51c33a3f61c$export$61bc672a900b57f = (0, $2XqLN.default)(()=>({
        renderers: {
            emoji: (emojiId, _parentComponent = 'SmartCard', contentType = 'page')=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                        value: sessionData
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                        emoji: emojiId,
                        height: 16,
                        context: "smartCard",
                        wrapper: $1431e51c33a3f61c$var$SmartCardEmojiWrapper,
                        contentType: contentType
                    }))),
            snippet: (0, $9wGTI.fg)('cc-ai-snippet-renderer-gate') ? $1431e51c33a3f61c$var$AISnippetRenderer : undefined
        }
    }));
module.exports["getSmartCardRenderers"] = $1431e51c33a3f61c$export$61bc672a900b57f;

});

parcelRegister("i5WUp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $9Rf00 = parcelRequire("9Rf00");

var $au4KV = parcelRequire("au4KV");


var $gWF6I = parcelRequire("gWF6I");


var $9NDUe = parcelRequire("9NDUe");

var $2Gu9D = parcelRequire("2Gu9D");


var $in8wv = parcelRequire("in8wv");


var $kt1Xc = parcelRequire("kt1Xc");


var $2UyBL = parcelRequire("2UyBL");

const $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $990b0c00f1a7800f$var$DEFAULT_MAX_LINES = 4;
const $990b0c00f1a7800f$var$styles = {
    container: "_11c8wadc"
};
const $990b0c00f1a7800f$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $990b0c00f1a7800f$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $990b0c00f1a7800f$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $42omo.createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: $990b0c00f1a7800f$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $42omo.createElement($990b0c00f1a7800f$export$ac90160f7ae1e32f, props));
};
const $990b0c00f1a7800f$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $990b0c00f1a7800f$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $irOoi.useQueryLoader)((0, $2UyBL.default));
    const isLoadingRef = (0, $42omo.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $2Gu9D.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $990b0c00f1a7800f$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $dh538.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $42omo.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $42omo.createElement((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ $42omo.createElement((0, $in8wv.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($990b0c00f1a7800f$var$styles.container)
    }, /*#__PURE__*/ $42omo.createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ $42omo.createElement((0, $au4KV.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $42omo.createElement((0, $kt1Xc.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $42omo.createElement((0, $au4KV.AIStreamLoading), null))));
    return /*#__PURE__*/ $42omo.createElement((0, $dpPtd.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $42omo.createElement((0, $9Rf00.AIFeedbackPropertiesProvider), {
        entrypointId: $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $990b0c00f1a7800f$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $42omo.createElement((0, $gWF6I.RelayEnvironmentProvider), null, /*#__PURE__*/ $42omo.createElement($990b0c00f1a7800f$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $990b0c00f1a7800f$export$c9a07cebec67e951;

});

parcelRegister("dpPtd", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
const $c997cd3fd9f4ee84$export$2879604e6aec4ab = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $c997cd3fd9f4ee84$export$a4270ab432ac8a58 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $frIzR.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$var$FlagContext.Provider, {
            value: api
        }, children);
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($c997cd3fd9f4ee84$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent
        }, t5);
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t4, t6);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag_1)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
        const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagType, {
            ...restProps,
            key: flag_1.id
        });
    })));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $c997cd3fd9f4ee84$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$export$a4270ab432ac8a58, null, fn());
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("2Rith", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("ifW2H", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $62e0541727c97e34$export$4f059feb37b5835e = (0, $42omo.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $62e0541727c97e34$export$4f059feb37b5835e;

});

parcelRegister("8Y3mE", function(module, exports) {

var $ea2ui = parcelRequire("ea2ui");

const $a544c5804dc19870$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $ea2ui.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $a544c5804dc19870$export$5013b36eeed4ec19;

});

parcelRegister("ea2ui", function(module, exports) {
var $5a6bb3bf0e14987c$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $5a6bb3bf0e14987c$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $5a6bb3bf0e14987c$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $5a6bb3bf0e14987c$export$7052d5b66e36f60f;

});

parcelRegister("j4EkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kTkuM = parcelRequire("kTkuM");


var $a4NM6 = parcelRequire("a4NM6");


var $ea2ui = parcelRequire("ea2ui");

const $a4ec83494ea42b83$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $42omo.useRef)(undefined);
    const aiSessionStateRef = (0, $42omo.useRef)((0, $ea2ui.AISessionState).unset);
    const setAISessionState = (0, $42omo.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $42omo.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $42omo.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $kTkuM.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $a4NM6.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $42omo.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $a4NM6.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $a4ec83494ea42b83$export$259576f4e7ac6488;

});

parcelRegister("kTkuM", function(module, exports) {

var $dWJ5i = parcelRequire("dWJ5i");


var $cUcZ5 = parcelRequire("cUcZ5");

function $9779584a42635fbf$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $dWJ5i.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
}
module.exports["getNewSingleInstrumentationID"] = $9779584a42635fbf$export$cee2a1482be61648;

});

parcelRegister("dWJ5i", function(module, exports) {
const $a273a9fd41301c8f$var$t = Symbol.for("@ts-pattern/matcher"), $a273a9fd41301c8f$var$e = Symbol.for("@ts-pattern/isVariadic"), $a273a9fd41301c8f$var$n = "@ts-pattern/anonymous-select-key", $a273a9fd41301c8f$var$r = (t)=>Boolean(t && "object" == typeof t), $a273a9fd41301c8f$var$i = (e)=>e && !!e[$a273a9fd41301c8f$var$t], $a273a9fd41301c8f$var$o = (n, s, c)=>{
    if ($a273a9fd41301c8f$var$i(n)) {
        const e = n[$a273a9fd41301c8f$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($a273a9fd41301c8f$var$r(n)) {
        if (!$a273a9fd41301c8f$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $a273a9fd41301c8f$var$i(s) && s[$a273a9fd41301c8f$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$a273a9fd41301c8f$var$o(t, e[n], c)) && r.every((t, e)=>$a273a9fd41301c8f$var$o(t, n[e], c)) && (0 === a.length || $a273a9fd41301c8f$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$a273a9fd41301c8f$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $a273a9fd41301c8f$var$i(a = r) && "optional" === a[$a273a9fd41301c8f$var$t]().matcherType) && $a273a9fd41301c8f$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $a273a9fd41301c8f$var$s = (e)=>{
    var n, o, a;
    return $a273a9fd41301c8f$var$r(e) ? $a273a9fd41301c8f$var$i(e) ? null != (n = null == (o = (a = e[$a273a9fd41301c8f$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s) : $a273a9fd41301c8f$var$c(Object.values(e), $a273a9fd41301c8f$var$s) : [];
}, $a273a9fd41301c8f$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $a273a9fd41301c8f$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$a273a9fd41301c8f$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $a273a9fd41301c8f$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $a273a9fd41301c8f$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$a273a9fd41301c8f$var$l(t),
        and: (e)=>$a273a9fd41301c8f$var$m(t, e),
        or: (e)=>$a273a9fd41301c8f$var$d(t, e),
        select: (e)=>void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t)
    });
}
function $a273a9fd41301c8f$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$a273a9fd41301c8f$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$a273a9fd41301c8f$var$h($a273a9fd41301c8f$var$l(t)),
        select: (e)=>$a273a9fd41301c8f$var$h(void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t))
    });
}
function $a273a9fd41301c8f$var$l(e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($a273a9fd41301c8f$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $a273a9fd41301c8f$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$s(e),
                matcherType: "optional"
            })
    });
}
const $a273a9fd41301c8f$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $a273a9fd41301c8f$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $a273a9fd41301c8f$var$m(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "and"
            })
    });
}
function $a273a9fd41301c8f$var$d(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "or"
            })
    });
}
function $a273a9fd41301c8f$var$p(e) {
    return {
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $a273a9fd41301c8f$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $a273a9fd41301c8f$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $a273a9fd41301c8f$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $a273a9fd41301c8f$var$n
                    ].concat(void 0 === i ? [] : $a273a9fd41301c8f$var$s(i))
            })
    });
}
function $a273a9fd41301c8f$var$v(t) {
    return "number" == typeof t;
}
function $a273a9fd41301c8f$var$b(t) {
    return "string" == typeof t;
}
function $a273a9fd41301c8f$var$w(t) {
    return "bigint" == typeof t;
}
const $a273a9fd41301c8f$var$S = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return !0;
})), $a273a9fd41301c8f$var$O = $a273a9fd41301c8f$var$S, $a273a9fd41301c8f$var$j = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length >= t))(e))),
        length: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && Boolean(t.match(n))))));
        }
    }), $a273a9fd41301c8f$var$K = $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$b)), $a273a9fd41301c8f$var$x = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e >= t))(e))),
        int: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t < 0)))
    }), $a273a9fd41301c8f$var$E = $a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$v)), $a273a9fd41301c8f$var$A = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e >= t))(e))),
        positive: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t < 0)))
    }), $a273a9fd41301c8f$var$P = $a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$w)), $a273a9fd41301c8f$var$T = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "boolean" == typeof t;
})), $a273a9fd41301c8f$var$B = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "symbol" == typeof t;
})), $a273a9fd41301c8f$var$_ = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null == t;
})), $a273a9fd41301c8f$var$k = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null != t;
}));
var $a273a9fd41301c8f$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $a273a9fd41301c8f$var$t,
    optional: $a273a9fd41301c8f$var$l,
    array: function(...e) {
        return $a273a9fd41301c8f$var$h({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $a273a9fd41301c8f$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$a273a9fd41301c8f$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $a273a9fd41301c8f$var$f(t, (t)=>$a273a9fd41301c8f$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $a273a9fd41301c8f$var$g(t, (t, e)=>{
                                const n = $a273a9fd41301c8f$var$o(s, e, r), i = $a273a9fd41301c8f$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$a273a9fd41301c8f$var$s(e[0]),
                            ...$a273a9fd41301c8f$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $a273a9fd41301c8f$var$m,
    union: $a273a9fd41301c8f$var$d,
    not: function(e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$a273a9fd41301c8f$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $a273a9fd41301c8f$var$p,
    select: $a273a9fd41301c8f$var$y,
    any: $a273a9fd41301c8f$var$S,
    _: $a273a9fd41301c8f$var$O,
    string: $a273a9fd41301c8f$var$K,
    number: $a273a9fd41301c8f$var$E,
    bigint: $a273a9fd41301c8f$var$P,
    boolean: $a273a9fd41301c8f$var$T,
    symbol: $a273a9fd41301c8f$var$B,
    nullish: $a273a9fd41301c8f$var$_,
    nonNullable: $a273a9fd41301c8f$var$k,
    instanceOf: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p($a273a9fd41301c8f$export$ce1e7a33533a73d9(t)));
    }
};
class $a273a9fd41301c8f$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $a273a9fd41301c8f$var$$ = {
    matched: !1,
    value: void 0
};
function $a273a9fd41301c8f$export$4659b591c19bdf3d(t) {
    return new $a273a9fd41301c8f$var$I(t, $a273a9fd41301c8f$var$$);
}
class $a273a9fd41301c8f$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$a273a9fd41301c8f$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $a273a9fd41301c8f$var$$ : {
            matched: !0,
            value: e(s ? $a273a9fd41301c8f$var$n in c ? c[$a273a9fd41301c8f$var$n] : c : this.input, this.input)
        };
        return new $a273a9fd41301c8f$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $a273a9fd41301c8f$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $a273a9fd41301c8f$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $a273a9fd41301c8f$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $a273a9fd41301c8f$var$L(t) {
    throw new $a273a9fd41301c8f$export$6c1467edb54d3773(t);
}
module.exports["P"] = $a273a9fd41301c8f$export$56c0d5a1e737357d;
module.exports["match"] = $a273a9fd41301c8f$export$4659b591c19bdf3d;

});

parcelRegister("a4NM6", function(module, exports) {

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

const $2674cc9dba61bfc1$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $2674cc9dba61bfc1$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $2674cc9dba61bfc1$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $eGd7K.setCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $2674cc9dba61bfc1$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $hEbxW.getCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $2674cc9dba61bfc1$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$d6fb1caea334c7c7;

});

parcelRegister("fYQcF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");

parcelRequire("3pfAb");
var $k7eoe = parcelRequire("k7eoe");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $1M9Av = parcelRequire("1M9Av");


var $ea2ui = parcelRequire("ea2ui");


var $j4EkW = parcelRequire("j4EkW");

const $a22fd04a8888d493$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $42omo.useContext)((0, $ifW2H.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $42omo.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $j4EkW.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $42omo.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $dWJ5i.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $ea2ui.AISessionState).unset,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).viewed, (0, $ea2ui.AISessionState).error, (0, $ea2ui.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $ea2ui.AISessionState).initiated,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).submitted, (0, $ea2ui.AISessionState).actioned, (0, $ea2ui.AISessionState).adopted, (0, $ea2ui.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $k7eoe.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $42omo.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $dWJ5i.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $1M9Av.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $42omo.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $42omo.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $42omo.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    // Each `useCallback` above depends on `createAndMergeEventPayload`, which in
    // turn closes over per-render config values (e.g. `additionalAttributes`
    // passed via `customConfig`). When callers spread fresh literals on every
    // render, those callbacks get fresh identities every render too. Consumers
    // that feed them into their own `useCallback` / `useEffect` deps then suffer
    // spurious re-runs — and combined with functional state updaters, this can
    // drive infinite render loops (see Jira CRCS-4870 / OOM regression).
    //
    // Stabilise the entire return surface behind a feature gate.
    const stableReturn = $a22fd04a8888d493$var$useStableMethods(baseReturn);
    return (0, $dh538.fg)('platform_ai_analytics_stable_handler_refs') ? stableReturn : baseReturn;
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a22fd04a8888d493$var$useStableMethods(methods) {
    const ref = (0, $42omo.useRef)(methods);
    ref.current = methods;
    return (0, $42omo.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a22fd04a8888d493$export$ddf49ad062368ad2;

});

parcelRegister("3pfAb", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("k7eoe")).FabricChannel);

var $7l88B = parcelRequire("7l88B");


var $cCg1W = parcelRequire("cCg1W");


var $k7eoe = parcelRequire("k7eoe");


});

parcelRegister("1M9Av", function(module, exports) {
const $699df07a7cf548d4$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $699df07a7cf548d4$export$e053e424fcbfebe9;

});

parcelRegister("9Rf00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $a07f007de41f1483$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $a07f007de41f1483$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $aXWIB.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a07f007de41f1483$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $a07f007de41f1483$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $42omo.useContext)($a07f007de41f1483$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $a07f007de41f1483$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $a07f007de41f1483$export$ff3deb4415ee32e3;

});

parcelRegister("au4KV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $aXWIB.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const title = titleMessage ?? $fe7ceaa3509ef4fa$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $igbBp.GeneratingStreamAnimation), {
        alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $42omo = parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("2Gu9D", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

const $b5fd5f50ef335781$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $42omo.useRef)(new (0, $5aVN7.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $42omo.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $42omo.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $42omo.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $b5fd5f50ef335781$export$fade2d05a6320d49;

});

parcelRegister("in8wv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $e6pbP = parcelRequire("e6pbP");


var $c6GJD = parcelRequire("c6GJD");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $fYQcF = parcelRequire("fYQcF");


var $aFC6o = parcelRequire("aFC6o");

var $iuafG = parcelRequire("iuafG");

var $aXh2V = parcelRequire("aXh2V");


var $fXbFR = parcelRequire("fXbFR");

const $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $b015c3cc5e677900$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $b015c3cc5e677900$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $42omo.useRef)(text);
    const isExperimentEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $42omo.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aFC6o.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6pbP.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $b015c3cc5e677900$var$sanitizeMarkdown(text || '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6pbP.default), null, text || '') : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iuafG.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXh2V.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
    })));
};
module.exports["AISnippetContent"] = $b015c3cc5e677900$export$3cf37822a11d3ff3;

});

parcelRegister("aFC6o", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $eLAh6 = parcelRequire("eLAh6");

const $902b2990c09c9892$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $902b2990c09c9892$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $eLAh6.i18n).rovoAwarenessMessage,
        define: (0, $eLAh6.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($902b2990c09c9892$var$styles.text)
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.RovoIcon), {
        size: "xxsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $902b2990c09c9892$export$fde99ed387d90f1;

});

parcelRegister("eLAh6", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8e99185ad20025a1$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $8e99185ad20025a1$export$a7357cdd1f0b0168;

});

parcelRegister("iuafG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $fSglY = parcelRequire("fSglY");

const $8fdbd961e8c69c33$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $8fdbd961e8c69c33$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $8fdbd961e8c69c33$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $fSglY.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
        appearance: "subtle",
        href: $8fdbd961e8c69c33$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8fdbd961e8c69c33$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $8fdbd961e8c69c33$export$e0542ba0c737fe5c;

});

parcelRegister("fSglY", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168;

});

parcelRegister("aXh2V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $biiXa = parcelRequire("biiXa");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $9Rf00 = parcelRequire("9Rf00");


var $aFwxm = parcelRequire("aFwxm");

const $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $00b0d3bf57a2c2c6$var$i18n = (0, $aXWIB.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $00b0d3bf57a2c2c6$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink));
const $00b0d3bf57a2c2c6$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $00b0d3bf57a2c2c6$var$i18n.researchGroupLink));
const $00b0d3bf57a2c2c6$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$00b0d3bf57a2c2c6$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00b0d3bf57a2c2c6$var$PrivacyPolicyLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $dh538.fg)('product-terminology-refresh') ? $00b0d3bf57a2c2c6$var$i18n.improveAtlassianTextAppify : $00b0d3bf57a2c2c6$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00b0d3bf57a2c2c6$var$ResearchGroupLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS = (0, $ecnYn.xcss)({
    transform: 'rotate(180deg)'
});
const $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $00b0d3bf57a2c2c6$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $42omo.useState)(false);
    const feedbackCollectorProperties = (0, $9Rf00.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $42omo.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagTitle),
            description: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aFwxm.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aFwxm.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00b0d3bf57a2c2c6$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($00b0d3bf57a2c2c6$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $00b0d3bf57a2c2c6$export$f9f34317e5bc3551;

});

parcelRegister("aFwxm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9FnLD = parcelRequire("9FnLD");

const $321f16821ba8d88a$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $321f16821ba8d88a$export$ec2ba0e929740f73;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("kt1Xc", function(module, exports) {

var $2UyBL = parcelRequire("2UyBL");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $9Rf00 = parcelRequire("9Rf00");


var $in8wv = parcelRequire("in8wv");

const $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $45557925e309956a$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $irOoi.usePreloadedQuery)((0, $2UyBL.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $42omo.createElement((0, $in8wv.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $dh538.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $42omo.createElement((0, $9Rf00.AIFeedbackPropertiesProvider), {
        entrypointId: $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $45557925e309956a$export$f50b64530422ea99;

});

parcelRegister("2UyBL", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $06d2529594a8e25b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$06d2529594a8e25b$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $06d2529594a8e25b$export$2e2bcd8739ae039 = $06d2529594a8e25b$var$node;
module.exports["default"] = $06d2529594a8e25b$export$2e2bcd8739ae039;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("lAwaY"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("lAwaY", function(module, exports) {

let $fb75eb3d0ad60b96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fb75eb3d0ad60b96$var$load("YAi2k"),
    $fb75eb3d0ad60b96$var$load("adNrA"),
    $fb75eb3d0ad60b96$var$load("oTA4y"),
    $fb75eb3d0ad60b96$var$load("fPbCp"),
    $fb75eb3d0ad60b96$var$load("jZLnv"),
    $fb75eb3d0ad60b96$var$load("6edij"),
    $fb75eb3d0ad60b96$var$load("3QXpo"),
    $fb75eb3d0ad60b96$var$load("6wr18"),
    $fb75eb3d0ad60b96$var$load("ffEVr"),
    $fb75eb3d0ad60b96$var$load("ajMch"),
    $fb75eb3d0ad60b96$var$load("4izLy"),
    $fb75eb3d0ad60b96$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("6GQtz", function(module, exports) {

var $477dG = parcelRequire("477dG");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $477dG.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if ((0, $6mKj3.isExperimentEnabled)('confluence_smartlink_default_display_types')) {
            if (this.shouldDisplayAsEmbed(url)) return 'embed';
            if (this.shouldDisplayAsCard(url)) return 'block';
        }
        return super.getHardCodedAppearance(url);
    }
    /**
   * Opt in to honouring an explicitly-requested embed appearance as the default
   * (validated, with a card fallback) for the quick-insert embed flow. Both active
   * cohorts of the quick-insert embeds experiment (`prioritizeLinkInQIM` and
   * `prioritizeEmbedInQIM`) enable this — they differ only in quick-insert menu
   * ordering, not in embedding behaviour. Only `control` and unenrolled users keep
   * the existing behaviour.
   *
   * The platform only calls this when a link is inserted with a requested embed
   * appearance and the user has no saved preference, so the exposure here is
   * scoped to the quick-insert embed insertion path.
   */ shouldHonorRequestedEmbedAsDefault() {
        return (0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control';
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("477dG", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $a1WXB = parcelRequire("a1WXB");


var $i0VEL = parcelRequire("i0VEL");


var $1oCLl = parcelRequire("1oCLl");


var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");


var $1bFdN = parcelRequire("1bFdN");


var $5nJCu = parcelRequire("5nJCu");


var $l1HSN = parcelRequire("l1HSN");


var $k00oi = parcelRequire("k00oi");


var $dh538 = parcelRequire("dh538");


var $lEzf1 = parcelRequire("lEzf1");


var $egwA4 = parcelRequire("egwA4");

const $807e27f9bf9a8610$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $807e27f9bf9a8610$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $807e27f9bf9a8610$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $807e27f9bf9a8610$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $807e27f9bf9a8610$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $807e27f9bf9a8610$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $807e27f9bf9a8610$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?");
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?");
const $807e27f9bf9a8610$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $807e27f9bf9a8610$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$LOOM_VIDEO_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$LOOM_SCREENSHOT_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?loom\\..*?\\/i\\/(?<id>[a-f0-9]{32})");
const $807e27f9bf9a8610$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $807e27f9bf9a8610$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $807e27f9bf9a8610$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$JIRA_PLAN_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)");
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$JIRA_PLAN_WITH_SCENARIO_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?");
const $807e27f9bf9a8610$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $807e27f9bf9a8610$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $807e27f9bf9a8610$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $807e27f9bf9a8610$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $807e27f9bf9a8610$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $807e27f9bf9a8610$var$CONFLUENCE_TEAM_CALENDARS_REGEX = RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)");
const $807e27f9bf9a8610$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $807e27f9bf9a8610$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $807e27f9bf9a8610$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $807e27f9bf9a8610$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $807e27f9bf9a8610$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline = (url)=>url.match($807e27f9bf9a8610$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $807e27f9bf9a8610$var$isPolarisView = (url)=>url.match($807e27f9bf9a8610$var$POLARIS_VIEW_REGEX);
const $807e27f9bf9a8610$var$isJwmView = (url)=>url.match($807e27f9bf9a8610$var$JWM_VIEW_REGEX);
const $807e27f9bf9a8610$var$isJiraList = (url)=>url.match($807e27f9bf9a8610$var$JIRA_LIST_REGEX);
const $807e27f9bf9a8610$var$isGiphyMedia = (url)=>url.match($807e27f9bf9a8610$var$GIPHY_MEDIA_REGEX);
const $807e27f9bf9a8610$var$isProformaView = (url)=>url.match($807e27f9bf9a8610$var$PROFORMA_VIEW_REGEX);
const $807e27f9bf9a8610$var$isConfluenceWhiteboard = (url)=>url.match($807e27f9bf9a8610$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($807e27f9bf9a8610$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $807e27f9bf9a8610$var$isConfluenceDatabase = (url)=>url.match($807e27f9bf9a8610$var$CONFLUENCE_DATABASE_REGEX);
const $807e27f9bf9a8610$var$isYoutubeVideo = (url)=>url.match($807e27f9bf9a8610$var$YOUTUBE_VIDEO_REGEX);
const $807e27f9bf9a8610$var$isLoomVideoUrl = (url)=>{
    return url.match($807e27f9bf9a8610$var$LOOM_VIDEO_URL_REGEX);
};
const $807e27f9bf9a8610$var$isLoomScreenshotUrl = (url)=>{
    return url.match($807e27f9bf9a8610$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $807e27f9bf9a8610$var$isJiraDashboard = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_DASHBOARD_REGEX);
};
const $807e27f9bf9a8610$var$isJiraBacklog = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_BACKLOG_REGEX);
};
const $807e27f9bf9a8610$var$isJiraBoard = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_BOARD_REGEX);
};
const $807e27f9bf9a8610$var$isJiraPlan = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_PLAN_REGEX) || url.match($807e27f9bf9a8610$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $807e27f9bf9a8610$var$isJiraVersion = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_VERSION_REGEX);
};
const $807e27f9bf9a8610$var$isJiraForm = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_FORM_REGEX);
};
const $807e27f9bf9a8610$var$isJiraSummary = (url)=>{
    return url.match($807e27f9bf9a8610$var$JIRA_SUMMARY_REGEX);
};
const $807e27f9bf9a8610$var$isRovoAgentProfilePage = (url)=>{
    return url.match($807e27f9bf9a8610$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $807e27f9bf9a8610$var$isCustomer360LandingPage = (url)=>url.match($807e27f9bf9a8610$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $807e27f9bf9a8610$var$isConfluenceTeamCalendars = (url)=>url.match($807e27f9bf9a8610$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $807e27f9bf9a8610$var$isJiraIssueNavigator = (url)=>url.match($807e27f9bf9a8610$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $807e27f9bf9a8610$var$isAvpVisualizationView = (url)=>url.match($807e27f9bf9a8610$var$AVP_VISUALIZATION_VIEW_REGEX);
const $807e27f9bf9a8610$export$6a9668b99d8a1708 = (url)=>$807e27f9bf9a8610$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $807e27f9bf9a8610$var$isConfluenceSlide = (url)=>(0, $l1HSN.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $807e27f9bf9a8610$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline,
    isPolarisView: $807e27f9bf9a8610$var$isPolarisView,
    isJwmView: $807e27f9bf9a8610$var$isJwmView,
    isJiraList: $807e27f9bf9a8610$var$isJiraList,
    isConfluenceWhiteboard: $807e27f9bf9a8610$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $807e27f9bf9a8610$var$isConfluenceDatabase,
    isConfluenceSlide: $807e27f9bf9a8610$var$isConfluenceSlide,
    isJiraDashboard: $807e27f9bf9a8610$var$isJiraDashboard,
    isJiraBacklog: $807e27f9bf9a8610$var$isJiraBacklog,
    isJiraBoard: $807e27f9bf9a8610$var$isJiraBoard,
    isJiraPlan: $807e27f9bf9a8610$var$isJiraPlan,
    isJiraVersion: $807e27f9bf9a8610$var$isJiraVersion,
    isJiraForm: $807e27f9bf9a8610$var$isJiraForm,
    isJiraSummary: $807e27f9bf9a8610$var$isJiraSummary,
    isRovoAgentProfilePage: $807e27f9bf9a8610$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $807e27f9bf9a8610$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $807e27f9bf9a8610$var$isJiraIssueNavigator
};
function $807e27f9bf9a8610$export$4006295459a20a0(url) {
    return Object.values($807e27f9bf9a8610$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $807e27f9bf9a8610$export$78234eee43b97e81(url) {
    return !$807e27f9bf9a8610$export$4006295459a20a0(url);
}
function $807e27f9bf9a8610$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $807e27f9bf9a8610$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $807e27f9bf9a8610$export$e4635c0135e1a519 extends (0, $i0VEL.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        if ((0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false) // if local cache feature flag is disabled, fall back to the base implementation
        return super.getData(node, callback);
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $btw9C.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response?.meta) {
                const status = (0, $btw9C.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $dh538.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$807e27f9bf9a8610$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $dh538.fg)('platform_smartlink_inline_resolve_optimization') ? $807e27f9bf9a8610$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$807e27f9bf9a8610$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $lEzf1.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $807e27f9bf9a8610$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $807e27f9bf9a8610$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $807e27f9bf9a8610$var$isJiraPlan(url);
        const isJiraFormEvaluated = $807e27f9bf9a8610$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $807e27f9bf9a8610$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $dh538.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $807e27f9bf9a8610$var$isConfluenceTeamCalendars(url);
        if ($807e27f9bf9a8610$var$isJiraRoadmapOrTimeline(url) || $807e27f9bf9a8610$var$isPolarisView(url) || $807e27f9bf9a8610$var$isJwmView(url) || $807e27f9bf9a8610$var$isJiraList(url) || $807e27f9bf9a8610$var$isGiphyMedia(url) || $807e27f9bf9a8610$var$isProformaView(url) || $807e27f9bf9a8610$var$isConfluenceWhiteboard(url) || $807e27f9bf9a8610$var$isConfluenceDatabase(url) || (0, $l1HSN.isConfluenceSlideUrl)(url) || $807e27f9bf9a8610$var$isYoutubeVideo(url) || $807e27f9bf9a8610$var$isLoomVideoUrl(url) || $807e27f9bf9a8610$var$isLoomScreenshotUrl(url) && (0, $dh538.fg)('loom-support-screenshot-sl-resolution') || $807e27f9bf9a8610$var$isJiraDashboard(url) || $807e27f9bf9a8610$var$isJiraBacklog(url) || $807e27f9bf9a8610$var$isJiraBoard(url) || $807e27f9bf9a8610$var$isRovoAgentProfilePage(url) || $807e27f9bf9a8610$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $807e27f9bf9a8610$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $807e27f9bf9a8610$var$isJiraIssueNavigator(url) || $807e27f9bf9a8610$var$isAvpVisualizationView(url) && (0, $dh538.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $btw9C.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $a1WXB.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $dh538.fg)('issue-link-suggestions-in-comments')) {
                if ($807e27f9bf9a8610$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $egwA4.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $5nJCu.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $807e27f9bf9a8610$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $k00oi.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $807e27f9bf9a8610$export$b7c3c9a99f7959f5 = new $807e27f9bf9a8610$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $807e27f9bf9a8610$export$4006295459a20a0;
module.exports["isExternalUrl"] = $807e27f9bf9a8610$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $807e27f9bf9a8610$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $807e27f9bf9a8610$export$b7c3c9a99f7959f5;

});

parcelRegister("a1WXB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8IyAG = parcelRequire("8IyAG");


var $4sZvs = parcelRequire("4sZvs");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $kbte2 = parcelRequire("kbte2");

function $ea05eb724aaf2d4b$export$ab527c45f467d3f7(options) {
    const { defaultExtractorFunction: defaultExtractorFunction, extractorPrioritiesByType: extractorPrioritiesByType, extractorFunctionsByType: extractorFunctionsByType, json: json } = options;
    if (json) {
        const type = json['@type'];
        if (type && Array.isArray(type)) {
            let highestPriority = 0;
            let highestPriorityExtractorFunction = defaultExtractorFunction;
            for (let t of type)if (extractorPrioritiesByType[t] > highestPriority) {
                highestPriority = extractorPrioritiesByType[t];
                highestPriorityExtractorFunction = extractorFunctionsByType[t];
            }
            return highestPriorityExtractorFunction(json);
        }
        if (type && extractorFunctionsByType[type]) return extractorFunctionsByType[type](json);
    }
    return defaultExtractorFunction(json);
}
const $ea05eb724aaf2d4b$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
const $ea05eb724aaf2d4b$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(icon);
    else {
        if (icon.url) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(icon.url);
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
const $ea05eb724aaf2d4b$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(url);
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = $ea05eb724aaf2d4b$export$efdbd45f3e77a161(jsonLd);
    const type = $ea05eb724aaf2d4b$export$2e9ae379995d99e3(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
const $ea05eb724aaf2d4b$export$3185b99040f72cfd = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $ea05eb724aaf2d4b$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && $ea05eb724aaf2d4b$export$67f3d92c824fd850(context.icon),
                type: $ea05eb724aaf2d4b$export$2e9ae379995d99e3(context)
            };
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $ea05eb724aaf2d4b$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $ea05eb724aaf2d4b$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $kbte2.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4sZvs.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $kbte2.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return $ea05eb724aaf2d4b$export$67f3d92c824fd850(icon);
    return undefined;
};
const $ea05eb724aaf2d4b$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$38df542ff03a4183 = (id)=>{
    return id === (0, $kbte2.CONFLUENCE_GENERATOR_ID);
};
const $ea05eb724aaf2d4b$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
const $ea05eb724aaf2d4b$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
const $ea05eb724aaf2d4b$export$601b23e9cf369aed = (jsonLd)=>{
    if (jsonLd['atlassian:dateViewed']) return jsonLd['atlassian:dateViewed'];
    return undefined;
};
const $ea05eb724aaf2d4b$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && $ea05eb724aaf2d4b$export$67f3d92c824fd850(person.icon)
        };
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>$ea05eb724aaf2d4b$export$c471ae5fddcf1392(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = $ea05eb724aaf2d4b$export$c471ae5fddcf1392(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return $ea05eb724aaf2d4b$export$c471ae5fddcf1392(assignedTo);
    return undefined;
};
const $ea05eb724aaf2d4b$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map($ea05eb724aaf2d4b$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $ea05eb724aaf2d4b$export$c471ae5fddcf1392(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map($ea05eb724aaf2d4b$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $ea05eb724aaf2d4b$export$c471ae5fddcf1392(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return $ea05eb724aaf2d4b$export$c471ae5fddcf1392(updatedBy);
    return undefined;
};
const $ea05eb724aaf2d4b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
const $ea05eb724aaf2d4b$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = $ea05eb724aaf2d4b$export$3e8ad908070b68b2(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$8beff7405d020ddf = (response)=>response?.entityData;
const $ea05eb724aaf2d4b$export$c7168210b81d9383 = (response)=>Boolean($ea05eb724aaf2d4b$export$8beff7405d020ddf(response));
const $ea05eb724aaf2d4b$var$extractEntityEmbedUrl = (response)=>{
    const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $ea05eb724aaf2d4b$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    if ((0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entityIcon = $ea05eb724aaf2d4b$export$19346520e937a99f(response);
        if (entityIcon) return {
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        };
    }
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $kbte2.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4sZvs.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $kbte2.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    };
};
const $ea05eb724aaf2d4b$export$19346520e937a99f = (response)=>{
    if ((0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        if (!entity) return undefined;
        if (!(0, $8IyAG.isBaseEntity)(entity)) return undefined;
        if ((0, $8IyAG.isDesignEntity)(entity) && entity.iconUrl) return {
            url: entity.iconUrl,
            label: entity.type
        };
        if ((0, $8IyAG.isDocumentEntity)(entity) && entity.type.iconUrl) return {
            url: entity.type.iconUrl,
            label: entity.type.category
        };
        // When JSON-LD is deprecated, we can change this to returning entity provider icon.
        // For now code upstream will return better result when this method returns undefined.
        return undefined;
    } else {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        let url;
        if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
        return {
            url: url,
            label: entity?.displayName
        };
    }
};
const $ea05eb724aaf2d4b$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.displayName;
    return $ea05eb724aaf2d4b$export$b05803156e5015b6(response?.data, removeTextHighlightingFromTitle);
};
const $ea05eb724aaf2d4b$export$7ba9b12c6a1b73de = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.url;
    return $ea05eb724aaf2d4b$export$63f54cf4c5883620(response?.data);
};
const $ea05eb724aaf2d4b$export$16b02be3e2bb31ad = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.ari || $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.thirdPartyAri;
    const data = response?.data;
    return $ea05eb724aaf2d4b$export$be18a6294fd426ec(data);
};
const $ea05eb724aaf2d4b$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $ea05eb724aaf2d4b$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return $ea05eb724aaf2d4b$export$4b0d98b1b7f6d115(response?.data, 'web', iframeUrlType);
};
const $ea05eb724aaf2d4b$export$ff753ed519e96e9e = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$ad879f2c9d5100a0(response);
    return response?.data && $ea05eb724aaf2d4b$export$a832871718466647(response?.data);
};
const $ea05eb724aaf2d4b$export$7a685df468cbf38f = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.createdAt;
    return response?.data && $ea05eb724aaf2d4b$export$e1226a5e0bbbf862(response.data);
};
const $ea05eb724aaf2d4b$export$75047940e157fd1f = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.lastUpdatedAt;
    return response?.data && $ea05eb724aaf2d4b$export$7fc2f5e6f9d22ae7(response.data);
};
const $ea05eb724aaf2d4b$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.createdBy?.displayName;
    const persons = $ea05eb724aaf2d4b$export$a66235cba0c9d11a(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $ea05eb724aaf2d4b$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return $ea05eb724aaf2d4b$export$a66235cba0c9d11a(response.data);
};
const $ea05eb724aaf2d4b$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.lastUpdatedBy?.displayName;
    const person = $ea05eb724aaf2d4b$export$8a2d1ed7e6f336f0(response.data);
    return person ? person.name : undefined;
};
const $ea05eb724aaf2d4b$export$96ed4c1b14ac210a = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["genericExtractPropsFromJSONLD"] = $ea05eb724aaf2d4b$export$ab527c45f467d3f7;
module.exports["extractUrlFromLinkJsonLd"] = $ea05eb724aaf2d4b$export$396ba4ef2e37dc65;
module.exports["extractUrlFromIconJsonLd"] = $ea05eb724aaf2d4b$export$67f3d92c824fd850;
module.exports["extractType"] = $ea05eb724aaf2d4b$export$2e9ae379995d99e3;
module.exports["extractAri"] = $ea05eb724aaf2d4b$export$be18a6294fd426ec;
module.exports["extractLink"] = $ea05eb724aaf2d4b$export$63f54cf4c5883620;
module.exports["extractSummary"] = $ea05eb724aaf2d4b$export$db5a8500f6b6286e;
module.exports["extractTitle"] = $ea05eb724aaf2d4b$export$b05803156e5015b6;
module.exports["extractContext"] = $ea05eb724aaf2d4b$export$efdbd45f3e77a161;
module.exports["extractNameFromJsonLd"] = $ea05eb724aaf2d4b$export$3185b99040f72cfd;
module.exports["extractProvider"] = $ea05eb724aaf2d4b$export$a832871718466647;
module.exports["extractProviderIcon"] = $ea05eb724aaf2d4b$export$6fb636a2ac885215;
module.exports["isConfluenceGenerator"] = $ea05eb724aaf2d4b$export$38df542ff03a4183;
module.exports["extractDateCreated"] = $ea05eb724aaf2d4b$export$e1226a5e0bbbf862;
module.exports["extractDateUpdated"] = $ea05eb724aaf2d4b$export$7fc2f5e6f9d22ae7;
module.exports["extractDateViewed"] = $ea05eb724aaf2d4b$export$601b23e9cf369aed;
module.exports["extractPersonFromJsonLd"] = $ea05eb724aaf2d4b$export$c471ae5fddcf1392;
module.exports["extractMembers"] = $ea05eb724aaf2d4b$export$6281d080d62a0719;
module.exports["extractPersonAssignedTo"] = $ea05eb724aaf2d4b$export$38a0979ebf273662;
module.exports["extractPersonCreatedBy"] = $ea05eb724aaf2d4b$export$a66235cba0c9d11a;
module.exports["extractPersonOwnedBy"] = $ea05eb724aaf2d4b$export$19ee667f3f7a6ec3;
module.exports["extractPersonUpdatedBy"] = $ea05eb724aaf2d4b$export$8a2d1ed7e6f336f0;
module.exports["extractImage"] = $ea05eb724aaf2d4b$export$4c753a1297cb9805;
module.exports["extractPlatformIsSupported"] = $ea05eb724aaf2d4b$export$3e8ad908070b68b2;
module.exports["extractPreview"] = $ea05eb724aaf2d4b$export$4b0d98b1b7f6d115;
module.exports["extractEntity"] = $ea05eb724aaf2d4b$export$8beff7405d020ddf;
module.exports["isEntityPresent"] = $ea05eb724aaf2d4b$export$c7168210b81d9383;
module.exports["extractEntityProvider"] = $ea05eb724aaf2d4b$export$ad879f2c9d5100a0;
module.exports["extractEntityIcon"] = $ea05eb724aaf2d4b$export$19346520e937a99f;
module.exports["extractSmartLinkTitle"] = $ea05eb724aaf2d4b$export$3eda18658b66108;
module.exports["extractSmartLinkUrl"] = $ea05eb724aaf2d4b$export$7ba9b12c6a1b73de;
module.exports["extractSmartLinkAri"] = $ea05eb724aaf2d4b$export$16b02be3e2bb31ad;
module.exports["extractSmartLinkEmbed"] = $ea05eb724aaf2d4b$export$864b719baf5d744d;
module.exports["extractSmartLinkProvider"] = $ea05eb724aaf2d4b$export$ff753ed519e96e9e;
module.exports["extractSmartLinkCreatedOn"] = $ea05eb724aaf2d4b$export$7a685df468cbf38f;
module.exports["extractSmartLinkModifiedOn"] = $ea05eb724aaf2d4b$export$75047940e157fd1f;
module.exports["extractSmartLinkCreatedBy"] = $ea05eb724aaf2d4b$export$242875b46118beb2;
module.exports["extractSmartLinkAuthorGroup"] = $ea05eb724aaf2d4b$export$41fc716e1bc2dc90;
module.exports["extractSmartLinkModifiedBy"] = $ea05eb724aaf2d4b$export$7f099a839071a190;
module.exports["extractSmartLinkDownloadUrl"] = $ea05eb724aaf2d4b$export$96ed4c1b14ac210a;

});

parcelRegister("8IyAG", function(module, exports) {
const $1092512147c3e960$var$DESIGN_TYPES = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
const $1092512147c3e960$var$DESIGN_STATUSES = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
const $1092512147c3e960$var$REMOTE_LINK_TYPES = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
const $1092512147c3e960$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $1092512147c3e960$var$WORK_ITEM_SUB_TYPES = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
const $1092512147c3e960$var$DOCUMENT_CATEGORIES = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ const $1092512147c3e960$var$isOneOf = (values, value)=>typeof value === 'string' && values.includes(value);
const $1092512147c3e960$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $1092512147c3e960$var$asRecord = (value)=>value;
const $1092512147c3e960$export$12af7c5462954d1e = (value)=>$1092512147c3e960$var$isObject(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';
const $1092512147c3e960$export$8dc9be81b5b6266b = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$DESIGN_STATUSES, $1092512147c3e960$var$asRecord(value).status) && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$DESIGN_TYPES, $1092512147c3e960$var$asRecord(value).type);
const $1092512147c3e960$export$f16c4076686c1f5b = (value)=>{
    if (!$1092512147c3e960$export$12af7c5462954d1e(value)) return false;
    const entity = $1092512147c3e960$var$asRecord(value);
    const remoteLink = entity['atlassian:remote-link'];
    return $1092512147c3e960$var$isObject(remoteLink) && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$REMOTE_LINK_TYPES, remoteLink.type);
};
const $1092512147c3e960$export$791f1b4852e2a184 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && $1092512147c3e960$var$isObject($1092512147c3e960$var$asRecord(value)['atlassian:project']);
const $1092512147c3e960$export$162dad7a1238d377 = (value)=>{
    if (!$1092512147c3e960$export$12af7c5462954d1e(value)) return false;
    const entity = $1092512147c3e960$var$asRecord(value);
    const workItem = entity['atlassian:work-item'];
    return $1092512147c3e960$var$isObject(workItem) && typeof workItem.status === 'string' && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$WORK_ITEM_SUB_TYPES, workItem.subtype) && typeof workItem.team === 'string';
};
const $1092512147c3e960$export$32c06ee7e0e9b79e = (value)=>{
    if (!$1092512147c3e960$export$12af7c5462954d1e(value)) return false;
    const entityType = $1092512147c3e960$var$asRecord(value).type;
    return $1092512147c3e960$var$isObject(entityType) && (entityType.category === undefined || $1092512147c3e960$var$isOneOf($1092512147c3e960$var$DOCUMENT_CATEGORIES, entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ($1092512147c3e960$var$isOneOf($1092512147c3e960$var$DOCUMENT_CATEGORIES, entityType.category) || typeof entityType.iconUrl === 'string');
};
const $1092512147c3e960$export$33e8c1bbf9148b0e = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && ('attachments' in value || 'commentCount' in value || 'hidden' in value || 'isPinned' in value || 'lastActive' in value || 'reactions' in value);
const $1092512147c3e960$export$6c20afe8743cb761 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && ('isArchived' in value || 'lastActive' in value || 'memberCount' in value || 'members' in value || 'membershipType' in value || 'topic' in value || 'workspace' in value);
const $1092512147c3e960$export$fe785532d894f833 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && !$1092512147c3e960$export$8dc9be81b5b6266b(value) && !$1092512147c3e960$export$f16c4076686c1f5b(value) && !$1092512147c3e960$export$791f1b4852e2a184(value) && !$1092512147c3e960$export$162dad7a1238d377(value) && !$1092512147c3e960$export$32c06ee7e0e9b79e(value) && !$1092512147c3e960$export$33e8c1bbf9148b0e(value) && !$1092512147c3e960$export$6c20afe8743cb761(value);
const $1092512147c3e960$export$47565ffe58e56845 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && ($1092512147c3e960$export$8dc9be81b5b6266b(value) || $1092512147c3e960$export$f16c4076686c1f5b(value) || $1092512147c3e960$export$791f1b4852e2a184(value) || $1092512147c3e960$export$162dad7a1238d377(value) || $1092512147c3e960$export$32c06ee7e0e9b79e(value) || $1092512147c3e960$export$33e8c1bbf9148b0e(value) || $1092512147c3e960$export$6c20afe8743cb761(value) || $1092512147c3e960$export$fe785532d894f833(value));
module.exports["isBaseEntity"] = $1092512147c3e960$export$12af7c5462954d1e;
module.exports["isDesignEntity"] = $1092512147c3e960$export$8dc9be81b5b6266b;
module.exports["isDocumentEntity"] = $1092512147c3e960$export$32c06ee7e0e9b79e;

});

parcelRegister("4sZvs", function(module, exports) {

var $ldZvW = parcelRequire("ldZvW");


var $8akax = parcelRequire("8akax");


var $2i2Hp = parcelRequire("2i2Hp");

const $8bfb06df0501dc58$export$68f3db7f6af48bcb = (0, $8akax.createFeatureFlaggedComponent)((0, $2i2Hp.ConfluenceIcon), (0, $ldZvW.ConfluenceIcon));
module.exports["ConfluenceIcon"] = $8bfb06df0501dc58$export$68f3db7f6af48bcb;

});

parcelRegister("kbte2", function(module, exports) {
const $4827a4a6130f9557$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $4827a4a6130f9557$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $4827a4a6130f9557$export$84a73a0383f58180 = 'JiraTask';
const $4827a4a6130f9557$export$c6c83963a9378a67 = 'JiraSubTask';
const $4827a4a6130f9557$export$58af3c426c111a6d = 'JiraStory';
const $4827a4a6130f9557$export$ac9898a63417219e = 'JiraBug';
const $4827a4a6130f9557$export$54db5e3fb12e39cd = 'JiraEpic';
const $4827a4a6130f9557$export$2f54a5a217202c85 = 'JiraIncident';
const $4827a4a6130f9557$export$d097371052bfc411 = 'JiraServiceRequest';
const $4827a4a6130f9557$export$efd9452ad16c6676 = 'JiraChange';
const $4827a4a6130f9557$export$2e7e70abb5d81f67 = 'JiraProblem';
const $4827a4a6130f9557$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $4827a4a6130f9557$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $4827a4a6130f9557$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});
module.exports["CONFLUENCE_GENERATOR_ID"] = $4827a4a6130f9557$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $4827a4a6130f9557$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $4827a4a6130f9557$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $4827a4a6130f9557$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $4827a4a6130f9557$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $4827a4a6130f9557$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $4827a4a6130f9557$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $4827a4a6130f9557$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $4827a4a6130f9557$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $4827a4a6130f9557$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $4827a4a6130f9557$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $4827a4a6130f9557$export$ce25cfc40b280dbc;
module.exports["SmartLinkSize"] = $4827a4a6130f9557$export$51f13ced115cbdae;
module.exports["IconType"] = $4827a4a6130f9557$export$13ff1290a9e22e77;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $iu6m9 = parcelRequire("iu6m9");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("5nJCu", function(module, exports) {
class $b839f3682b6db3a9$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b839f3682b6db3a9$export$f993aef960936087;

});

parcelRegister("l1HSN", function(module, exports) {
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $57844766c894899d$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $57844766c894899d$export$4091d55e0211d2e1 = (url)=>$57844766c894899d$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);
module.exports["isConfluenceSlideUrl"] = $57844766c894899d$export$4091d55e0211d2e1;

});

parcelRegister("lEzf1", function(module, exports) {
const $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $73e1dba18235f000$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $73e1dba18235f000$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $73e1dba18235f000$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $73e1dba18235f000$export$b5fe3f66a567bec0;

});

parcelRegister("egwA4", function(module, exports) {

var $kt8c2 = parcelRequire("kt8c2");

var $7a3952f20342cebe$var$_SmartCardLocalCacheClient;
const $7a3952f20342cebe$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $7a3952f20342cebe$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $7a3952f20342cebe$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$7a3952f20342cebe$export$1987ad1ab31f2528.instance) $7a3952f20342cebe$export$1987ad1ab31f2528.instance = new $7a3952f20342cebe$export$1987ad1ab31f2528(maxItems);
        return $7a3952f20342cebe$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $7a3952f20342cebe$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $kt8c2.default)($7a3952f20342cebe$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url in storage
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached in storage
     */ this.setItem = (url, response)=>{
            // Add or update the item in the cache with current timestamp
            this.memoryCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            // Apply FIFO behavior if cache exceeds maxItems
            const cacheKeys = Object.keys(this.memoryCache);
            if (cacheKeys.length > this.maxItems) {
                // Sort keys by timestamp (oldest first) and remove the oldest items
                const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.memoryCache[key];
                });
            }
            // Write through to storage asynchronously (non-blocking)
            // Debounced to batch multiple rapid calls into a single write
            if (!this.pendingWrite) {
                this.pendingWrite = true;
                queueMicrotask(()=>{
                    try {
                        this.storageClient.setItemWithExpiry($7a3952f20342cebe$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                    } catch (_) {
                    // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                    // Cache will still function in-memory for the session, but won't persist
                    } finally{
                        this.pendingWrite = false;
                    }
                });
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url from storage (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            const response = this.memoryCache?.[url]?.data;
            return response;
        };
        /**
     * Checks if a cached entry exists for the provided url in storage
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        // Load cache from storage into memory on instantiation
        const stored = this.storageClient.getItem($7a3952f20342cebe$var$SMART_CARD_CACHE_KEY, {
            useExpiredItem: true
        });
        this.memoryCache = stored ? JSON.parse(stored) : {};
    }
}
$7a3952f20342cebe$var$_SmartCardLocalCacheClient = $7a3952f20342cebe$export$1987ad1ab31f2528;
$7a3952f20342cebe$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $7a3952f20342cebe$export$1987ad1ab31f2528;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("lmNXu", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $vLw8x = parcelRequire("vLw8x");

const $cdf0b5cb977c302e$export$f996105bf70a5c25 = (0, $2XqLN.default)((routesContext, handleLinks)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
        },
        ...handleLinks ? {
            link: {
                onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
            }
        } : {}
    } : undefined);
module.exports["createSmartCardEventHandler"] = $cdf0b5cb977c302e$export$f996105bf70a5c25;

});

parcelRegister("vLw8x", function(module, exports) {

var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $icKZN = parcelRequire("icKZN");


var $jibmA = parcelRequire("jibmA");

const $fbd8de70e694fd11$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $jibmA.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
    } else $fbd8de70e694fd11$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $fbd8de70e694fd11$var$handleClick = (e, url)=>{
    (0, $icKZN.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $fbd8de70e694fd11$export$71eec072841e6b90;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.ACCESS_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("icKZN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $76c86d96bcffdba9$export$4128d9964cdd56b5 = (event, options)=>{
    return event?.isDefaultPrevented() && (Boolean(options?.shouldCheckIframe) && $76c86d96bcffdba9$var$isIframe() || $76c86d96bcffdba9$var$isCtrlOrCommandClick(event) || $76c86d96bcffdba9$var$isMiddleClick(event));
};
const $76c86d96bcffdba9$var$isIframe = ()=>window.parent !== parent;
const $76c86d96bcffdba9$var$isMiddleClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return nativeEvent.button === 1;
};
const $76c86d96bcffdba9$var$isCtrlOrCommandClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return (0, $9wGTI.fg)('platform-smart-card-shift-key') ? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey : nativeEvent.ctrlKey || nativeEvent.metaKey;
};
module.exports["isClickEventToOpenNewTab"] = $76c86d96bcffdba9$export$4128d9964cdd56b5;

});

parcelRegister("jibmA", function(module, exports) {

var $60cDW = parcelRequire("60cDW");

const $005667118ff06aa5$export$b98882f166bb7ce2 = (url)=>{
    const windowHostname = typeof window !== 'undefined' && window.location ? window.location.hostname : (0, $60cDW.getSSRRenderInputs)().host;
    // Only including support for certain Jira paths to minimise hardcoding
    const linkClickExceptionPaths = [
        '/browse',
        '/jira'
    ];
    let urlObject;
    try {
        // Resolve against the current host so relative URLs (e.g. /browse/ABC-1) parse correctly.
        urlObject = url && new URL(url, windowHostname ? `https://${windowHostname}` : undefined);
    } catch  {}
    const { hostname: hostname, pathname: pathname } = urlObject || {};
    return hostname && windowHostname && hostname !== windowHostname || linkClickExceptionPaths.some((exceptionPath)=>pathname?.startsWith(exceptionPath));
};
module.exports["isExternalLink"] = $005667118ff06aa5$export$b98882f166bb7ce2;

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        // Nav4 is fully rolled out; top nav height is always 48px unless FHS is enabled
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        let navHeight = 48;
        if (// The increased height change is only applied when FHS is enabled.
        // Ideally we could check `useIsFhsEnabled()` but we can't use hooks here.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false)) navHeight = 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("kBU5m", function(module, exports) {
// featureFlags should come from getSessionData in @confluence/session-data
// IMPORTANT: If you change the code below, please also update the
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
function $d887a76516ca8f8c$export$88f94a4dc797781a(featureFlags) {
    return featureFlags ? {
        mediaInline: true
    } : {};
}
module.exports["getMediaFeatureFlags"] = $d887a76516ca8f8c$export$88f94a4dc797781a;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $fJJ4V = parcelRequire("fJJ4V");


var $i0VEL = parcelRequire("i0VEL");


var $dZ8uq = parcelRequire("dZ8uq");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $dZ8uq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $fJJ4V.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $dZ8uq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $fJJ4V.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("lEf66", function(module, exports) {
const $0892e7364b81f0d9$export$256d0139ed1b4d96 = (queryData)=>{
    return queryData?.user?.confluence?.permissionType;
};
module.exports["getUserPermissionFromQuery"] = $0892e7364b81f0d9$export$256d0139ed1b4d96;

});

parcelRegister("5OVTZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $9d9b34902cc040ae$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $9d9b34902cc040ae$export$8995abb8169b2cb8;

});

parcelRegister("5dnlf", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ // We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("2jMPn");
var $7GrAm = parcelRequire("7GrAm");


var $aXWIB = parcelRequire("aXWIB");

const $407fdba28f01fe31$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: "content-renderer.inlineComment.marker.start",
        defaultMessage: "inline comment start"
    },
    contentRendererInlineCommentMarkerEnd: {
        id: "content-renderer.inlineComment.marker.end",
        defaultMessage: "inline comment end"
    }
});
/* Yellow highlights*/ const $407fdba28f01fe31$var$highlightStyle = (intl, isFabric)=>(0, $7GrAm.default)`
	cursor: pointer;
	background-color: ${isFabric ? "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" : "var(--ds-background-accent-yellow-subtler, #F5E989)"};
	border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"};
	&.active-highlight {
		background-color: ${"var(--ds-background-accent-yellow-subtle, #EED12B)"};
		border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"};
		box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"};
	}

	/* Accessibility markers for screen readers: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/mark#accessibility_concerns */
	&::before,
	&::after {
		clip-path: inset(100%);
		clip: rect(1px, 1px, 1px, 1px);
		height: 1px;
		overflow: hidden;
		position: absolute;
		white-space: nowrap;
		width: 1px;
	}

	&.first-mark-highlight::before {
		content: ' [${intl.formatMessage($407fdba28f01fe31$export$defe85febe8b728c.contentRendererInlineCommentMarkerStart)}] ';
	}

	&.last-mark-highlight::after {
		content: ' [${intl.formatMessage($407fdba28f01fe31$export$defe85febe8b728c.contentRendererInlineCommentMarkerEnd)}] ';
	}
`;
const $407fdba28f01fe31$export$ff7bdbeb01ad8e1f = (markerRefs, isFabric, intl)=>{
    const combinedStyles = {
        ...$407fdba28f01fe31$export$b2855f2a39bd93e8(intl) // Include the SPA styles
    };
    // Add SSR-style direct marker ref targeting
    markerRefs.forEach((markerRef)=>{
        const attribute = isFabric ? 'id' : 'ref';
        const selector = isFabric ? `mark[data-${attribute}="${markerRef}"]` : `span[data-${attribute}="${markerRef}"]`;
        combinedStyles[selector] = $407fdba28f01fe31$var$highlightStyle(intl, isFabric);
    });
    return combinedStyles;
};
const $407fdba28f01fe31$export$b2855f2a39bd93e8 = (intl)=>(0, $7GrAm.default)`
	div[mode='stick'] {
		z-index: 1;
		background: ${"var(--ds-background-inverse-subtle, #00000029)"};
	}

	span {
		&.inline-highlight {
			${$407fdba28f01fe31$var$highlightStyle(intl)}
		}

		&.inline-create-comment-selection {
			background-color: ${"var(--ds-background-accent-yellow-subtle, #EED12B)"};
			border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"};
			box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"};
		}
	}
`;
module.exports["messages"] = $407fdba28f01fe31$export$defe85febe8b728c;
module.exports["inlineHighlightStyles"] = $407fdba28f01fe31$export$ff7bdbeb01ad8e1f;
module.exports["inlineCommentStyles"] = $407fdba28f01fe31$export$b2855f2a39bd93e8;

});

parcelRegister("2jMPn", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("7GrAm")).default);

var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");

parcelRequire("3p0fY");


var $1naEG = parcelRequire("1naEG");


var $dmgN7 = parcelRequire("dmgN7");


var $5ElVn = parcelRequire("5ElVn");


var $17TcT = parcelRequire("17TcT");


var $7GrAm = parcelRequire("7GrAm");

var $1b033b47e5e51d93$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $1naEG.h).call(props, 'css')) // $FlowFixMe
    return (0, $42omo.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $1naEG.E);
    createElementArgArray[1] = (0, $1naEG.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $42omo.createElement).apply(null, createElementArgArray);
};
var $1b033b47e5e51d93$var$warnedAboutCssPropForGlobal = false;
var $1b033b47e5e51d93$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $1naEG.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $42omo.createElement)((0, $1naEG.T).Consumer, null, function(theme) {
        var serialized = (0, $5ElVn.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $42omo.createElement)($1b033b47e5e51d93$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $5ElVn.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $42omo.createElement)($1b033b47e5e51d93$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $1b033b47e5e51d93$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $17TcT.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $dmgN7.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $42omo.Component));
var $1b033b47e5e51d93$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $7GrAm.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $1b033b47e5e51d93$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $1b033b47e5e51d93$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $dmgN7.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $1b033b47e5e51d93$var$Noop = function Noop() {
    return null;
};
var $1b033b47e5e51d93$export$9b9c0f9d9f3552b8 = (0, $1naEG.w)(function(props, context) {
    return /*#__PURE__*/ (0, $42omo.createElement)((0, $1naEG.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $5ElVn.serializeStyles)(args, context.registered);
            (0, $dmgN7.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $1b033b47e5e51d93$var$merge(context.registered, css, $1b033b47e5e51d93$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $42omo.createElement)($1b033b47e5e51d93$var$Noop, null);
        return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), null, possiblyStyleElement, ele);
    });
});

});

parcelRegister("3p0fY", function(module, exports) {

var $17TcT = parcelRequire("17TcT");


var $iJwkl = parcelRequire("iJwkl");

parcelRequire("b2bJs");

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $27a3e7d86cf699a4$var$delimiter = '/*|*/';
var $27a3e7d86cf699a4$var$needle = $27a3e7d86cf699a4$var$delimiter + '}';
function $27a3e7d86cf699a4$var$toSheet(block) {
    if (block) $27a3e7d86cf699a4$var$Sheet.current.insert(block + '}');
}
var $27a3e7d86cf699a4$var$Sheet = {
    current: null
};
var $27a3e7d86cf699a4$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $27a3e7d86cf699a4$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $27a3e7d86cf699a4$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $27a3e7d86cf699a4$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $27a3e7d86cf699a4$var$delimiter : '');
            }
        case -2:
            content.split($27a3e7d86cf699a4$var$needle).forEach($27a3e7d86cf699a4$var$toSheet);
    }
};
var $27a3e7d86cf699a4$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $iJwkl.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($27a3e7d86cf699a4$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $27a3e7d86cf699a4$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $17TcT.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $27a3e7d86cf699a4$export$2e2bcd8739ae039 = $27a3e7d86cf699a4$var$createCache;
module.exports["default"] = $27a3e7d86cf699a4$export$2e2bcd8739ae039;

});

parcelRegister("17TcT", function(module, exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $0d2144d6479b12ec$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $0d2144d6479b12ec$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $0d2144d6479b12ec$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $0d2144d6479b12ec$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $0d2144d6479b12ec$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();
module.exports["StyleSheet"] = $0d2144d6479b12ec$export$9d753cd7ae895cce;

});

parcelRegister("iJwkl", function(module, exports) {
function $da358174ef16096d$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $da358174ef16096d$export$2e2bcd8739ae039 = $da358174ef16096d$var$stylis_min;
module.exports["default"] = $da358174ef16096d$export$2e2bcd8739ae039;

});

parcelRegister("b2bJs", function(module, exports) {
var $8088fb5b17b7a32a$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $8088fb5b17b7a32a$export$2e2bcd8739ae039 = $8088fb5b17b7a32a$var$weakMemoize;

});

parcelRegister("1naEG", function(module, exports) {
parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $3p0fY = parcelRequire("3p0fY");


var $dmgN7 = parcelRequire("dmgN7");


var $5ElVn = parcelRequire("5ElVn");

var $10003458710057aa$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $10003458710057aa$var$EmotionCacheContext = /*#__PURE__*/ (0, $42omo.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $3p0fY.default)() : null);
var $10003458710057aa$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $42omo.createContext)({});
var $10003458710057aa$export$e7094788287c5e9b = $10003458710057aa$var$EmotionCacheContext.Provider;
var $10003458710057aa$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $42omo.createElement)($10003458710057aa$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $42omo.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $10003458710057aa$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $10003458710057aa$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $10003458710057aa$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $10003458710057aa$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($10003458710057aa$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$10003458710057aa$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $10003458710057aa$var$Noop = function Noop() {
    return null;
};
var $10003458710057aa$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$10003458710057aa$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $5ElVn.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $dmgN7.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($10003458710057aa$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $10003458710057aa$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $42omo.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $42omo.createElement)($10003458710057aa$var$Noop, null);
    return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $10003458710057aa$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $10003458710057aa$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $42omo.createElement)($10003458710057aa$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $10003458710057aa$var$render(cache, props, theme, ref);
    });
    return $10003458710057aa$var$render(cache, props, null, ref);
});
module.exports["h"] = $10003458710057aa$export$dda1d9f60106f0e9;
module.exports["T"] = $10003458710057aa$export$971d5caa766a69d7;
module.exports["w"] = $10003458710057aa$export$efccba1c4a2ef57b;
module.exports["c"] = $10003458710057aa$export$db3b6bfb95261072;
module.exports["E"] = $10003458710057aa$export$a9c23c6ac3fc3eca;

});

parcelRegister("5ElVn", function(module, exports) {

var $81A5B = parcelRequire("81A5B");


var $fTleW = parcelRequire("fTleW");


var $77umQ = parcelRequire("77umQ");

var $41d1b1e3faa6b423$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $41d1b1e3faa6b423$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $41d1b1e3faa6b423$var$hyphenateRegex = /[A-Z]|^ms/g;
var $41d1b1e3faa6b423$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $41d1b1e3faa6b423$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $41d1b1e3faa6b423$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $41d1b1e3faa6b423$var$processStyleName = (0, $77umQ.default)(function(styleName) {
    return $41d1b1e3faa6b423$var$isCustomProperty(styleName) ? styleName : styleName.replace($41d1b1e3faa6b423$var$hyphenateRegex, '-$&').toLowerCase();
});
var $41d1b1e3faa6b423$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($41d1b1e3faa6b423$var$animationRegex, function(match, p1, p2) {
                $41d1b1e3faa6b423$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $41d1b1e3faa6b423$var$cursor
                };
                return p1;
            });
    }
    if ((0, $fTleW.default)[key] !== 1 && !$41d1b1e3faa6b423$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $41d1b1e3faa6b423$var$contentValuePattern, $41d1b1e3faa6b423$var$contentValues, $41d1b1e3faa6b423$var$oldProcessStyleValue, $41d1b1e3faa6b423$var$msPattern, $41d1b1e3faa6b423$var$hyphenPattern, $41d1b1e3faa6b423$var$hyphenatedCache;
var $41d1b1e3faa6b423$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $41d1b1e3faa6b423$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $41d1b1e3faa6b423$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $41d1b1e3faa6b423$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $41d1b1e3faa6b423$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $41d1b1e3faa6b423$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $41d1b1e3faa6b423$var$cursor;
                var result = interpolation(mergedProps);
                $41d1b1e3faa6b423$var$cursor = previousCursor;
                return $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $41d1b1e3faa6b423$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($41d1b1e3faa6b423$var$isProcessableValue(value)) string += $41d1b1e3faa6b423$var$processStyleName(_key) + ":" + $41d1b1e3faa6b423$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($41d1b1e3faa6b423$var$isProcessableValue(value[_i])) string += $41d1b1e3faa6b423$var$processStyleName(_key) + ":" + $41d1b1e3faa6b423$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $41d1b1e3faa6b423$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $41d1b1e3faa6b423$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $41d1b1e3faa6b423$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $41d1b1e3faa6b423$var$cursor;
var $41d1b1e3faa6b423$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $41d1b1e3faa6b423$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $41d1b1e3faa6b423$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $41d1b1e3faa6b423$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $81A5B.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $41d1b1e3faa6b423$var$cursor
    };
};
module.exports["serializeStyles"] = $41d1b1e3faa6b423$export$6321afa313b251b5;

});

parcelRegister("81A5B", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $5d7a694cc4314d6e$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $5d7a694cc4314d6e$export$2e2bcd8739ae039 = $5d7a694cc4314d6e$var$murmur2;
module.exports["default"] = $5d7a694cc4314d6e$export$2e2bcd8739ae039;

});

parcelRegister("fTleW", function(module, exports) {
var $02fc5483b8246141$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $02fc5483b8246141$export$2e2bcd8739ae039 = $02fc5483b8246141$var$unitlessKeys;
module.exports["default"] = $02fc5483b8246141$export$2e2bcd8739ae039;

});

parcelRegister("77umQ", function(module, exports) {
function $52f0be343b1694de$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $52f0be343b1694de$export$2e2bcd8739ae039 = $52f0be343b1694de$var$memoize;
module.exports["default"] = $52f0be343b1694de$export$2e2bcd8739ae039;

});

parcelRegister("7GrAm", function(module, exports) {

var $gaYGO = parcelRequire("gaYGO");

function $5981da884573f5f2$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $gaYGO.serializeStyles)(args);
}
var $5981da884573f5f2$export$2e2bcd8739ae039 = $5981da884573f5f2$var$css;
module.exports["default"] = $5981da884573f5f2$export$2e2bcd8739ae039;

});

parcelRegister("gaYGO", function(module, exports) {

var $kCFr8 = parcelRequire("kCFr8");


var $kBt7i = parcelRequire("kBt7i");


var $4SQOF = parcelRequire("4SQOF");

var $bc6ca833ea660b74$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $bc6ca833ea660b74$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $bc6ca833ea660b74$var$hyphenateRegex = /[A-Z]|^ms/g;
var $bc6ca833ea660b74$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $bc6ca833ea660b74$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $bc6ca833ea660b74$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $bc6ca833ea660b74$var$processStyleName = (0, $4SQOF.default)(function(styleName) {
    return $bc6ca833ea660b74$var$isCustomProperty(styleName) ? styleName : styleName.replace($bc6ca833ea660b74$var$hyphenateRegex, '-$&').toLowerCase();
});
var $bc6ca833ea660b74$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($bc6ca833ea660b74$var$animationRegex, function(match, p1, p2) {
                $bc6ca833ea660b74$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $bc6ca833ea660b74$var$cursor
                };
                return p1;
            });
    }
    if ((0, $kBt7i.default)[key] !== 1 && !$bc6ca833ea660b74$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $bc6ca833ea660b74$var$contentValuePattern, $bc6ca833ea660b74$var$contentValues, $bc6ca833ea660b74$var$oldProcessStyleValue, $bc6ca833ea660b74$var$msPattern, $bc6ca833ea660b74$var$hyphenPattern, $bc6ca833ea660b74$var$hyphenatedCache;
var $bc6ca833ea660b74$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $bc6ca833ea660b74$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $bc6ca833ea660b74$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $bc6ca833ea660b74$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $bc6ca833ea660b74$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $bc6ca833ea660b74$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $bc6ca833ea660b74$var$cursor;
                var result = interpolation(mergedProps);
                $bc6ca833ea660b74$var$cursor = previousCursor;
                return $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $bc6ca833ea660b74$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($bc6ca833ea660b74$var$isProcessableValue(value)) string += $bc6ca833ea660b74$var$processStyleName(_key) + ":" + $bc6ca833ea660b74$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($bc6ca833ea660b74$var$isProcessableValue(value[_i])) string += $bc6ca833ea660b74$var$processStyleName(_key) + ":" + $bc6ca833ea660b74$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $bc6ca833ea660b74$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $bc6ca833ea660b74$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $bc6ca833ea660b74$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $bc6ca833ea660b74$var$cursor;
var $bc6ca833ea660b74$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $bc6ca833ea660b74$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $bc6ca833ea660b74$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $bc6ca833ea660b74$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $kCFr8.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $bc6ca833ea660b74$var$cursor
    };
};
module.exports["serializeStyles"] = $bc6ca833ea660b74$export$6321afa313b251b5;

});

parcelRegister("kCFr8", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $f0377fb5614f23a4$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $f0377fb5614f23a4$export$2e2bcd8739ae039 = $f0377fb5614f23a4$var$murmur2;
module.exports["default"] = $f0377fb5614f23a4$export$2e2bcd8739ae039;

});

parcelRegister("kBt7i", function(module, exports) {
var $effdd9535a2a84c3$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $effdd9535a2a84c3$export$2e2bcd8739ae039 = $effdd9535a2a84c3$var$unitlessKeys;
module.exports["default"] = $effdd9535a2a84c3$export$2e2bcd8739ae039;

});

parcelRegister("4SQOF", function(module, exports) {
function $38e52cc536218d28$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $38e52cc536218d28$export$2e2bcd8739ae039 = $38e52cc536218d28$var$memoize;
module.exports["default"] = $38e52cc536218d28$export$2e2bcd8739ae039;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gXsSh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");

function $fce7c419b91370d9$export$62d325d4ac84165c(WrappedComponent) {
    function WithRoutesContext(props) {
        const $ = (0, $frIzR.c)(3);
        const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
        let t0;
        if ($[0] !== props || $[1] !== routesContext) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...routesContext,
                ...props
            });
            $[0] = props;
            $[1] = routesContext;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    WithRoutesContext.displayName = `withRoutesContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithRoutesContext;
}
module.exports["withRoutesContext"] = $fce7c419b91370d9$export$62d325d4ac84165c;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("f0NfR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");

function $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a(WrappedComponent) {
    function WithSessionData(props) {
        const sessionData = (0, $bQm3c.useSessionData)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            sessionData: sessionData,
            ...props
        });
    }
    WithSessionData.displayName = `withSessionData(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithSessionData;
}
module.exports["withSessionData"] = $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a;

});

parcelRegister("1SPMi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $k7eoe = parcelRequire("k7eoe");


var $bQm3c = parcelRequire("bQm3c");


var $2SowE = parcelRequire("2SowE");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $k7eoe.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $k7eoe.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("gKr8t", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $5v4fk = parcelRequire("5v4fk");


var $guZe9 = parcelRequire("guZe9");


var $jxz2A = parcelRequire("jxz2A");


var $jWs8F = parcelRequire("jWs8F");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)({
    isForAggOnly: true
});
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $jWs8F.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $jxz2A.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $5v4fk.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $guZe9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $5v4fk.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $5v4fk.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9wEpK.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $5v4fk.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $5v4fk = parcelRequire("5v4fk");


var $lB1H3 = parcelRequire("lB1H3");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $5v4fk.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $5v4fk.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $lB1H3.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $lB1H3.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $5v4fk = parcelRequire("5v4fk");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $5v4fk.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/** Used for built-in method references. */ var $3e1566926de40aab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e1566926de40aab$var$hasOwnProperty = $3e1566926de40aab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $w287Y(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$3e1566926de40aab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $9rfkh(object, path);
    return obj == null || delete obj[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "@confluence/space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("19w2x", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $105205360274b3e9$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $105205360274b3e9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $105205360274b3e9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $105205360274b3e9$export$a300664a1a230956 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion } = t0;
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $2K5gO.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $6ttbq.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $4QtAs.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== requestAnimationFrame || $[9] !== setTimeout) {
        t3 = ()=>{
            if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = requestAnimationFrame;
        $[9] = setTimeout;
        $[10] = t3;
    } else t3 = $[10];
    (0, $dclyF.useLayoutEffect)(t3);
    let t4;
    if ($[11] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[11] = setElementRef;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $105205360274b3e9$export$a300664a1a230956;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hUAWL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9fe18f2334f78b72$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $9fe18f2334f78b72$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9fe18f2334f78b72$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $9fe18f2334f78b72$export$1775f27e7c8051ca;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("gHaxX", function(module, exports) {

var $973aB = parcelRequire("973aB");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/user/manifest.ts
var $c278d7dccfa97a86$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $973aB.IdentityUserAriResourceOwner),
    resourceType: (0, $973aB.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $c278d7dccfa97a86$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NXcb.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $c278d7dccfa97a86$export$1e9d09c2be53e55e;

});

parcelRegister("973aB", function(module, exports) {
// src/identity/user/types.ts
var $6a2739fa6e7a2528$export$b4c14c54282a779d = "identity", $6a2739fa6e7a2528$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $6a2739fa6e7a2528$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $6a2739fa6e7a2528$export$e9b50e20f4fbfb71;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$31a43870c77aad50 = {
    NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE: 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible',
    NTH_USER_D0_SIMPLIFIED_NAV_START_AT: 'simplify-nav-new-user:nthUserD0SimplifiedNavStartAt'
};
const $3c94963df51c0e13$export$400b215814bf3fc0 = {
    CHECKED_ELIGIBLE: 'creation-focused-nav-xflow:creationFocusedNavXflowCheckedEligible',
    START_AT: 'creation-focused-nav-xflow:creationFocusedNavXflowStartAt'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_START_AT
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$31a43870c77aad50),
    ...Object.values($3c94963df51c0e13$export$400b215814bf3fc0),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["PROMPT_DATABASE_COMPETITOR_LINK"] = $3c94963df51c0e13$export$5b471e2344a37be7;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["SIMPLIFY_NAV_NEW_USER"] = $3c94963df51c0e13$export$31a43870c77aad50;
module.exports["CFIND_5565_CREATION_FOCUSED_NAV_XFLOW"] = $3c94963df51c0e13$export$400b215814bf3fc0;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $cbOce = parcelRequire("cbOce");


var $1cHqV = parcelRequire("1cHqV");


var $8Z78B = parcelRequire("8Z78B");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");

const $6fc4b7bb962289cc$var$isOnboardingStateEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return !a && !b;
    if (a.length !== b.length) return false;
    return a.every((item, i)=>item.key === b[i].key && item.value === b[i].value);
};
// Hook to check if we're on a view page route
const $6fc4b7bb962289cc$var$useIsViewPageRoute = ()=>(0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
// Get the combined onboarding state from cache, returns null if not cached
const $6fc4b7bb962289cc$var$getCombinedQueryFromCache = ()=>{
    try {
        return (0, $l1uFv.readQueryInterop)({
            query: (0, $8Z78B.default),
            variables: {
                key: []
            },
            __callerPackage__: "@confluence/onboarding-helpers"
        });
    } catch  {
        return null;
    }
};
// Updates the combined query cache with new onboarding state values.
// This ensures components using the centralized cache see updates on next mount/navigation.
const $6fc4b7bb962289cc$var$updateCombinedQueryCache = (updatedStates)=>{
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return;
    const currentData = $6fc4b7bb962289cc$var$getCombinedQueryFromCache();
    if (!currentData?.onboardingState) return;
    const updatedMap = new Map(updatedStates.map((s)=>[
            s.key,
            s.value
        ]));
    const newOnboardingState = currentData.onboardingState.map((item)=>updatedMap.has(item.key) ? {
            ...item,
            value: updatedMap.get(item.key) ?? item.value
        } : item);
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        data: {
            onboardingState: newOnboardingState
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "@confluence/onboarding-helpers"
                });
            });
            // Update the combined query cache for centralized onboarding state
            $6fc4b7bb962289cc$var$updateCombinedQueryCache(states ?? []);
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    const setOnboardingState = (0, $42omo.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false, reactive = true)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const isViewPageRoute = $6fc4b7bb962289cc$var$useIsViewPageRoute();
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // Check if centralized cache should be used (experiment enabled + on view page route)
    const useCentralizedCache = isViewPageRoute && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false);
    // For non-reactive mode: read from cache once (no subscription)
    // This is a one-time synchronous read that doesn't trigger re-renders on cache changes
    const cachedCombinedData = !reactive && useCentralizedCache ? $6fc4b7bb962289cc$var$getCombinedQueryFromCache() : null;
    const hasCachedCombinedData = cachedCombinedData !== null;
    // For reactive mode: use useQueryInterop with cache-only to subscribe to cache changes
    // This subscribes to the centralized cache and re-renders when it changes (no network requests)
    const { data: reactiveCacheData, error: reactiveCacheError, loading: reactiveCacheLoading } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: []
        },
        skip: skipQuery || !reactive || !useCentralizedCache,
        fetchPolicy: 'cache-only',
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Memoize the filtered reactive cache result so filterOnboardingState is only called
    // when reactiveCacheData or key actually changes — not on every render.
    //
    // We must not skip the fallback just because reactiveCacheData is truthy — the centralized
    // cache may not contain the specific keys this consumer requested (e.g. the preload fetched
    // a different set of keys). We only skip the fallback when the filtered reactive cache data
    // actually has entries for the requested keys.
    const { reactiveFilteredData: reactiveFilteredData, reactiveFilteredHasData: reactiveFilteredHasData } = (0, $42omo.useMemo)(()=>{
        if (!(reactive && useCentralizedCache && reactiveCacheData)) return {
            reactiveFilteredData: null,
            reactiveFilteredHasData: false
        };
        const filtered = (0, $1cHqV.filterOnboardingState)(reactiveCacheData, key);
        return {
            reactiveFilteredData: filtered,
            reactiveFilteredHasData: (filtered?.onboardingState?.length ?? 0) > 0
        };
    }, [
        reactive,
        useCentralizedCache,
        reactiveCacheData,
        key
    ]);
    const { data: fallbackQueryData, error: fallbackError, loading: fallbackLoading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery || hasCachedCombinedData || reactiveFilteredHasData,
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Determine which data source to use:
    // 1. Non-reactive with cached data: use cachedCombinedData (filtered)
    // 2. Reactive with centralized cache and keys found: use reactiveFilteredData
    // 3. Fallback: use fallbackQueryData
    // For reactive path: skip re-render if filtered data for our keys hasn't changed
    const prevFilteredDataRef = (0, $42omo.useRef)(undefined);
    const data = (0, $42omo.useMemo)(()=>{
        if (hasCachedCombinedData) return (0, $1cHqV.filterOnboardingState)(cachedCombinedData, key);
        if (reactiveFilteredHasData && reactiveFilteredData) {
            if (prevFilteredDataRef.current && $6fc4b7bb962289cc$var$isOnboardingStateEqual(prevFilteredDataRef.current.onboardingState, reactiveFilteredData.onboardingState)) return prevFilteredDataRef.current;
            prevFilteredDataRef.current = reactiveFilteredData;
            return reactiveFilteredData;
        }
        return fallbackQueryData;
    }, [
        hasCachedCombinedData,
        cachedCombinedData,
        reactiveFilteredHasData,
        reactiveFilteredData,
        fallbackQueryData,
        key
    ]);
    // Combine error and loading states from both queries
    const error = reactiveCacheError || fallbackError;
    // When centralized cache is enabled in reactive mode but the preload hasn't populated
    // the cache yet, cache-only returns loading: false with data: undefined. Without this
    // guard, consumers interpret undefined data as "user never saw this onboarding" and
    // incorrectly show spotlights/changeboarding that was already dismissed.
    // We report loading: true until either the reactive cache or fallback has actual data.
    //
    // Also guard the case where the reactive cache is populated but doesn't contain the
    // specific keys this consumer requested (reactiveFilteredHasData is false). In that
    // scenario the fallback query has been allowed to run — keep loading: true until it
    // either returns data or an error, so consumers don't prematurely see empty state.
    const isCentralizedCacheWaitingForPreload = reactive && useCentralizedCache && (!reactiveCacheData || !reactiveFilteredHasData) && !fallbackQueryData && !skipQuery && !reactiveCacheError && !fallbackError;
    const loading = isCentralizedCacheWaitingForPreload || (reactive && useCentralizedCache ? reactiveCacheLoading : false) || fallbackLoading;
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState?.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<d76d95039bbf9cae17d368276aebc792>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("ceVeI", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $c9f3102bc65ac225$var$getExperimentValue = (extensionKey)=>{
    switch(extensionKey){
        case 'blog-posts':
            return (0, $6mKj3.expValEquals)('cc_rewrite_blog_posts_legacy_macro', 'isEnabled', true);
        case 'content-report-table':
            return (0, $6mKj3.expValEquals)('cc_rewrite_content-report-table', 'isEnabled', true);
        case 'contentbylabel':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contentbylabel_legacy_macro', 'isEnabled', true);
        case 'contributors':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
        case 'detailssummary':
        case 'profile':
        case 'profile-picture':
            return (0, $6mKj3.expValEquals)('cc_macro_full_ssr_support', 'isEnabled', true);
        case 'iframe':
            return (0, $6mKj3.expValEquals)('cc_rewrite_iframe_legacy_macro', 'isEnabled', true);
        case 'pagetree':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
        case 'pagetreesearch':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_search_legacy_macro', 'isEnabled', true);
        case 'popular-labels':
            return (0, $6mKj3.expValEquals)('cc_rewrite_popular_labels_legacy_macro', 'isEnabled', true);
        case 'recently-updated':
            return (0, $6mKj3.expValEquals)('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
        case 'viewpdf':
            return (0, $6mKj3.expValEquals)('cc_rewrite_viewpdf_macro', 'isEnabled', true);
        case 'widget':
            return (0, $6mKj3.expValEquals)('cc_rewrite_widget_legacy_macro', 'isEnabled', true);
        case 'attachments':
        case 'include':
        case 'tasks-report-macro':
        case 'change-history':
            return (0, $6mKj3.expValEquals)('cc_rewrite_legacy_macros_phase_2', 'isEnabled', true);
        default:
            return false;
    }
};
const $c9f3102bc65ac225$var$isMigratedMacroExtensionKey = (key)=>[
        'attachments',
        'blog-posts',
        'change-history',
        'content-report-table',
        'contributors',
        'detailssummary',
        'iframe',
        'include',
        'pagetree',
        'pagetreesearch',
        'recently-updated',
        'widget',
        'contentbylabel',
        'popular-labels',
        'profile',
        'profile-picture',
        'viewpdf',
        'tasks-report-macro'
    ].includes(key);
const $c9f3102bc65ac225$export$95a5e4cb1c9fae51 = (extensionKey)=>{
    const overrideList = (0, $1xpoY.default).getStringList('cc_macro_override_to_legacy_renderer', []);
    if (overrideList.includes(extensionKey)) return false;
    if (!$c9f3102bc65ac225$var$isMigratedMacroExtensionKey(extensionKey)) return false;
    return $c9f3102bc65ac225$var$getExperimentValue(extensionKey);
};
module.exports["isMigratedMacroImplEnabled"] = $c9f3102bc65ac225$export$95a5e4cb1c9fae51;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("yuV6Z", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $dh538.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("k2in1", function(module, exports) {
const $70107457754d8ab2$var$MAX_RETRY_DELAY = 30000;
const $70107457754d8ab2$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $70107457754d8ab2$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $70107457754d8ab2$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $70107457754d8ab2$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $70107457754d8ab2$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $70107457754d8ab2$export$cffaac380b94df26;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<79c814000abc51a87825021048515fd1>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "031eb89bf77537fd501cf18345136db8";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $lMdlY = parcelRequire("lMdlY");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $5spQU.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $lzcvT.isFedRamp)() && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("hrSFW", function(module, exports) {
var $cb3f5eae1efed147$var$has = Object.prototype.hasOwnProperty;
function $cb3f5eae1efed147$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $cb3f5eae1efed147$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($cb3f5eae1efed147$var$has.call(foo, ctor) && ++len && !$cb3f5eae1efed147$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$cb3f5eae1efed147$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $cb3f5eae1efed147$export$de8294bb3be0322f;

});

parcelRegister("3uVVG", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => (parcelRequire("uvNb9")).AuthError);

var $uvNb9 = parcelRequire("uvNb9");


var $9P47v = parcelRequire("9P47v");

function $81514351a4f15f99$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $9P47v.isOfTypeAuthError)(errorType)) reject(new (0, $uvNb9.AuthError)(data.message, errorType));
                    else reject(new (0, $uvNb9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $uvNb9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $81514351a4f15f99$export$73693bad9f5880b0;

});

parcelRegister("uvNb9", function(module, exports) {
class $2c5766e42a4da15d$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $2c5766e42a4da15d$export$145273558d58e0ac;

});

parcelRegister("9P47v", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $cd3cb472abe3f4ba$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $cd3cb472abe3f4ba$export$400e64c8451aa84f;

});

parcelRegister("4JDbp", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $b400565b9de87bc3$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7RGj.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$var$WidthObserver;
module.exports["default"] = $b400565b9de87bc3$export$2e2bcd8739ae039;

});

parcelRegister("i7RGj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $5EteX.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $63cd7642b16dfa22$export$2f62ee6831462844 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $frIzR.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("9JpPs", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $frIzR.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("cTQmR", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $a6db6a3439cd9017$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $a6db6a3439cd9017$export$7c77c3a9bb93870d;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("9SMct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8jHAi = parcelRequire("8jHAi");


var $7CgcZ = parcelRequire("7CgcZ");

const $3c9171fc16956912$var$PageIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), 'blueBold');
$3c9171fc16956912$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $3c9171fc16956912$export$2e2bcd8739ae039 = $3c9171fc16956912$var$PageIconWithColor;
module.exports["default"] = $3c9171fc16956912$export$2e2bcd8739ae039;

});

parcelRegister("7CgcZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7642E = parcelRequire("7642E");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");

/**
 * Maps IconTile appearance to the icon glyph color token to use when rendering
 * a standalone icon (without a tile background).
 */ const $6846287c8ee6bf50$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $6846287c8ee6bf50$export$3acc3fb10995f020 = (size)=>{
    if ((0, $dh538.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $5TXU5.SmartLinkSize).Small:
        case (0, $5TXU5.SmartLinkSize).Medium:
            return undefined;
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            // SmartLinkSize.Small, SmartLinkSize.Medium, and undefined all
            // previously mapped to size="16" which has been removed. Render
            // the icon directly (no tile) for these sizes.
            return undefined;
    }
};
const $6846287c8ee6bf50$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ((0, $ivUmx.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectIcon, props);
    };
};
const $6846287c8ee6bf50$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = $6846287c8ee6bf50$export$3acc3fb10995f020(size);
        if (tileSize === undefined) {
            // size="16" has been removed — render the icon directly without a tile,
            // using the appearance-derived color so it still matches the intended style.
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                color: $6846287c8ee6bf50$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { shape: _shape, UNSAFE_circleReplacementComponent: _unsafe, ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $6846287c8ee6bf50$export$3acc3fb10995f020;
module.exports["renderIconPerSize"] = $6846287c8ee6bf50$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $6846287c8ee6bf50$export$87c3646d0e299cfe;

});

parcelRegister("7642E", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $XOZYy = parcelRequire("XOZYy");


const $52ac3a8ba658d4f5$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
 * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
 *
 * This provides a lightweight replacement for the legacy Icon component that
 * was removed in DSP-24550. Instead of wrapping the glyph in a span with
 * complex styling, it simply renders the glyph component directly, passing
 * through relevant props.
 *
 * This is NOT a public API — it exists solely to unblock the removal of
 * deprecated icon APIs from @atlaskit/icon.
 */ const React = (parcelRequire("42omo"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $XOZYy, {
    default: $52ac3a8ba658d4f5$var$_inlined0
});
if ($XOZYy.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("i7jPX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $6421b29072e9fbe0$var$Tile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $frIzR.c)(12);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const t2 = label !== "" ? label : undefined;
    const t3 = label !== "" ? "img" : undefined;
    const t4 = $6421b29072e9fbe0$var$sizeMap[size];
    const t5 = isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset;
    const t6 = isInset && $6421b29072e9fbe0$var$insetSizeMap[size];
    const t7 = $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t8 = hasBorder && $6421b29072e9fbe0$var$styles.border;
    let t9;
    if ($[0] !== t4 || $[1] !== t5 || $[2] !== t6 || $[3] !== t7 || $[4] !== t8) {
        t9 = (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            t4,
            t5,
            t6,
            t7,
            t8
        ]);
        $[0] = t4;
        $[1] = t5;
        $[2] = t6;
        $[3] = t7;
        $[4] = t8;
        $[5] = t9;
    } else t9 = $[5];
    let t10;
    if ($[6] !== children || $[7] !== t2 || $[8] !== t3 || $[9] !== t9 || $[10] !== testId) {
        t10 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": testId,
            "aria-label": t2,
            role: t3,
            className: t9
        }, children);
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
        $[9] = t9;
        $[10] = testId;
        $[11] = t10;
    } else t10 = $[11];
    return t10;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ])
    }, children);
};
var $6421b29072e9fbe0$export$2e2bcd8739ae039 = $6421b29072e9fbe0$var$Tile;
module.exports["default"] = $6421b29072e9fbe0$export$2e2bcd8739ae039;

});

parcelRegister("kXb3C", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

/**
 * __Object base__
 *
 * An object represents an Atlassian-specific content type.
 *
 */ const $5412502140f64e3a$var$ObjectBase = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ObjectBase(t0) {
    const $ = (0, $frIzR.c)(6);
    const { label: t1, size: t2, testId: testId, color: color, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const t3 = size === "medium" ? "medium" : "small";
    let t4;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== t3 || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            size: t3,
            color: color,
            testId: testId
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = t3;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function ObjectBase({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
};
var $5412502140f64e3a$export$2e2bcd8739ae039 = $5412502140f64e3a$var$ObjectBase;
module.exports["default"] = $5412502140f64e3a$export$2e2bcd8739ae039;

});

parcelRegister("fP78j", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $fce53c8d1c9f5417$var$ObjectTileBase = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $frIzR.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size
        }, t3);
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
};
var $fce53c8d1c9f5417$export$2e2bcd8739ae039 = $fce53c8d1c9f5417$var$ObjectTileBase;
module.exports["default"] = $fce53c8d1c9f5417$export$2e2bcd8739ae039;

});

parcelRegister("l5jcq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $kXb3C = parcelRequire("kXb3C");

const $6c7fb5a91851c05d$var$BugObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $6c7fb5a91851c05d$export$2e2bcd8739ae039 = $6c7fb5a91851c05d$var$BugObject;
module.exports["default"] = $6c7fb5a91851c05d$export$2e2bcd8739ae039;

});

parcelRegister("2tvDK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $fP78j = parcelRequire("fP78j");

const $ab5e2ffbeed9f2f4$var$BugObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039 = $ab5e2ffbeed9f2f4$var$BugObjectTile;
module.exports["default"] = $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039;

});

parcelRegister("8d3zB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $kXb3C = parcelRequire("kXb3C");

const $487ca0b42e22d1f4$var$WorkItemObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $487ca0b42e22d1f4$export$2e2bcd8739ae039 = $487ca0b42e22d1f4$var$WorkItemObject;
module.exports["default"] = $487ca0b42e22d1f4$export$2e2bcd8739ae039;

});

parcelRegister("kMqyt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $fP78j = parcelRequire("fP78j");

const $cb2f9539166b293e$var$WorkItemObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $cb2f9539166b293e$export$2e2bcd8739ae039 = $cb2f9539166b293e$var$WorkItemObjectTile;
module.exports["default"] = $cb2f9539166b293e$export$2e2bcd8739ae039;

});

parcelRegister("9J3bP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $kXb3C = parcelRequire("kXb3C");

const $458cec0faf8f188b$var$StoryObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $458cec0faf8f188b$export$2e2bcd8739ae039 = $458cec0faf8f188b$var$StoryObject;
module.exports["default"] = $458cec0faf8f188b$export$2e2bcd8739ae039;

});

parcelRegister("lWQXA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $fP78j = parcelRequire("fP78j");

const $d00f1f002e9877f9$var$StoryObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $d00f1f002e9877f9$export$2e2bcd8739ae039 = $d00f1f002e9877f9$var$StoryObjectTile;
module.exports["default"] = $d00f1f002e9877f9$export$2e2bcd8739ae039;

});

parcelRegister("7G33r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $kXb3C = parcelRequire("kXb3C");

const $b1b906ca2447e962$var$TaskObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $b1b906ca2447e962$export$2e2bcd8739ae039 = $b1b906ca2447e962$var$TaskObject;
module.exports["default"] = $b1b906ca2447e962$export$2e2bcd8739ae039;

});

parcelRegister("fX4W8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $fP78j = parcelRequire("fP78j");

const $042d51f21cf4898d$var$TaskObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $042d51f21cf4898d$export$2e2bcd8739ae039 = $042d51f21cf4898d$var$TaskObjectTile;
module.exports["default"] = $042d51f21cf4898d$export$2e2bcd8739ae039;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("j6GAe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

const $90028f2cad692a01$var$BlogObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $90028f2cad692a01$export$2e2bcd8739ae039 = $90028f2cad692a01$var$BlogObjectTile;
module.exports["default"] = $90028f2cad692a01$export$2e2bcd8739ae039;

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

const $893c7e3925139b9a$var$PageLiveDocObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $893c7e3925139b9a$export$2e2bcd8739ae039 = $893c7e3925139b9a$var$PageLiveDocObject;
module.exports["default"] = $893c7e3925139b9a$export$2e2bcd8739ae039;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("fAGae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

const $0f3b40ffeda05888$var$PageLiveDocObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $0f3b40ffeda05888$export$2e2bcd8739ae039 = $0f3b40ffeda05888$var$PageLiveDocObjectTile;
module.exports["default"] = $0f3b40ffeda05888$export$2e2bcd8739ae039;

});

parcelRegister("7gpC4", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $frIzR.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $42omo.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $gMc0m.default)([
            $1f9fb6b4b3bc4020$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ $42omo.createElement("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ $42omo.createElement((0, $6MlG5.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ $42omo.createElement((0, $cVrnQ.default), null, label, isRequired && /*#__PURE__*/ $42omo.createElement((0, $hcDON.default), null));
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ $42omo.createElement((0, $9wgn8.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss
        }, t16, t17, t18);
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $42omo.createElement("input" // It is necessary only for Safari. It allows to render focus styles.
    , {
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        className: (0, $gMc0m.default)([
            $1f9fb6b4b3bc4020$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $42omo.createElement((0, $6MlG5.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $42omo.createElement((0, $cVrnQ.default), null, label, isRequired && /*#__PURE__*/ $42omo.createElement((0, $hcDON.default), null)));
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = t0;
    let t1;
    if ($[0] !== isChecked || $[1] !== isIndeterminate) {
        t1 = $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked);
        $[0] = isChecked;
        $[1] = isIndeterminate;
        $[2] = t1;
    } else t1 = $[2];
    const icon = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $42omo.createElement("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            className: (0, $gMc0m.default)([
                $71feb0a29953fded$var$svgStyles.rect
            ])
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== icon) {
        t4 = /*#__PURE__*/ $42omo.createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            role: "presentation",
            className: t2
        }, /*#__PURE__*/ $42omo.createElement("g", {
            fillRule: "evenodd"
        }, t3, icon));
        $[5] = icon;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $42omo.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.rect
        ])
    }), icon));
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
const $edf27753e59bf881$var$Label = (0, $4pOgL.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $frIzR.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_zulp1nu5 _yv0ey09t";
    const t2 = (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz";
    const t3 = isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2";
    const t4 = isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ $42omo.createElement("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id
        }, children);
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $42omo.createElement("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
};
var $edf27753e59bf881$export$2e2bcd8739ae039 = $edf27753e59bf881$var$Label;
module.exports["default"] = $edf27753e59bf881$export$2e2bcd8739ae039;

});

parcelRegister("cVrnQ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
const $f0c2060f65a94bd0$var$LabelText = (0, $4pOgL.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
};
var $f0c2060f65a94bd0$export$2e2bcd8739ae039 = $f0c2060f65a94bd0$var$LabelText;
module.exports["default"] = $f0c2060f65a94bd0$export$2e2bcd8739ae039;

});

parcelRegister("hcDON", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
const $a14852587cdb2524$var$RequiredIndicator = (0, $4pOgL.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("span", {
            "aria-hidden": true,
            className: (0, $gMc0m.default)([
                "_syaz1tmw _bozgv77o"
            ])
        }, "*");
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ $42omo.createElement("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
};
var $a14852587cdb2524$export$2e2bcd8739ae039 = $a14852587cdb2524$var$RequiredIndicator;
module.exports["default"] = $a14852587cdb2524$export$2e2bcd8739ae039;

});

parcelRegister("226XV", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $15C2j = parcelRequire("15C2j");

const $c8f51fccdd166527$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $c8f51fccdd166527$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $15C2j.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $c8f51fccdd166527$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $c8f51fccdd166527$export$218d96312e385949 = (details)=>details?.meta?.key;
const $c8f51fccdd166527$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $c8f51fccdd166527$export$e029950864672b4 = (details)=>{
    if ((0, $dh538.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $c8f51fccdd166527$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $dh538.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $c8f51fccdd166527$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $c8f51fccdd166527$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $c8f51fccdd166527$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $c8f51fccdd166527$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $c8f51fccdd166527$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $c8f51fccdd166527$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $c8f51fccdd166527$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $c8f51fccdd166527$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $c8f51fccdd166527$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $c8f51fccdd166527$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $c8f51fccdd166527$export$ac5d414b1ebfab5a = (details)=>details && $c8f51fccdd166527$export$cd41ae544cfc2a65(details) && $c8f51fccdd166527$export$795910f5f15a9633(details);
const $c8f51fccdd166527$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $c8f51fccdd166527$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $c8f51fccdd166527$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $c8f51fccdd166527$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $c8f51fccdd166527$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $c8f51fccdd166527$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $c8f51fccdd166527$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $c8f51fccdd166527$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $c8f51fccdd166527$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getByDefinitionId"] = $c8f51fccdd166527$export$f75b0b690ab4dfb9;
module.exports["getClickUrl"] = $c8f51fccdd166527$export$cf3c5acf9e9d0f02;
module.exports["getDefinitionId"] = $c8f51fccdd166527$export$46fa3e7718c82e41;
module.exports["getExtensionKey"] = $c8f51fccdd166527$export$218d96312e385949;
module.exports["getObjectAri"] = $c8f51fccdd166527$export$81164c1570bcd038;
module.exports["getThirdPartyARI"] = $c8f51fccdd166527$export$e029950864672b4;
module.exports["getFirstPartyIdentifier"] = $c8f51fccdd166527$export$48b4e58cdb8031ba;
module.exports["getObjectName"] = $c8f51fccdd166527$export$5615361d76a8be5;
module.exports["getObjectIconUrl"] = $c8f51fccdd166527$export$bcf275804417edda;
module.exports["getResourceType"] = $c8f51fccdd166527$export$16c0ebb0de9b767b;
module.exports["getServices"] = $c8f51fccdd166527$export$a009e3a1163d46fb;
module.exports["isFinalState"] = $c8f51fccdd166527$export$d590d08942abc17a;
module.exports["hasAuthScopeOverrides"] = $c8f51fccdd166527$export$3f9446bb21b945a0;

});

parcelRegister("15C2j", function(module, exports) {
const $4a791b5829124355$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};
module.exports["extractVisitUrl"] = $4a791b5829124355$export$c81497d3681f24f4;

});

parcelRegister("I1nNR", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { children: children, locale: t1, fetchTranslations: fetchTranslations } = t0;
    const incomingLocale = t1 === undefined ? (0, $chRg6.DEFAULT_LOCALE) : t1;
    const [messages, setMessages] = (0, $42omo.useState)();
    let t2;
    if ($[0] !== incomingLocale) {
        t2 = (0, $chRg6.normalizeLocale)(incomingLocale);
        $[0] = incomingLocale;
        $[1] = t2;
    } else t2 = $[1];
    const locale = t2;
    let t3;
    let t4;
    if ($[2] !== fetchTranslations || $[3] !== locale) {
        t3 = ()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        };
        t4 = [
            fetchTranslations,
            locale
        ];
        $[2] = fetchTranslations;
        $[3] = locale;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    if (!messages) return null;
    let t5;
    if ($[6] !== children || $[7] !== locale || $[8] !== messages) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, $chRg6.DEFAULT_LOCALE)
        }, children);
        $[6] = children;
        $[7] = locale;
        $[8] = messages;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("hpNab", function(module, exports) {

var $kFwgS = parcelRequire("kFwgS");


var $9tQM5 = parcelRequire("9tQM5");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("cGc86", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $diaaX.createUniqueKey)();
        $[0] = t1;
    } else t1 = $[0];
    const uniqueKey = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            uniqueKey: uniqueKey
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        }
    }, children);
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
} : ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("kudeD", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        }
    }, children);
};
const $0a26766864270169$export$865423e6f8e2e839 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
} : ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { children: children, contentType: contentType, sourceComponent: sourceComponent } = t0;
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    let t1;
    let t2;
    if ($[0] !== contentType || $[1] !== isInitialized || $[2] !== setContentType) {
        t1 = ()=>{
            isInitialized && contentType && setContentType(contentType);
        };
        t2 = [
            isInitialized,
            contentType,
            setContentType
        ];
        $[0] = contentType;
        $[1] = isInitialized;
        $[2] = setContentType;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[5] !== children || $[6] !== contentType || $[7] !== isInitialized || $[8] !== sourceComponent) {
        t3 = !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a26766864270169$var$Provider, {
            contentType: contentType,
            sourceComponent: sourceComponent
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[5] = children;
        $[6] = contentType;
        $[7] = isInitialized;
        $[8] = sourceComponent;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2LONO = parcelRequire("2LONO");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $aXWIB = parcelRequire("aXWIB");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $2LONO.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$serializeQueryParams = (queryParams)=>queryParams ? new URLSearchParams(Object.entries(queryParams).sort(([paramA], [paramB])=>paramA.localeCompare(paramB))).toString() : '';
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, queryParams: consumerQueryParams, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature_0)=>feature_0 !== 'edit' && feature_0 !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature_1)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature_1)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature_2)=>(0, $cezNv.isRedirectionEnabled)(feature_2)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const consumerQueryParamsString = $5a8d62fce039da42$var$serializeQueryParams(consumerQueryParams);
    const contentConfigurationQueryParamsString = $5a8d62fce039da42$var$serializeQueryParams(contentConfiguration?.queryParams);
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        const searchParams = new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery
        });
        new URLSearchParams(consumerQueryParamsString).forEach((value, key)=>{
            if (!searchParams.has(key)) searchParams.set(key, value);
        });
        new URLSearchParams(contentConfigurationQueryParamsString).forEach((value_0, key_0)=>{
            searchParams.set(key_0, value_0);
        });
        return `?${searchParams.toString()}`;
    }, [
        consumerQueryParamsString,
        contentConfigurationQueryParamsString,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $d21a741e0de1277a$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $d21a741e0de1277a$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$d21a741e0de1277a$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $d21a741e0de1277a$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("l3dur", function(module, exports) {
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $2Gb84 = parcelRequire("2Gb84");

const $8a7492fb362aaff8$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
$8a7492fb362aaff8$var$linkify.add('sourcetree:', 'http:');
$8a7492fb362aaff8$var$linkify.add('jamfselfservice:', 'http:');
$8a7492fb362aaff8$var$linkify.add('notes:', 'http:');
const $8a7492fb362aaff8$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8a7492fb362aaff8$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8a7492fb362aaff8$var$tlds.push($8a7492fb362aaff8$var$tlds2Char);
$8a7492fb362aaff8$var$linkify.tlds($8a7492fb362aaff8$var$tlds, false);
const $8a7492fb362aaff8$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8a7492fb362aaff8$var$normaliseLinkHref = (url)=>{
    const match = $8a7492fb362aaff8$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8a7492fb362aaff8$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8a7492fb362aaff8$export$6f7d7761b97f967(str);
    if (!match.length) match = $8a7492fb362aaff8$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8a7492fb362aaff8$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8a7492fb362aaff8$export$6f7d7761b97f967 = (text)=>{
    const matches = [];
    if (!$8a7492fb362aaff8$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8a7492fb362aaff8$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8a7492fb362aaff8$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
        } else break;
    }
    return matches;
};
const $8a7492fb362aaff8$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8a7492fb362aaff8$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8a7492fb362aaff8$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8a7492fb362aaff8$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8a7492fb362aaff8$var$normaliseLinkHref(urlWithoutNewlines);
}
module.exports["isSafeUrl"] = $8a7492fb362aaff8$export$c9f92f5469372e0f;
module.exports["normalizeUrl"] = $8a7492fb362aaff8$export$6535eb414fa2c8b6;

});

parcelRegister("keVvA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

const $36f6a30267bec70f$var$IntlMessagesProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $frIzR.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $36f6a30267bec70f$export$2e2bcd8739ae039 = $36f6a30267bec70f$var$IntlMessagesProvider;
module.exports["default"] = $36f6a30267bec70f$export$2e2bcd8739ae039;

});

parcelRegister("e9OZ6", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $frIzR.c)(4);
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $e1a1ee666860bb23$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    (0, $42omo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $e1a1ee666860bb23$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $aXWIB.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) return (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("3wgAM", function(module, exports) {

var $2LrJx = parcelRequire("2LrJx");


var $5Nw7l = parcelRequire("5Nw7l");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $29013b23581f9040$var$pick = $5Nw7l(function(object, paths) {
    return object == null ? {} : $2LrJx(object, paths);
});
module.exports = $29013b23581f9040$var$pick;

});

parcelRegister("2LrJx", function(module, exports) {

var $egNUN = parcelRequire("egNUN");


var $7U49l = parcelRequire("7U49l");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $20357bdd9d2fadfb$var$basePick(object, paths) {
    return $egNUN(object, paths, function(value, path) {
        return $7U49l(object, path);
    });
}
module.exports = $20357bdd9d2fadfb$var$basePick;

});

parcelRegister("7HI7Y", function(module, exports) {
$parcel$export(module.exports, "merge", () => $59bec75d4837f566$export$4950aa0f605343fb, (v) => $59bec75d4837f566$export$4950aa0f605343fb = v);
var $59bec75d4837f566$export$4950aa0f605343fb;
"use strict";

var $YgydF = parcelRequire("YgydF");


var $HHFyQ = parcelRequire("HHFyQ");


var $5Dgek = parcelRequire("5Dgek");


var $kQ0lo = parcelRequire("kQ0lo");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $59bec75d4837f566$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($5Dgek.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $YgydF.Observable) return observables[0];
    return $kQ0lo.mergeAll(concurrent)(new $HHFyQ.ArrayObservable(observables, scheduler));
}
$59bec75d4837f566$export$4950aa0f605343fb = $59bec75d4837f566$var$merge;

});

parcelRegister("kQ0lo", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $f2b8ee495d9150ab$export$18aef43295bbe906, (v) => $f2b8ee495d9150ab$export$18aef43295bbe906 = v);
var $f2b8ee495d9150ab$export$18aef43295bbe906;
"use strict";

var $XrDsM = parcelRequire("XrDsM");


var $hsCka = parcelRequire("hsCka");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $f2b8ee495d9150ab$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $XrDsM.mergeMap($hsCka.identity, null, concurrent);
}
$f2b8ee495d9150ab$export$18aef43295bbe906 = $f2b8ee495d9150ab$var$mergeAll;

});

parcelRegister("hsCka", function(module, exports) {
$parcel$export(module.exports, "identity", () => $cb62c79807c8a85d$export$f0954fd7d5368655, (v) => $cb62c79807c8a85d$export$f0954fd7d5368655 = v);
var $cb62c79807c8a85d$export$f0954fd7d5368655;
"use strict";
function $cb62c79807c8a85d$var$identity(x) {
    return x;
}
$cb62c79807c8a85d$export$f0954fd7d5368655 = $cb62c79807c8a85d$var$identity;

});

parcelRegister("eVpDl", function(module, exports) {
"use strict";
var $adda45daebf3b6ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $adda45daebf3b6ff$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $adda45daebf3b6ff$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $adda45daebf3b6ff$var$filter;
var $adda45daebf3b6ff$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $adda45daebf3b6ff$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $adda45daebf3b6ff$var$FilterSubscriber = function(_super) {
    $adda45daebf3b6ff$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($axeml.Subscriber);

});

parcelRegister("kXEyd", function(module, exports) {
"use strict";
var $f428c5e2ee2b390f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $f428c5e2ee2b390f$var$take(count) {
    return function(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $f428c5e2ee2b390f$var$TakeOperator(count));
    };
}
module.exports.take = $f428c5e2ee2b390f$var$take;
var $f428c5e2ee2b390f$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f428c5e2ee2b390f$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f428c5e2ee2b390f$var$TakeSubscriber = function(_super) {
    $f428c5e2ee2b390f$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($axeml.Subscriber);

});

parcelRegister("2g0GA", function(module, exports) {
"use strict";
var $1a4d9b96869ee1a1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError = function(_super) {
    $1a4d9b96869ee1a1$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError;

});

parcelRegister("1Ria2", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $15a8d410ba774044$export$45b10814cc054894, (v) => $15a8d410ba774044$export$45b10814cc054894 = v);
var $15a8d410ba774044$export$45b10814cc054894;
"use strict";

var $244gB = parcelRequire("244gB");

function $15a8d410ba774044$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $15a8d410ba774044$var$toArray() {
    return $244gB.reduce($15a8d410ba774044$var$toArrayReducer, []);
}
$15a8d410ba774044$export$45b10814cc054894 = $15a8d410ba774044$var$toArray;

});

parcelRegister("244gB", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $180f43c63924c6e6$export$533b26079ad0b4b, (v) => $180f43c63924c6e6$export$533b26079ad0b4b = v);
var $180f43c63924c6e6$export$533b26079ad0b4b;
"use strict";

var $kiSup = parcelRequire("kiSup");


var $ib5HR = parcelRequire("ib5HR");


var $avZwt = parcelRequire("avZwt");


var $5wWzN = parcelRequire("5wWzN");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $180f43c63924c6e6$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $5wWzN.pipe($kiSup.scan(accumulator, seed), $ib5HR.takeLast(1), $avZwt.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $5wWzN.pipe($kiSup.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $ib5HR.takeLast(1))(source);
    };
}
$180f43c63924c6e6$export$533b26079ad0b4b = $180f43c63924c6e6$var$reduce;

});

parcelRegister("kiSup", function(module, exports) {
"use strict";
var $ec7fc18d41270381$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $ec7fc18d41270381$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $ec7fc18d41270381$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $ec7fc18d41270381$var$scan;
var $ec7fc18d41270381$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ec7fc18d41270381$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ec7fc18d41270381$var$ScanSubscriber = function(_super) {
    $ec7fc18d41270381$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ib5HR", function(module, exports) {
"use strict";
var $d3bdae4589ae3cf1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $d3bdae4589ae3cf1$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $d3bdae4589ae3cf1$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $d3bdae4589ae3cf1$var$takeLast;
var $d3bdae4589ae3cf1$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d3bdae4589ae3cf1$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d3bdae4589ae3cf1$var$TakeLastSubscriber = function(_super) {
    $d3bdae4589ae3cf1$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($axeml.Subscriber);

});

parcelRegister("avZwt", function(module, exports) {
"use strict";
var $7a7c85c9732247d4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $7a7c85c9732247d4$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $7a7c85c9732247d4$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $7a7c85c9732247d4$var$defaultIfEmpty;
var $7a7c85c9732247d4$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7a7c85c9732247d4$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7a7c85c9732247d4$var$DefaultIfEmptySubscriber = function(_super) {
    $7a7c85c9732247d4$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($axeml.Subscriber);

});

parcelRegister("hu8We", function(module, exports) {
$parcel$export(module.exports, "of", () => $cbac2bf0af029aab$export$ba255e9e49e00608, (v) => $cbac2bf0af029aab$export$ba255e9e49e00608 = v);
var $cbac2bf0af029aab$export$ba255e9e49e00608;
"use strict";

var $HHFyQ = parcelRequire("HHFyQ");

$cbac2bf0af029aab$export$ba255e9e49e00608 = $HHFyQ.ArrayObservable.of;

});

parcelRegister("fulrs", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6j5QO = parcelRequire("6j5QO");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteDelay = $kVeeY.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($6j5QO.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($6j5QO.Notification.createComplete());
    };
    return DelaySubscriber;
}($axeml.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});

parcelRegister("3u6GG", function(module, exports) {
$parcel$export(module.exports, "async", () => $28995c6d2039be6b$export$12af436354f1a4f7, (v) => $28995c6d2039be6b$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $28995c6d2039be6b$export$12af436354f1a4f7;
"use strict";

var $k8JsH = parcelRequire("k8JsH");


var $iOeLv = parcelRequire("iOeLv");

$28995c6d2039be6b$export$12af436354f1a4f7 = new $iOeLv.AsyncScheduler($k8JsH.AsyncAction);

});

parcelRegister("kVeeY", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $f3b42d67f4ad5339$export$871608497c498473, (v) => $f3b42d67f4ad5339$export$871608497c498473 = v);
var $f3b42d67f4ad5339$export$871608497c498473;
"use strict";
function $f3b42d67f4ad5339$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$f3b42d67f4ad5339$export$871608497c498473 = $f3b42d67f4ad5339$var$isDate;

});

parcelRegister("9k33u", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $grxv4.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("jRNsq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("hYoU4", function(module, exports) {

var $3wgAM = parcelRequire("3wgAM");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $1P1Tu.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $FOT9i.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $9zUhf.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("bre0g", function(module, exports) {

var $i5qfp = parcelRequire("i5qfp");

class $1d9210071da756d7$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $i5qfp.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $1d9210071da756d7$export$2e2bcd8739ae039;

});

parcelRegister("i5qfp", function(module, exports) {
async function $953ad04814dc1360$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
module.exports["getAutoConvertPatternsFromModule"] = $953ad04814dc1360$export$60407594ea5edd1c;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
var $4440a0699c7a4c4d$export$6a393d893fab1730 = /*#__PURE__*/ function(SidebarTabValues) {
    SidebarTabValues["COMMENTS"] = "COMMENTS";
    SidebarTabValues["SUGGESTIONS"] = "SUGGESTIONS";
    return SidebarTabValues;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        isCurrentlySelectedThreadOptimisticallyAdded: false,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false,
            ["MENTIONS_ME"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        replyToContributorUsers: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null,
        currentSidebarTab: "COMMENTS",
        triggerOnDemandSummary: false,
        isSummaryDismissedByUser: false,
        automaticSummariesPreference: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType, isOptimisticAddSuccess)=>({ getState: getState, setState: setState })=>{
            const { currentlySelectedThreadKey: currentlySelectedThreadKey } = getState();
            if (!!isOptimisticAddSuccess && commentType === (0, $8i27m.CommentType).GENERAL && currentlySelectedThreadKey !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) // This means that user has selected a different comment thread
            // after new comment was optimistically added on UI but before
            // the GQL mutation succeeded. In this case, we shouldn't set
            // currentlySelectedThreadKey to the new comment.
            return;
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType,
                // Note: Added for COMMENTS-6792: Optimistically adding a footer comment.
                // When adding a footer comment optimistically, setCurrentlySelectedThreadKey is
                // called twice: once when the comment is added to UI optimistically with a fake id,
                // and once more when the mutation succeeds and UI is updated with the actual id.
                // The effect of the second call is rendered on UI before the updated comment list
                // is rendered, which causes a visible flicker, where the new comment goes from
                // "selected" -> "unselected" (for an instant) -> "selected" again.
                // To fix this flicker, we keep showing the comment with fake id as "selected" when
                // this flag is true, even if value of `currentlySelectedThreadKey` has changed.
                isCurrentlySelectedThreadOptimisticallyAdded: commentType === (0, $8i27m.CommentType).GENERAL && !!isOptimisticAddSuccess
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user, contributorUsers: contributorUsers } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user,
                replyToContributorUsers: contributorUsers
            });
        },
    setReplyToContributorUsers: (users)=>({ setState: setState })=>{
            setState({
                replyToContributorUsers: users
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        },
    setCurrentSidebarTab: (tab)=>({ setState: setState })=>{
            setState({
                currentSidebarTab: tab
            });
        },
    setTriggerOnDemandSummary: (triggerOnDemandSummary)=>({ setState: setState })=>{
            setState({
                triggerOnDemandSummary: triggerOnDemandSummary
            });
        },
    setIsSummaryDismissedByUser: (isSummaryDismissedByUser)=>({ setState: setState })=>{
            setState({
                isSummaryDismissedByUser: isSummaryDismissedByUser
            });
        },
    setAutomaticSummariesPreference: (automaticSummariesPreference)=>({ setState: setState })=>{
            setState({
                automaticSummariesPreference: automaticSummariesPreference
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["SidebarTabValues"] = $4440a0699c7a4c4d$export$6a393d893fab1730;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $kDhla = parcelRequire("kDhla");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("3Qron"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("6Qt0n"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("6PB7O"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("5opnM"))).CommentsPanelWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uSRQM",
    name: "CommentsPanelFooterWrapper",
    loader: async ()=>(await (parcelRequire("bvUYT"))).CommentsPanelFooterWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderActions = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4wZwH",
    name: "CommentsPanelHeaderActions",
    loader: async ()=>(await (parcelRequire("egmJr"))).CommentsPanelHeaderActions
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    },
    discussionsPanelHeaderLabel: {
        id: "comments-panel.panel.header.discussions.label",
        defaultMessage: "Discussions"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderActions.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { currentSidebarTab: currentSidebarTab } = (0, $3mVfX.useCommentsPanelState)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId, setCurrentSidebarTab: setCurrentSidebarTab } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    (0, $42omo.useEffect)(()=>{
        fullPageEditorPresetAPI?.aiSuggestions?.actions.setUIVisibility(isObjectSidebarShown);
    }, [
        isObjectSidebarShown,
        fullPageEditorPresetAPI
    ]);
    // Track whether the Suggestions tab was visited during this sidebar session,
    // so we can keep the suggestion node selected in the editor after close
    // (regardless of which tab is active when the panel is dismissed).
    const hadSuggestionsTabRef = (0, $42omo.useRef)(false);
    // Track the previous value of currentSidebarTab so we can detect when the
    // user actively switches *away from* the Suggestions tab (as opposed to
    // the tab simply being COMMENTS when the sidebar first opens).
    const prevSidebarTabRef = (0, $42omo.useRef)(currentSidebarTab);
    // When the sidebar finishes closing, reset the session flag and the tab
    // back to COMMENTS so subsequent non-suggestion opens start clean.
    (0, $42omo.useEffect)(()=>{
        if (!isObjectSidebarShown) {
            hadSuggestionsTabRef.current = false;
            setCurrentSidebarTab?.((0, $3mVfX.SidebarTabValues).COMMENTS);
        }
    }, [
        isObjectSidebarShown,
        setCurrentSidebarTab
    ]);
    (0, $42omo.useEffect)(()=>{
        const prevTab = prevSidebarTabRef.current;
        if (currentSidebarTab === (0, $3mVfX.SidebarTabValues).SUGGESTIONS) hadSuggestionsTabRef.current = true;
        // Only deselect the suggestion when the user actively switches away
        // from the Suggestions tab (prev was SUGGESTIONS, now it is not).
        // This avoids deselecting on initial sidebar open (where prev and
        // current are both COMMENTS) and on sidebar close.
        if (prevTab === (0, $3mVfX.SidebarTabValues).SUGGESTIONS && currentSidebarTab !== (0, $3mVfX.SidebarTabValues).SUGGESTIONS && isObjectSidebarShown) fullPageEditorPresetAPI?.aiSuggestions?.actions.selectSuggestion(null, {
            interactionPoint: 'sidebar'
        });
        // Update prev ref *after* checking it
        prevSidebarTabRef.current = currentSidebarTab;
    }, [
        currentSidebarTab,
        fullPageEditorPresetAPI,
        isObjectSidebarShown
    ]);
    const onPanelCloseFunction = ()=>{
        const closingFromSuggestions = hadSuggestionsTabRef.current;
        setCurrentView(undefined);
        // When closing from a suggestions session, skip resetting the tab to
        // COMMENTS so the useEffect that watches currentSidebarTab does not
        // fire selectSuggestion(null) during the close transition.
        if (!closingFromSuggestions) {
            setCurrentSidebarTab((0, $3mVfX.SidebarTabValues).COMMENTS);
            // Unselect active annotations on the page
            if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                setViewProps(null);
            } else {
                eventEmitter.emit('setselectedannotation', '');
                setEditorViewProps(null);
            }
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelClose = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        setCurrentSidebarTab
    ]);
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView, openWithTab: openWithTab } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                ...(0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) && {
                    openWithTab: openWithTab
                },
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        // Drag-to-resize on page surfaces only (same exclusions as the panel
        // itself). `expValEquals` is the LAST clause per
        // `confluence-feature-gating/no-preconditioning` so exposure is only
        // recorded for users who actually meet the surface preconditions.
        const isResizableSurface = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView && (0, $6mKj3.expValEquals)('confluence_fe_comments_panel_resize', 'isEnabled', true);
        const showFooter = canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        /**
     * Logic for showing the footer for platform_editor_ai_content_suggested_edits
     * There is additional logic for comments vs. suggestions inside CommentsPanelFooterWrapper
     */ const showFooterCommon = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        const showDiscussionLabel = !isDatabaseView && !isWhiteboardView && !isSlidesView;
        // When the gate is on, use CommentsPanelFooterWrapper which reactively
        // switches between SuggestionsFooter and CommentsPanelFooter based on
        // the current tab — without needing to re-open the sidebar.
        // When the gate is off, fall back to the original CommentsPanelFooter.
        const FooterComponent = showFooterCommon ? $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper : undefined;
        const OldFooterComponent = showFooter ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: showDiscussionLabel && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? $3b7f940e5fdc8097$export$a7357cdd1f0b0168.discussionsPanelHeaderLabel : $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelHeaderActions
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView,
                    openWithTab: openWithTab
                }),
            FooterComponent: (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? FooterComponent : OldFooterComponent,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            },
            isResizable: isResizableSurface
        }, 'push');
    };
    const showCommentsPanel = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 * Similarly, "enable-share" is an opt-in feature and should not be enabled when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button',
        'enable-share'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo') && (0, $9wGTI.fg)('jira_linked_confluence_doc_rovo_nudge_gate');
    const showShare = (0, $9wGTI.fg)('csm_ai_enable_share_feature') && allowedEditPageFeatures?.includes('enable-share');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled,
        showShare: showShare
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("9VQUw", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $4ea72974304e25a5$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $4ea72974304e25a5$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $4ea72974304e25a5$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $42omo.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $42omo.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("cxu5H", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $9VQUw.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("4BDAe", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bbe4d3361c67916e$var$noop,
                close: $bbe4d3361c67916e$var$noop,
                setPanelWidth: $bbe4d3361c67916e$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("fN3iy", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = ()=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $dh538.fg)("nin_glance_panel_initial_width_ssr") ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel && (0, $dh538.fg)("preview_panel_initial_state") ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$1ec08acbc7c3653d$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)((0, $dh538.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        ...initialPanel && (0, $dh538.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
} : ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$MINIMUM_WIDTH = 1800;
const $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $9ee4137247832c84$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["AgentReceiptPanel"] = "agentReceiptPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    PanelName["SpaceSuggestionReviewPanel"] = "space-suggestion-review-panel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    "agentReceiptPanel",
    "space-suggestion-review-panel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("htsj6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2PDpU = parcelRequire("2PDpU");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");

const $feac3235d890b171$export$50af12b79850199d = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const props = t1;
    return $feac3235d890b171$export$689c7050603c5c14(props, false);
};
const $feac3235d890b171$export$689c7050603c5c14 = ({ skip: skip = false } = {}, returnRefreshFunction = true)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const query = (0, $2PDpU.default);
    const options = {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    };
    let result;
    if (returnRefreshFunction) // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jMyy4.useQueryInterop)(query, {
        ...options,
        __callerPackage__: "@confluence/page-utils"
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(query, options);
    const { data: data, loading: loading, error: error } = result;
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: result.refetch,
        type: contentNode?.type
    };
};
module.exports["useContentStatus"] = $feac3235d890b171$export$50af12b79850199d;
module.exports["useContentStatusWithRefetch"] = $feac3235d890b171$export$689c7050603c5c14;

});

parcelRegister("2PDpU", function(module, exports) {
/**
 * @generated SignedSource<<46aaf98c7fe5f9fcbf890b27644f6f9d>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5
const $ac2eaa9e4c9bbbba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft",
                        "archived"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
            "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
            "metadata": {},
            "name": "useContentStatusContentStatusQuery",
            "operationKind": "query",
            "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
        }
    };
}();
$ac2eaa9e4c9bbbba$var$node.hash = "42fd7c46b2fddcc220c48467ae805b6e";
var $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039 = $ac2eaa9e4c9bbbba$var$node;
module.exports["default"] = $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039;

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $42omo = parcelRequire("42omo");


var $cVw8q = parcelRequire("cVw8q");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $8WQTF = parcelRequire("8WQTF");

const $d99a6317060f344e$export$4162754b616020bc = 2000;
const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $42omo.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    commentSidebarContext: null,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $42omo.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider = ({ children: children, value: value })=>{
    if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: value
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $42omo.createContext)({
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    setCommentSidebarContext: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{},
    waitForAnnotationElementAndEmit: ()=>{}
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const [selectionProps, setSelectionProps] = (0, $42omo.useState)(null);
    const [hoverProps, setHoverProps] = (0, $42omo.useState)(null);
    const [viewProps, setViewProps] = (0, $42omo.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $42omo.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $42omo.useState)(null);
    const [showCreateComponent, setShowCreateComponent] = (0, $42omo.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $42omo.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $42omo.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $42omo.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $42omo.useState)();
    const [commentSidebarContext, setCommentSidebarContext] = (0, $42omo.useState)(null);
    const [prevContentId, setPrevContentId] = (0, $42omo.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const annotationManager = (0, $42omo.useMemo)(()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cVw8q.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $42omo.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $42omo.useState)(null);
    // Track active MutationObserver and timeout for cleanup on unmount
    const activeObserverRef = (0, $42omo.useRef)(null);
    const activeTimeoutRef = (0, $42omo.useRef)(null);
    /**
   * Waits for an annotation element to appear in the DOM using MutationObserver,
   * then emits annotation selection events. If element doesn't appear within 2 seconds,
   * fails the VIEW_INLINE_COMMENT_EXPERIENCE.
   */ const waitForAnnotationElementAndEmit = (0, $42omo.useCallback)((annotationId, emitter)=>{
        // Clean up any existing observer/timeout before creating new ones
        if (activeObserverRef.current) activeObserverRef.current.disconnect();
        if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
        // Use MutationObserver to wait for element to appear in DOM
        activeObserverRef.current = new MutationObserver(()=>{
            const element = document.getElementById(annotationId);
            if (element) {
                if (activeObserverRef.current) activeObserverRef.current.disconnect();
                if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
                activeObserverRef.current = null;
                activeTimeoutRef.current = null;
                // Emit annotation events and check if listeners exist
                if (emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: element
                })) {
                    emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: annotationId
                    });
                    setNewlyCreatedAnnotationId(annotationId);
                } else // No listeners registered - fail the experience
                experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Failed to emit annotation click')
                });
            }
        });
        // Observe the renderer wrapper for child additions (fallback to document.body for safety)
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper') || document.body;
        activeObserverRef.current.observe(rendererWrapper, {
            childList: true,
            subtree: true
        });
        // Fallback: If element doesn't appear within timeout, fail the experience
        // This almost always happens due to super slow re-renders (slow client on large page)
        activeTimeoutRef.current = setTimeout(()=>{
            if (activeObserverRef.current) activeObserverRef.current.disconnect();
            activeObserverRef.current = null;
            activeTimeoutRef.current = null;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`Annotation element not found in DOM after ${$d99a6317060f344e$export$4162754b616020bc}ms`)
            });
        }, $d99a6317060f344e$export$4162754b616020bc);
    }, [
        experienceTracker,
        setNewlyCreatedAnnotationId
    ]);
    // Cleanup observer and timeout on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (activeObserverRef.current) {
                activeObserverRef.current.disconnect();
                activeObserverRef.current = null;
            }
            if (activeTimeoutRef.current) {
                clearTimeout(activeTimeoutRef.current);
                activeTimeoutRef.current = null;
            }
        };
    }, []);
    // Get rendererActions for renderer mode (always call hook, but only use when feature gate is enabled)
    const rendererActionsHook = (0, $8WQTF.useRendererActions)();
    const rendererActions = rendererActionsHook?.rendererActions;
    (0, $42omo.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $42omo.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setCommentSidebarContext(null);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) {
            resetProviderState();
            if ((0, $6mKj3.expValEquals)('confluence_fe_view_inline_comment_page_jump_fix', 'isEnabled', true)) // Deselect any currently selected annotations
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        }
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
   * NOTE: This function will not be calling setShowCreateComponent because it's
   *       consumers will not be refreshing themselves with new selectionOptions.
   *       It will now be the responsibility of the consumers of this function to call
   *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
   */ const setSelectionOptionsForCreateEditor = (0, $42omo.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // Narrow pageClass to 'renderer' | 'editor' for the experience attributes
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage') ? pageClassAttr : 'renderer',
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            if (!selectionProps) {
                // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                return;
            }
            result = selectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        const ancestorNodeTypes = result?.ancestorNodeTypes ?? [];
        const alphabeticalAncestorNodeTypes = [
            ...ancestorNodeTypes
        ].sort();
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            ancestorNodeTypes: ancestorNodeTypes,
            alphabeticalAncestorNodeTypes: alphabeticalAncestorNodeTypes,
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            setSelectionOptions({
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            });
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $42omo.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        setCommentSidebarContext('create');
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else // Renderer mode: Try using rendererActions.applyAnnotation() first (similar to editor's annotationManager.applyDraft())
        // This provides more reliable annotation application, matching the editor implementation
        if (rendererActions && selectionOptions?.step) {
            const step = selectionOptions.step;
            // Extract position from step - use pos if available, otherwise use from/to
            const position = selectionOptions.pos ? {
                to: selectionOptions.pos,
                from: selectionOptions.pos
            } : {
                to: step.to,
                from: step.from
            };
            const annotationResult = rendererActions.applyAnnotation(position, {
                annotationId: annotationId,
                annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
            });
            if (annotationResult && annotationResult.doc) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(annotationResult.doc);
                waitForAnnotationElementAndEmit(annotationId, emitter);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // Fallback to original onCreate method
            // Since we generated the uuid ourselves, we need to replace the document generated with
            // the annotationId that we received from the backend so things line up correctly
            result = selectionProps.onCreate(annotationId);
            if (result) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                waitForAnnotationElementAndEmit(annotationId, emitter);
            } else throw new Error('Error ocurred when applying the step to the active document');
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData,
        rendererActions,
        selectionOptions,
        waitForAnnotationElementAndEmit
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            commentSidebarContext: commentSidebarContext,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        commentSidebarContext,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            setCommentSidebarContext: setCommentSidebarContext,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null),
            waitForAnnotationElementAndEmit: waitForAnnotationElementAndEmit
        }), [
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        setCommentSidebarContext,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData,
        waitForAnnotationElementAndEmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $dPJCf = parcelRequire("dPJCf");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    // useRouteName use RoutesContext which is more reliable than reading window.location.pathname directly.
    const routeName = (0, $dPJCf.useRouteName)({
        selector: (name)=>name
    });
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'tinyMCE';
    // Pass routeName to isDatabase/isWhiteboard - they will use it to avoid race conditions during SPA transitions
    if ((0, $gEtAQ.isDatabase)(routeName)) return 'database';
    if ((0, $gEtAQ.isWhiteboard)(routeName)) return 'whiteboard';
    if ((0, $gEtAQ.isSlides)(routeName)) return 'slide';
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some((selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $gtj7V = parcelRequire("gtj7V");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                compoundTaskId: compoundTaskId,
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)([
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint,
            edition: attributes.edition,
            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
        };
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        /**
     * This completes the init experience and starts the draft to publish experience.
     */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $5T18X = parcelRequire("5T18X");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const baseOptions = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
        __callerPackage__: "@confluence/comments-hooks"
    });
    const { data: data, loading: loading, error: error } = queryResult;
    const networkStatus = 'networkStatus' in queryResult && queryResult.networkStatus !== undefined ? queryResult.networkStatus : (0, $5T18X.NetworkStatus).ready;
    const refetch = 'refetch' in queryResult && typeof queryResult.refetch === 'function' ? queryResult.refetch : $be6154107952d370$var$noOpRefetch;
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<57f5dc3732e3b478e212a6d8f6a9bb34>>
 * @relayHash 5b33d38d543554afec98c6d129862ca0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5b33d38d543554afec98c6d129862ca0",
            "id": "c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "aad09466db1f47073b1a0249e54dc3a4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("8FCWK"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("8FCWK", function(module, exports) {

let $65005d03f1075b43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65005d03f1075b43$var$load("hhss7"),
    $65005d03f1075b43$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("bSvtO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $1P1Tu.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $9zUhf.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $9zUhf.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $9zUhf.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("3Qron", function(module, exports) {

let $2ccb79f1952a3d6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ccb79f1952a3d6f$var$load("YAi2k"),
    $2ccb79f1952a3d6f$var$load("adNrA"),
    $2ccb79f1952a3d6f$var$load("lUFbG"),
    $2ccb79f1952a3d6f$var$load("hs6P3"),
    $2ccb79f1952a3d6f$var$load("3Bbwl"),
    $2ccb79f1952a3d6f$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("6Qt0n", function(module, exports) {

let $4fbe19382e37bded$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4fbe19382e37bded$var$load("gBV5J"),
    $4fbe19382e37bded$var$load("djjX5"),
    $4fbe19382e37bded$var$load("kHOMt"),
    $4fbe19382e37bded$var$load("YAi2k"),
    $4fbe19382e37bded$var$load("adNrA"),
    $4fbe19382e37bded$var$load("b9CA3"),
    $4fbe19382e37bded$var$load("6wr18"),
    $4fbe19382e37bded$var$load("ffEVr"),
    $4fbe19382e37bded$var$load("fDWK8"),
    $4fbe19382e37bded$var$load("8LtYa"),
    $4fbe19382e37bded$var$load("jXA76"),
    $4fbe19382e37bded$var$load("4W6oq"),
    $4fbe19382e37bded$var$load("hs6P3"),
    $4fbe19382e37bded$var$load("aQh37"),
    $4fbe19382e37bded$var$load("bJVDE"),
    $4fbe19382e37bded$var$load("70IPm"),
    $4fbe19382e37bded$var$load("jnJbs"),
    $4fbe19382e37bded$var$load("3QXpo"),
    $4fbe19382e37bded$var$load("h3ABO"),
    $4fbe19382e37bded$var$load("kC80R"),
    $4fbe19382e37bded$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("6PB7O", function(module, exports) {

let $4f944dbe79d36182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f944dbe79d36182$var$load("6wr18"),
    $4f944dbe79d36182$var$load("ffEVr"),
    $4f944dbe79d36182$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("5opnM", function(module, exports) {

let $3ed2e213aaded16a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3ed2e213aaded16a$var$load("h3ABO"),
    $3ed2e213aaded16a$var$load("aQMre"),
    $3ed2e213aaded16a$var$load("3ezts"),
    $3ed2e213aaded16a$var$load("el56J"),
    $3ed2e213aaded16a$var$load("gBV5J"),
    $3ed2e213aaded16a$var$load("djjX5"),
    $3ed2e213aaded16a$var$load("YAi2k"),
    $3ed2e213aaded16a$var$load("adNrA"),
    $3ed2e213aaded16a$var$load("oTA4y"),
    $3ed2e213aaded16a$var$load("fPbCp"),
    $3ed2e213aaded16a$var$load("6wr18"),
    $3ed2e213aaded16a$var$load("fUl3O"),
    $3ed2e213aaded16a$var$load("kuluX"),
    $3ed2e213aaded16a$var$load("eik0U"),
    $3ed2e213aaded16a$var$load("cJsay"),
    $3ed2e213aaded16a$var$load("1OPxx"),
    $3ed2e213aaded16a$var$load("dpC8y"),
    $3ed2e213aaded16a$var$load("1GCFv"),
    $3ed2e213aaded16a$var$load("byAMe"),
    $3ed2e213aaded16a$var$load("dzUzj"),
    $3ed2e213aaded16a$var$load("fDWK8"),
    $3ed2e213aaded16a$var$load("cmqxT"),
    $3ed2e213aaded16a$var$load("dr1mZ"),
    $3ed2e213aaded16a$var$load("3SEnm"),
    $3ed2e213aaded16a$var$load("jbxHq"),
    $3ed2e213aaded16a$var$load("8YSo7"),
    $3ed2e213aaded16a$var$load("hs6P3"),
    $3ed2e213aaded16a$var$load("9anPW"),
    $3ed2e213aaded16a$var$load("3EXzu"),
    $3ed2e213aaded16a$var$load("dl2qY"),
    $3ed2e213aaded16a$var$load("kL5FA"),
    $3ed2e213aaded16a$var$load("7EorR"),
    $3ed2e213aaded16a$var$load("cHb2G"),
    $3ed2e213aaded16a$var$load("Wowvf"),
    $3ed2e213aaded16a$var$load("cX4Bp"),
    $3ed2e213aaded16a$var$load("dawn8"),
    $3ed2e213aaded16a$var$load("cyGuT"),
    $3ed2e213aaded16a$var$load("ffEVr"),
    $3ed2e213aaded16a$var$load("hhss7"),
    $3ed2e213aaded16a$var$load("7huND"),
    $3ed2e213aaded16a$var$load("jBZJd"),
    $3ed2e213aaded16a$var$load("2rRRp"),
    $3ed2e213aaded16a$var$load("aQh37"),
    $3ed2e213aaded16a$var$load("bJVDE"),
    $3ed2e213aaded16a$var$load("bhtkd"),
    $3ed2e213aaded16a$var$load("14zRe"),
    $3ed2e213aaded16a$var$load("70IPm"),
    $3ed2e213aaded16a$var$load("cbazH"),
    $3ed2e213aaded16a$var$load("2Ws5B"),
    $3ed2e213aaded16a$var$load("bLm2D"),
    $3ed2e213aaded16a$var$load("7tgvK"),
    $3ed2e213aaded16a$var$load("fRtVQ"),
    $3ed2e213aaded16a$var$load("b9CA3"),
    $3ed2e213aaded16a$var$load("dIjeS"),
    $3ed2e213aaded16a$var$load("c6DIp"),
    $3ed2e213aaded16a$var$load("dgH7p"),
    $3ed2e213aaded16a$var$load("hH53H"),
    $3ed2e213aaded16a$var$load("3QXpo"),
    $3ed2e213aaded16a$var$load("f2Ovh"),
    $3ed2e213aaded16a$var$load("lAHER"),
    $3ed2e213aaded16a$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("bvUYT", function(module, exports) {

let $861eca39e74236b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $861eca39e74236b9$var$load("gBV5J"),
    $861eca39e74236b9$var$load("djjX5"),
    $861eca39e74236b9$var$load("kHOMt"),
    $861eca39e74236b9$var$load("YAi2k"),
    $861eca39e74236b9$var$load("adNrA"),
    $861eca39e74236b9$var$load("b9CA3"),
    $861eca39e74236b9$var$load("6wr18"),
    $861eca39e74236b9$var$load("ffEVr"),
    $861eca39e74236b9$var$load("fDWK8"),
    $861eca39e74236b9$var$load("8LtYa"),
    $861eca39e74236b9$var$load("jXA76"),
    $861eca39e74236b9$var$load("4W6oq"),
    $861eca39e74236b9$var$load("hs6P3"),
    $861eca39e74236b9$var$load("aQh37"),
    $861eca39e74236b9$var$load("bJVDE"),
    $861eca39e74236b9$var$load("70IPm"),
    $861eca39e74236b9$var$load("jnJbs"),
    $861eca39e74236b9$var$load("3QXpo"),
    $861eca39e74236b9$var$load("6q8Rl"),
    $861eca39e74236b9$var$load("h3ABO"),
    $861eca39e74236b9$var$load("kC80R"),
    $861eca39e74236b9$var$load("ioZhb")
]).then(()=>parcelRequire('eBrKE'));

});

parcelRegister("egmJr", function(module, exports) {

let $a6243169722826aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a6243169722826aa$var$load("YAi2k"),
    $a6243169722826aa$var$load("adNrA"),
    $a6243169722826aa$var$load("lUFbG"),
    $a6243169722826aa$var$load("hs6P3"),
    $a6243169722826aa$var$load("3Bbwl"),
    $a6243169722826aa$var$load("bZz7X"),
    $a6243169722826aa$var$load("9izCO")
]).then(()=>parcelRequire('gDZxl'));

});

parcelRegister("fHAwL", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $9zUhf.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $9zUhf.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $9zUhf.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("6hmtW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $42omo.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $42omo.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $42omo.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $42omo.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $42omo.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $42omo.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for create comment events (called by content types).
   * Canvas registers this so it can be notified when a new top-level comment
   * is created inside the Confluence comments panel.
   */ registerOnCreateComment(callback) {
        this.onCreateCommentHandler = callback;
    }
    /**
   * Handle a create comment event (fired by CFE after a new comment is saved
   * in the comments panel).  This allows Canvas to sync the new comment to
   * other collaborators.
   */ onCreateComment(threadKey) {
        this.onCreateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param actionType - Optional action type: 'reply' for new replies, 'edit' for comment edits
   */ onUpdateComment(threadKey, actionType) {
        this.onUpdateCommentHandler?.(threadKey, actionType);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onCreateCommentHandler = void 0;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $42omo = parcelRequire("42omo");


var $ag6aQ = parcelRequire("ag6aQ");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $9wGTI = parcelRequire("9wGTI");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $42omo.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $42omo.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $42omo.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $42omo.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $42omo.useState)(false);
    const firstHighlightClicked = (0, $42omo.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $42omo.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $42omo.useState)(null);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $42omo.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = document.getElementById(nextThreadKey) || ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? document.getElementById(`footer-comment-thread-${nextThreadKey}-container`) : null);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $ag6aQ.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("lesF8", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $6cQbn = parcelRequire("6cQbn");

const $0eec8481dd12dbe1$export$4153d6fbc2386422 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CommentEditor(props) {
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
            ...props,
            appearance: "comment",
            AppearanceComponent: (0, $6cQbn.CommentEditorWithIntl)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function CommentEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $6cQbn.CommentEditorWithIntl)
    });
};
module.exports["CommentEditor"] = $0eec8481dd12dbe1$export$4153d6fbc2386422;

});

parcelRegister("7EEGh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $1PKpt = parcelRequire("1PKpt");

const $c97a308eea576e63$export$5252bd745392dcde = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ChromelessEditor(props) {
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
            ...props,
            appearance: "chromeless",
            AppearanceComponent: (0, $1PKpt.default)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function ChromelessEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $1PKpt.default)
    });
};
module.exports["ChromelessEditor"] = $c97a308eea576e63$export$5252bd745392dcde;

});

parcelRegister("8EF7j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a6242f603ec1727a8ab94c75bc410d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64d1f41eb9b7eee3$var$_react = $64d1f41eb9b7eee3$var$_interopRequireDefault((parcelRequire("42omo")));

var $64d1f41eb9b7eee3$var$_baseNew = $64d1f41eb9b7eee3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $64d1f41eb9b7eee3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolMindMap".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for mind map diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon = (props)=>/*#__PURE__*/ $64d1f41eb9b7eee3$var$_react.default.createElement($64d1f41eb9b7eee3$var$_baseNew.default, Object.assign({
        name: "DiagramSymbolMindMapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 13.5h2.5v-2H12zM1.5 9H4V7H1.5zM12 4.5h2.5v-2H12zm4 .125C16 5.385 15.384 6 14.625 6h-2.75c-.76 0-1.375-.616-1.375-1.375V4.25h-1a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h1v-.375c0-.76.616-1.375 1.375-1.375h2.75c.76 0 1.375.616 1.375 1.375v2.25c0 .76-.616 1.375-1.375 1.375h-2.75c-.76 0-1.375-.616-1.375-1.375v-.375h-1a2 2 0 0 1-2-2v-2.5h-2v.375c0 .76-.616 1.375-1.375 1.375h-2.75C.615 10.5 0 9.884 0 9.125v-2.25C0 6.115.616 5.5 1.375 5.5h2.75c.76 0 1.375.616 1.375 1.375v.375h2v-2.5a2 2 0 0 1 2-2h1v-.375c0-.76.616-1.375 1.375-1.375h2.75l.14.007c.694.07 1.235.656 1.235 1.368z"/>`
    }, props));
$64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon.displayName = 'DiagramSymbolMindMapIcon';
var $64d1f41eb9b7eee3$var$_default = module.exports.default = $64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon;

});

parcelRegister("jQW4q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7739ad8bf36e5bd9a55f1766d10483c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e73feb3a782b379c$var$_react = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("42omo")));

var $e73feb3a782b379c$var$_baseNew = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e73feb3a782b379c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Remix with Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e73feb3a782b379c$var$AiGenerativeRemixIcon = (props)=>/*#__PURE__*/ $e73feb3a782b379c$var$_react.default.createElement($e73feb3a782b379c$var$_baseNew.default, Object.assign({
        name: "AiGenerativeRemixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="M15.78 3.72a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM6 4.25a.75.75 0 0 1-.49.71l-1.1.4a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.41 0l-.4-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.48-.59L0 4.25l.01-.12a.75.75 0 0 1 .48-.59l1.1-.4a.5.5 0 0 0 .3-.3l.4-1.1.05-.11A.75.75 0 0 1 3 1.24l.12.01a.75.75 0 0 1 .54.38l.05.11.4 1.1c.05.14.16.25.3.3l1.1.4a.75.75 0 0 1 .49.71"/>`
    }, props));
$e73feb3a782b379c$var$AiGenerativeRemixIcon.displayName = 'AiGenerativeRemixIcon';
var $e73feb3a782b379c$var$_default = module.exports.default = $e73feb3a782b379c$var$AiGenerativeRemixIcon;

});

parcelRegister("g5QRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb761d6fd7d44f19$var$_react = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb761d6fd7d44f19$var$_baseNew = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb761d6fd7d44f19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $bb761d6fd7d44f19$var$_react.default.createElement($bb761d6fd7d44f19$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$bb761d6fd7d44f19$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $bb761d6fd7d44f19$var$_default = module.exports.default = $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon;

});

parcelRegister("4XRO0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::197921048e92db6f31070962e79acfb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $39d668c2c7063a5d$var$_react = $39d668c2c7063a5d$var$_interopRequireDefault((parcelRequire("42omo")));

var $39d668c2c7063a5d$var$_baseNew = $39d668c2c7063a5d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $39d668c2c7063a5d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: play video in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $39d668c2c7063a5d$var$VideoPlayCircleIcon = (props)=>/*#__PURE__*/ $39d668c2c7063a5d$var$_react.default.createElement($39d668c2c7063a5d$var$_baseNew.default, Object.assign({
        name: "VideoPlayCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5-2.694c0-.808.866-1.32 1.574-.931l4.958 2.722a1.062 1.062 0 0 1 0 1.862l-4.958 2.722A1.063 1.063 0 0 1 5 10.75zm1.5.74v3.965l3.611-1.983z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 10.01V6.046l3.611 1.983z"/>`
    }, props));
$39d668c2c7063a5d$var$VideoPlayCircleIcon.displayName = 'VideoPlayCircleIcon';
var $39d668c2c7063a5d$var$_default = module.exports.default = $39d668c2c7063a5d$var$VideoPlayCircleIcon;

});

parcelRegister("ij2FZ", function(module, exports) {
const $d70a1b66183cdb12$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $d70a1b66183cdb12$export$d4f002c79ea2ad20 = 'skill';
const $d70a1b66183cdb12$export$e4d0b30afd49f7df = 'skillTag';
const $d70a1b66183cdb12$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $d70a1b66183cdb12$export$aae1b80712c1b67b = `${$d70a1b66183cdb12$export$d4f002c79ea2ad20}:${$d70a1b66183cdb12$export$e4d0b30afd49f7df}`;
const $d70a1b66183cdb12$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $d70a1b66183cdb12$export$d0e832101df0ac96 && extensionKey === $d70a1b66183cdb12$export$aae1b80712c1b67b;
};
const $d70a1b66183cdb12$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $d70a1b66183cdb12$export$aae1b80712c1b67b,
                extensionType: $d70a1b66183cdb12$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $d70a1b66183cdb12$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $d70a1b66183cdb12$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $d70a1b66183cdb12$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $d70a1b66183cdb12$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $d70a1b66183cdb12$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $d70a1b66183cdb12$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $d70a1b66183cdb12$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $d70a1b66183cdb12$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $d70a1b66183cdb12$export$a425ebfe740d9932;

});

parcelRegister("d3VBU", function(module, exports) {

var $42omo = parcelRequire("42omo");






































const $fd687e8904fce28a$export$dce8bc0f04f0d915 = {
    skill: ()=>(parcelRequire("ciV2C")),
    assets: ()=>(parcelRequire("8OGHW")),
    add: ()=>Promise.resolve((parcelRequire("g5gZt"))),
    'chart-bar-line': ()=>(parcelRequire("4qVJ2")),
    'ai-generative-text': ()=>Promise.resolve((parcelRequire("h7YX1"))),
    'work-item': ()=>Promise.resolve((parcelRequire("2qVkt"))),
    'lock-locked': ()=>Promise.resolve((parcelRequire("9Q2dU"))),
    'chart-pie': ()=>(parcelRequire("8sr2T")),
    plan: ()=>(parcelRequire("i4zNS")),
    settings: ()=>Promise.resolve((parcelRequire("fIcbd"))),
    'project-status': ()=>(parcelRequire("6E8pW")),
    'merge-success': ()=>(parcelRequire("3mxkw")),
    'person-add': ()=>(parcelRequire("kMEmh")),
    'people-group': ()=>Promise.resolve((parcelRequire("lebfc"))),
    'person-added': ()=>(parcelRequire("pt6v8")),
    login: ()=>(parcelRequire("kURs4")),
    'ai-generative-text-summary': ()=>Promise.resolve((parcelRequire("a6IPc"))),
    transition: ()=>(parcelRequire("aho4H")),
    board: ()=>Promise.resolve((parcelRequire("5aaqS"))),
    release: ()=>Promise.resolve((parcelRequire("5j8et"))),
    'app-switcher': ()=>(parcelRequire("798YW")),
    search: ()=>Promise.resolve((parcelRequire("jluld"))),
    'playlist-add': ()=>(parcelRequire("dnSjb")),
    'playlist-remove': ()=>(parcelRequire("4kdB8")),
    summary: ()=>Promise.resolve((parcelRequire("a6IPc"))),
    clock: ()=>Promise.resolve((parcelRequire("kevJM"))),
    'ai-generative-chapters': ()=>(parcelRequire("kJyT8")),
    talent: ()=>(parcelRequire("i3Sza")),
    incident: ()=>Promise.resolve((parcelRequire("5LN4K"))),
    form: ()=>(parcelRequire("2CaDj")),
    ticket: ()=>(parcelRequire("kC0Cc")),
    alert: ()=>(parcelRequire("e6w7G")),
    pulse: ()=>(parcelRequire("186Qe")),
    'text-lengthen': ()=>(parcelRequire("7xeCY")),
    'ai-generative-cleanup': ()=>(parcelRequire("lwzVs")),
    survey: ()=>(parcelRequire("c58rI")),
    'text-review': ()=>(parcelRequire("aC3t3"))
};
const $fd687e8904fce28a$export$ca2f546e21dcce87 = $fd687e8904fce28a$export$dce8bc0f04f0d915.skill;
const $fd687e8904fce28a$export$f7883dcc9f65479a = Object.fromEntries(Object.entries($fd687e8904fce28a$export$dce8bc0f04f0d915).map(([key, loader])=>[
        key,
        (0, $42omo.lazy)(loader)
    ]));
const $fd687e8904fce28a$export$78596fa6083c04d1 = $fd687e8904fce28a$export$f7883dcc9f65479a.skill;
module.exports["skillIcon"] = $fd687e8904fce28a$export$dce8bc0f04f0d915;
module.exports["defaultIcon"] = $fd687e8904fce28a$export$ca2f546e21dcce87;
module.exports["skillIconMap"] = $fd687e8904fce28a$export$f7883dcc9f65479a;
module.exports["DefaultSkillIcon"] = $fd687e8904fce28a$export$78596fa6083c04d1;

});

parcelRegister("ciV2C", function(module, exports) {

let $8f5369acfd9ab17e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f5369acfd9ab17e$var$load("2ap9J").then(()=>parcelRequire('bKhxF'));

});

parcelRegister("8OGHW", function(module, exports) {

let $66b41f16e830c814$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66b41f16e830c814$var$load("1yrlK").then(()=>parcelRequire('2LFoe'));

});

parcelRegister("4qVJ2", function(module, exports) {

let $33a65e3728a6deed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33a65e3728a6deed$var$load("czqcb").then(()=>parcelRequire('OmUay'));

});

parcelRegister("8sr2T", function(module, exports) {

let $6285eaf809731400$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6285eaf809731400$var$load("8vVzT").then(()=>parcelRequire('4DzVW'));

});

parcelRegister("i4zNS", function(module, exports) {

let $d2845f86362f2ced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2845f86362f2ced$var$load("hpUn4").then(()=>parcelRequire('3Pjsu'));

});

parcelRegister("6E8pW", function(module, exports) {

let $4d6d0204a36cd6bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d6d0204a36cd6bd$var$load("l4YAS").then(()=>parcelRequire('f2ref'));

});

parcelRegister("3mxkw", function(module, exports) {

let $272d47d3be217e93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $272d47d3be217e93$var$load("6HxBR").then(()=>parcelRequire('2KFft'));

});

parcelRegister("kMEmh", function(module, exports) {

let $f21798a7023c2d22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f21798a7023c2d22$var$load("fjOTL").then(()=>parcelRequire('cDMVr'));

});

parcelRegister("pt6v8", function(module, exports) {

let $04c8e955877b500e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $04c8e955877b500e$var$load("4rKYa").then(()=>parcelRequire('l8mxb'));

});

parcelRegister("kURs4", function(module, exports) {

let $f3a28009260eef94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3a28009260eef94$var$load("iMSgb").then(()=>parcelRequire('ilSNM'));

});

parcelRegister("aho4H", function(module, exports) {

let $77be2ab0ef9d3474$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77be2ab0ef9d3474$var$load("8Qv5g").then(()=>parcelRequire('cnlZf'));

});

parcelRegister("798YW", function(module, exports) {

let $5340574c778c8cd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5340574c778c8cd4$var$load("48rvp").then(()=>parcelRequire('kNHXO'));

});

parcelRegister("dnSjb", function(module, exports) {

let $9be78cd6942a698e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9be78cd6942a698e$var$load("7kkP6").then(()=>parcelRequire('3DMri'));

});

parcelRegister("4kdB8", function(module, exports) {

let $326393f9ce2ef51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $326393f9ce2ef51d$var$load("k2R9e").then(()=>parcelRequire('2Ihtu'));

});

parcelRegister("kJyT8", function(module, exports) {

let $f18312b6ea88af73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f18312b6ea88af73$var$load("1okAQ").then(()=>parcelRequire('iulqN'));

});

parcelRegister("i3Sza", function(module, exports) {

let $d262d588718b83e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d262d588718b83e3$var$load("eF7Ol").then(()=>parcelRequire('f7Fwi'));

});

parcelRegister("2CaDj", function(module, exports) {

let $1e7760e1b1d31574$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1e7760e1b1d31574$var$load("3TFqP").then(()=>parcelRequire('4JtPF'));

});

parcelRegister("kC0Cc", function(module, exports) {

let $f017d56eb0f65c8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f017d56eb0f65c8a$var$load("334w0").then(()=>parcelRequire('kVwu3'));

});

parcelRegister("e6w7G", function(module, exports) {

let $a44a8b2afa568976$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a44a8b2afa568976$var$load("2ABJz").then(()=>parcelRequire('7Shff'));

});

parcelRegister("186Qe", function(module, exports) {

let $0d2bd8617a14a4d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d2bd8617a14a4d3$var$load("cSj9q").then(()=>parcelRequire('8uomH'));

});

parcelRegister("7xeCY", function(module, exports) {

let $57c6f6319bc0dd8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57c6f6319bc0dd8e$var$load("9f5Sw").then(()=>parcelRequire('eugUs'));

});

parcelRegister("lwzVs", function(module, exports) {

let $fab87441f79abcca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fab87441f79abcca$var$load("dYRAy").then(()=>parcelRequire('cbtR4'));

});

parcelRegister("c58rI", function(module, exports) {

let $8cbc80e42da4fe4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cbc80e42da4fe4b$var$load("2jXG3").then(()=>parcelRequire('gjyaY'));

});

parcelRegister("aC3t3", function(module, exports) {

let $7ba02494c7b926ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ba02494c7b926ed$var$load("ct54r").then(()=>parcelRequire('1mMWQ'));

});

parcelRegister("h5cDl", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $lGVHb = parcelRequire("lGVHb");

const $69b3b1a34fa19136$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Legacy GraphQL query — graphIntegration_componentDirectoryItems.
 * Returns user-facing descriptions (not AI model instructions).
 * Used when rovo_chat_unified_skills_agg is OFF.
 */ const $69b3b1a34fa19136$var$LEGACY_SKILLS_QUERY = `
  query GraphIntegrationItemsQuery(
    $first: Int
    $cloudId: ID!
    $surface: GraphIntegrationSurface
    $relevantFor: [GraphIntegrationDirectoryItemType!]
  ) {
    graphIntegration_componentDirectoryItems(
      first: $first
      cloudId: $cloudId
      surface: $surface
      relevantFor: $relevantFor
    )
    @optIn(to: "GraphIntegrationItemsQuery")
    {
      edges {
        node {
          __typename
          ... on GraphIntegrationSkillDirectoryItem {
            id
            slashCommand
            name
            description
            iconUrl
            integrationKey {
              displayName
              iconUrl
            }
            color
            tags {
              displayName
            }
          }
        }
      }
    }
  }
`;
/**
 * New unified GraphQL query — convoai_availableSkills.
 * Used when rovo_chat_unified_skills_agg is ON.
 */ const $69b3b1a34fa19136$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}:${graphqlEndpoint}:${useUnified}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $69b3b1a34fa19136$var$skillsCache = new Map();
function $69b3b1a34fa19136$export$e6cf70cf6554c856() {
    $69b3b1a34fa19136$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $69b3b1a34fa19136$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($69b3b1a34fa19136$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $69b3b1a34fa19136$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 100
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $lGVHb.parseConvoAiSkillEdges)(edges);
}
/**
 * Fetch skills using the legacy graphIntegration_componentDirectoryItems endpoint.
 */ async function $69b3b1a34fa19136$var$fetchSkillsLegacy(cloudId) {
    const response = await fetch($69b3b1a34fa19136$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $69b3b1a34fa19136$var$LEGACY_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 100,
                surface: 'ROVO',
                relevantFor: [
                    'SKILL'
                ]
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length) return [];
    const edges = json.data?.graphIntegration_componentDirectoryItems?.edges;
    return (0, $lGVHb.parseSkillEdges)(edges);
}
async function $69b3b1a34fa19136$export$268d57ae88e7df66(cloudId) {
    const useUnified = (0, $dh538.fg)('rovo_chat_unified_skills_agg');
    const cacheKey = `${cloudId}:${useUnified}`;
    const cached = $69b3b1a34fa19136$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = useUnified ? await $69b3b1a34fa19136$var$fetchSkillsUnified(cloudId) : await $69b3b1a34fa19136$var$fetchSkillsLegacy(cloudId);
        $69b3b1a34fa19136$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $69b3b1a34fa19136$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $69b3b1a34fa19136$export$268d57ae88e7df66;

});

parcelRegister("lGVHb", function(module, exports) {
function $b4b40a49047a27cf$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $b4b40a49047a27cf$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $b4b40a49047a27cf$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const trimmedDescription = node.description && node.description?.length > 150 ? `${node.description?.slice(0, 147)}...` : node.description ?? '';
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $b4b40a49047a27cf$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.displayName ?? node.name ?? '',
        description: node.helpText ?? node.description ?? '',
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $b4b40a49047a27cf$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$b4b40a49047a27cf$export$db36004670a5626e(edge?.node) ? $b4b40a49047a27cf$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $b4b40a49047a27cf$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$b4b40a49047a27cf$export$7d1ba2a7b9e1a07(edge?.node) ? $b4b40a49047a27cf$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $b4b40a49047a27cf$export$faef8b68e529d4a7(edges) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($b4b40a49047a27cf$export$db36004670a5626e(node)) return $b4b40a49047a27cf$export$74ea09dd5afceb60(node);
        if ($b4b40a49047a27cf$export$7d1ba2a7b9e1a07(node)) return $b4b40a49047a27cf$export$fd76a94f4a001a14(node);
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $b4b40a49047a27cf$export$74ea09dd5afceb60;
module.exports["parseSkillEdges"] = $b4b40a49047a27cf$export$2cffb029ea623d71;
module.exports["parseConvoAiSkillEdges"] = $b4b40a49047a27cf$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $b4b40a49047a27cf$export$faef8b68e529d4a7;

});

parcelRegister("aqrhZ", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("96msn")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("96msn")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("96msn")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $lhchg = parcelRequire("lhchg");


var $96msn = parcelRequire("96msn");

parcelRequire("1BwGq");
var $jnAB4 = parcelRequire("jnAB4");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("eow39");
var $jyd5r = parcelRequire("jyd5r");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");


var $iYRNV = parcelRequire("iYRNV");


});

parcelRegister("8dgvm", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("dXZzO")).MODE);

var $dXZzO = parcelRequire("dXZzO");

const $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN = undefined;
const $5fac572772fbabda$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $5fac572772fbabda$var$DEFAULT_MODE = (0, $dXZzO.MODE).HYDRATE;
const $5fac572772fbabda$var$DEFAULT_RETRY = 2;
const $5fac572772fbabda$var$config = {
    crossOrigin: $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN,
    manifest: $5fac572772fbabda$var$DEFAULT_MANIFEST,
    mode: $5fac572772fbabda$var$DEFAULT_MODE,
    retry: $5fac572772fbabda$var$DEFAULT_RETRY
};
const $5fac572772fbabda$export$44487a86467333c3 = ()=>$5fac572772fbabda$var$config;
const $5fac572772fbabda$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $5fac572772fbabda$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN;
    $5fac572772fbabda$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $5fac572772fbabda$var$DEFAULT_MANIFEST;
    $5fac572772fbabda$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $5fac572772fbabda$var$DEFAULT_MODE;
    $5fac572772fbabda$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $5fac572772fbabda$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $5fac572772fbabda$export$44487a86467333c3;
module.exports["setConfig"] = $5fac572772fbabda$export$940a7873bb071df8;

});

parcelRegister("dXZzO", function(module, exports) {
const $a2b08cde192cf1ec$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $a2b08cde192cf1ec$export$e48589d9e4824227;

});

parcelRegister("lhchg", function(module, exports) {

var $89YVk = parcelRequire("89YVk");


var $8dgvm = parcelRequire("8dgvm");

parcelRequire("ecrVx");
var $4CMiD = parcelRequire("4CMiD");
var $6y0vU = parcelRequire("6y0vU");


var $27zaj = parcelRequire("27zaj");

const $f7d4b5876658b264$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dgvm.setConfig)(config);
        (0, $4CMiD.LISTENERS).length = 0;
        (0, $6y0vU.setCurrent)(0);
        if (!(0, $27zaj.isNodeEnvironment)()) (0, $89YVk.collect)();
    }
};

});

parcelRegister("89YVk", function(module, exports) {

var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");


var $8lfql = parcelRequire("8lfql");


var $3iPPT = parcelRequire("3iPPT");

const $5f0e6c234ea4c71a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dgvm.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dXZzO.MODE).RENDER ? (0, $8lfql.cloneElements)(markers[i], lazyBegin) : (0, $3iPPT.refElements)(markers[i], lazyBegin);
        if ((0, $euF6Z.COLLECTED).has(lazyBegin)) (0, $euF6Z.COLLECTED).get(lazyBegin).push(value);
        else (0, $euF6Z.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $5f0e6c234ea4c71a$export$bb44f104e3c54dae;

});

parcelRegister("euF6Z", function(module, exports) {
const $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $a8d3c1fdc5de2df2$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $a8d3c1fdc5de2df2$export$4831ef3968ea94ef;

});

parcelRegister("8lfql", function(module, exports) {
const $612c3fc5c2a28c4f$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $612c3fc5c2a28c4f$export$c42217d53a7ebafb;

});

parcelRegister("3iPPT", function(module, exports) {
const $267b431587227d50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $267b431587227d50$export$c69443129766a7fc;

});

parcelRegister("ecrVx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("6y0vU")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("6y0vU")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("4CMiD")).LISTENERS);

var $6y0vU = parcelRequire("6y0vU");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");


});

parcelRegister("6y0vU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $euF6Z = parcelRequire("euF6Z");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");

let $4c46510d73a23c1f$var$CURRENT_PHASE = (0, $euF6Z.PHASE).PAINT;
const $4c46510d73a23c1f$export$5f80f094fd31fffd = (phase)=>{
    $4c46510d73a23c1f$var$CURRENT_PHASE = phase;
    (0, $4CMiD.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $4c46510d73a23c1f$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $ilgZx.createSubscribe)((0, $4CMiD.LISTENERS)),
    currentValue: ()=>$4c46510d73a23c1f$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).PAINT)
    }
});
const $4c46510d73a23c1f$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($4c46510d73a23c1f$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $4c46510d73a23c1f$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $4c46510d73a23c1f$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $4c46510d73a23c1f$export$1dc361b277327f88;

});

parcelRegister("4CMiD", function(module, exports) {
const $35e02d56e6163baa$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $35e02d56e6163baa$export$81b9c458a026d68f;

});

parcelRegister("ilgZx", function(module, exports) {
const $d5a75e5021e4308a$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $d5a75e5021e4308a$export$364097d812234b3f;

});

parcelRegister("27zaj", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("7zmsS")).default);

var $7zmsS = parcelRequire("7zmsS");

const $18b7834f7092bd86$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $18b7834f7092bd86$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $18b7834f7092bd86$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $18b7834f7092bd86$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $18b7834f7092bd86$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $18b7834f7092bd86$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $18b7834f7092bd86$export$283635c04a02cc36;
module.exports["attrToProp"] = $18b7834f7092bd86$export$62bf630d0de3d781;

});

parcelRegister("7zmsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $582d3a4d2ad75f69$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $582d3a4d2ad75f69$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("96msn", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");


var $27zaj = parcelRequire("27zaj");
var $7zmsS = parcelRequire("7zmsS");


var $k001K = parcelRequire("k001K");


var $1r9rN = parcelRequire("1r9rN");


var $2niqO = parcelRequire("2niqO");


var $aAlyb = parcelRequire("aAlyb");


var $1C3RC = parcelRequire("1C3RC");


var $1Bcgq = parcelRequire("1Bcgq");


var $fLvpO = parcelRequire("fLvpO");

function $6a061803acf54fcf$var$_extends() {
    $6a061803acf54fcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a061803acf54fcf$var$_extends.apply(this, arguments);
}
function $6a061803acf54fcf$var$lazyProxy(_loader, { defer: defer = (0, $euF6Z.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $27zaj.isNodeEnvironment)();
    const dataLazyId = (0, $7zmsS.default)(moduleId);
    const LazyInternal = isServer ? (0, $2niqO.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $1r9rN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $aAlyb.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $8dgvm.getConfig)();
                return (0, $1Bcgq.retry)(_loader, {
                    delay: (0, $k001K.RETRY_DELAY),
                    factor: (0, $k001K.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $27zaj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $8dgvm.getConfig)();
        return (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $euF6Z.PHASE).PAINT ? (0, $k001K.PRIORITY).HIGH : (0, $k001K.PRIORITY).LOW;
        return (0, $1C3RC.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6a061803acf54fcf$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $euF6Z.PHASE).LAZY
    }
};
function $6a061803acf54fcf$export$c952e5f94576010e(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6a061803acf54fcf$export$291dd592399bdafa(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6a061803acf54fcf$export$488013bae63b21da(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6a061803acf54fcf$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6a061803acf54fcf$export$291dd592399bdafa;
module.exports["lazy"] = $6a061803acf54fcf$export$488013bae63b21da;

});

parcelRegister("aQIfl", function(module, exports) {
const $0209d2ec05e7d0da$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $0209d2ec05e7d0da$export$303f43e55cf1ef2f;

});

parcelRegister("k001K", function(module, exports) {
const $e8f3d428f2749473$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e8f3d428f2749473$export$a339266ad71b2447 = 300;
const $e8f3d428f2749473$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e8f3d428f2749473$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e8f3d428f2749473$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e8f3d428f2749473$export$ba64c908e55507fe;

});

parcelRegister("1r9rN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("1BwGq");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $k001K = parcelRequire("k001K");


var $fLvpO = parcelRequire("fLvpO");


var $8VyCG = parcelRequire("8VyCG");


var $femay = parcelRequire("femay");


var $1C3RC = parcelRequire("1C3RC");


var $iYRNV = parcelRequire("iYRNV");


var $36I1o = parcelRequire("36I1o");

function $10bfa415480e5081$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $42omo.useContext)((0, $iYRNV.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $fLvpO.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $36I1o.useSubscription)({
            context: (0, $9uVEz.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $euF6Z.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $36I1o.useSubscription)({
                context: (0, $6y0vU.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $42omo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $1C3RC.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $k001K.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        (0, $42omo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $euF6Z.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $8dgvm.getConfig)().mode === (0, $dXZzO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8VyCG.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $femay.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $10bfa415480e5081$export$6898b5504b58699a;

});

parcelRegister("1BwGq", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("9uVEz")).WaitContext);

var $9uVEz = parcelRequire("9uVEz");


var $jnAB4 = parcelRequire("jnAB4");


});

parcelRegister("9uVEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jLShN = parcelRequire("jLShN");

const $6ea3a326e6c1ad89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>(0, $jLShN.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $6ea3a326e6c1ad89$export$9ba3fe09d15de47b;

});

parcelRegister("jLShN", function(module, exports) {
const $e64c8432c5ffa90e$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $e64c8432c5ffa90e$export$276c7dbda7675aec;

});

parcelRegister("jnAB4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9uVEz = parcelRequire("9uVEz");

const $e1bc8db03d394dff$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $42omo.useContext)((0, $9uVEz.WaitContext));
    const value = (0, $42omo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $42omo.useRef)(new Set());
    const api = (0, $42omo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $42omo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uVEz.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("eow39", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("h5RZ7")).LazySuspenseContext);

var $jyd5r = parcelRequire("jyd5r");


var $h5RZ7 = parcelRequire("h5RZ7");


});

parcelRegister("jyd5r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");


var $h5RZ7 = parcelRequire("h5RZ7");

class $e3bb580fd9a2f323$export$256c542058532d6f extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $27zaj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $42omo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $e3bb580fd9a2f323$export$256c542058532d6f;

});

parcelRegister("h5RZ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c71cc793aab4db4d$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $c71cc793aab4db4d$export$c33990e84065970c;

});

parcelRegister("fLvpO", function(module, exports) {
const $b7a39d38ff5e8305$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $b7a39d38ff5e8305$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$b7a39d38ff5e8305$export$6aa69c1258005366]: true
    });
    return error;
};
const $b7a39d38ff5e8305$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b7a39d38ff5e8305$export$6aa69c1258005366);
module.exports["createLoaderError"] = $b7a39d38ff5e8305$export$c73a6a6f0bf7d425;

});

parcelRegister("8VyCG", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $67fe80fcd34326f0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $67fe80fcd34326f0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($67fe80fcd34326f0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $67fe80fcd34326f0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $67fe80fcd34326f0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $67fe80fcd34326f0$export$d55db778a3e1446b;

});

parcelRegister("femay", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");

function $b1695c2d5acdcbdf$var$_extends() {
    $b1695c2d5acdcbdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1695c2d5acdcbdf$var$_extends.apply(this, arguments);
}
const $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $27zaj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), $b1695c2d5acdcbdf$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4;

});

parcelRegister("1C3RC", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");


var $27zaj = parcelRequire("27zaj");


var $k001K = parcelRequire("k001K");


var $1J5yR = parcelRequire("1J5yR");


var $iYRNV = parcelRequire("iYRNV");

function $12cc564e7e862135$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $8dgvm.getConfig)();
    const assets = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1J5yR.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $12cc564e7e862135$var$fakePromise = {
    then: ()=>$12cc564e7e862135$var$fakePromise,
    catch: ()=>$12cc564e7e862135$var$fakePromise,
    finally: ()=>$12cc564e7e862135$var$fakePromise
};
function $12cc564e7e862135$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1J5yR.insertLinkTag)(href, rel));
        return $12cc564e7e862135$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $12cc564e7e862135$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jLShN.noopCleanup;
}
function $12cc564e7e862135$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $27zaj.isNodeEnvironment)()) return 0, $jLShN.noopCleanup;
    (_GlobalReactLooselyLa = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $k001K.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $12cc564e7e862135$export$3af04dbcb01bad4d,
        $12cc564e7e862135$export$1046fd6a49d5e7a,
        $12cc564e7e862135$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jLShN.noopCleanup;
}
module.exports["preloadAsset"] = $12cc564e7e862135$export$25bad4aa00c45355;

});

parcelRegister("1J5yR", function(module, exports) {

var $iYRNV = parcelRequire("iYRNV");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");

function $141e4ec3ad408220$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jLShN.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $8dgvm.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $141e4ec3ad408220$export$6610512821c8a4ce;

});

parcelRegister("iYRNV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dd1790f807a46380$export$e2d53c0cbedd2710 = {
    current: null
};
const $dd1790f807a46380$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $42omo.createContext)($dd1790f807a46380$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $dd1790f807a46380$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $dd1790f807a46380$export$8146ab57a3f7a7cb;

});

parcelRegister("36I1o", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $2434146821c65301$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $2434146821c65301$export$368b4214baeb914c;

});

parcelRegister("2niqO", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $27zaj = parcelRequire("27zaj");


var $fLvpO = parcelRequire("fLvpO");

function $1bac06d947c9671a$var$load(moduleId, loader) {
    try {
        return (0, $27zaj.getExport)(loader());
    } catch (err) {
        throw (0, $fLvpO.createLoaderError)(err);
    }
}
function $1bac06d947c9671a$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $1bac06d947c9671a$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $8dgvm.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $euF6Z.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("link", {
                key: url,
                rel: defer === (0, $euF6Z.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $1bac06d947c9671a$export$eb2e4b04351cdd9e;

});

parcelRegister("aAlyb", function(module, exports) {
const $7b4dfb9d7bf38586$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $7b4dfb9d7bf38586$export$e673efccd97e4223;

});

parcelRegister("1Bcgq", function(module, exports) {
const $12a2c288067cec34$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $12a2c288067cec34$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $12a2c288067cec34$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $12a2c288067cec34$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $12a2c288067cec34$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $12a2c288067cec34$var$calculateDelay(context, policy);
        if (delay) await $12a2c288067cec34$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $12a2c288067cec34$export$9369b12211e1fce4;

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("F4YLX", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $87886bfe56e46f2e$export$2e83ac12275e5b95 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jDbpB",
    name: "TourableRedactionExtensionLoader",
    loader: async ()=>(await (parcelRequire("bOmaA"))).TourableRedactionExtension
});
module.exports["TourableRedactionExtensionLoader"] = $87886bfe56e46f2e$export$2e83ac12275e5b95;

});

parcelRegister("bOmaA", function(module, exports) {

let $89958fa6e0d2d088$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89958fa6e0d2d088$var$load("5AfWB").then(()=>parcelRequire('jubPE'));

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $aXWIB.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $kyiqo = parcelRequire("kyiqo");


var $3kTfj = parcelRequire("3kTfj");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $kyiqo.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $kyiqo.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $kyiqo.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $kyiqo.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $cbc8g.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $kyiqo = parcelRequire("kyiqo");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $kyiqo.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

const $02745cd2b6b0665c$var$PageObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $02745cd2b6b0665c$export$2e2bcd8739ae039 = $02745cd2b6b0665c$var$PageObject;
module.exports["default"] = $02745cd2b6b0665c$export$2e2bcd8739ae039;

});

parcelRegister("744ND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d51e4a53b773461fcacb3f2ef49e80e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $524ca136d29d3c89$var$_react = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("42omo")));

var $524ca136d29d3c89$var$_baseNew = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $524ca136d29d3c89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $524ca136d29d3c89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $524ca136d29d3c89$var$_react.default.createElement($524ca136d29d3c89$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$524ca136d29d3c89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $524ca136d29d3c89$var$_default = module.exports.default = $524ca136d29d3c89$var$WarningOutlineIcon;

});

parcelRegister("7ShCl", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $3d55d2ba43147efd$export$480e55f805d7990f = (0, $aXWIB.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    askRovoToolbarRemixAppTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.title",
        defaultMessage: "Edit"
    },
    askRovoToolbarImageTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.image.title",
        defaultMessage: "Edit image"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    askRovoToolbarRemixAppTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.tooltip.quickCommand",
        defaultMessage: "Edit {key}+'"
    },
    askRovoToolbarImageTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.image.tooltip.quickCommand",
        defaultMessage: "Edit image {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    rovoToolbarDropdownChevronLabel: {
        id: "fabric.editor.ai.toolbar.rovoDropdownChevron.label",
        defaultMessage: "More Ask Rovo options"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    },
    // On-paste menu messages
    pasteMenuActionsTitle: {
        id: "fabric.editor.ai.paste-menu.section-title",
        defaultMessage: "Actions"
    },
    // Block menu messages
    blockMenuNestedMenuTitle: {
        id: "fabric.editor.ai.config.item.blockMenuNestedMenu.title",
        defaultMessage: "View more actions"
    },
    // Smartlink action messages
    smartlinkListKeyTopics: {
        id: "fabric.editor.ai.smartlink.action.listKeyTopics",
        defaultMessage: "List key topics"
    },
    smartlinkListKeyThemes: {
        id: "fabric.editor.ai.smartlink.action.listKeyThemes",
        defaultMessage: "List key themes"
    },
    smartlinkExtractInsights: {
        id: "fabric.editor.ai.smartlink.action.extractInsights",
        defaultMessage: "Extract insights"
    },
    smartlinkExtractUserQuotes: {
        id: "fabric.editor.ai.smartlink.action.extractUserQuotes",
        defaultMessage: "Extract user quotes"
    },
    smartlinkAddDecisions: {
        id: "fabric.editor.ai.smartlink.action.addDecisions",
        defaultMessage: "Add decisions"
    },
    smartlinkDefineActionItems: {
        id: "fabric.editor.ai.smartlink.action.defineActionItems",
        defaultMessage: "Define action items"
    },
    smartlinkSummarizeChanges: {
        id: "fabric.editor.ai.smartlink.action.summarizeChanges",
        defaultMessage: "Summarize changes"
    },
    smartlinkAddRelatedWorkItems: {
        id: "fabric.editor.ai.smartlink.action.addRelatedWorkItems",
        defaultMessage: "Add related work items"
    },
    smartlinkListTodos: {
        id: "fabric.editor.ai.smartlink.action.listTodos",
        defaultMessage: "List to-dos"
    }
});
module.exports["aiMessages"] = $3d55d2ba43147efd$export$480e55f805d7990f;

});

parcelRegister("ls2Fy", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $aXWIB = parcelRequire("aXWIB");

const $19b135ef0d7ad272$export$21be832820f3e6e6 = (0, $aXWIB.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $19b135ef0d7ad272$export$21be832820f3e6e6;

});

parcelRegister("4iPjq", function(module, exports) {
parcelRequire("aqrhZ");
var $96msn = parcelRequire("96msn");


var $5wEPK = parcelRequire("5wEPK");


const $74848600c16eb369$var$LazyLinkPickerComponent = (0, $96msn.lazyForPaint)(()=>(parcelRequire("bciVA")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $74848600c16eb369$var$_default_1 = (0, $5wEPK.composeLinkPicker)($74848600c16eb369$var$LazyLinkPickerComponent);
var $74848600c16eb369$export$2e2bcd8739ae039 = $74848600c16eb369$var$_default_1;
module.exports["default"] = $74848600c16eb369$export$2e2bcd8739ae039;

});

parcelRegister("5wEPK", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

parcelRequire("aqrhZ");
var $jyd5r = parcelRequire("jyd5r");


var $bYRk6 = parcelRequire("bYRk6");


var $2lNr8 = parcelRequire("2lNr8");


var $knjgj = parcelRequire("knjgj");


var $918lS = parcelRequire("918lS");


var $jrfDA = parcelRequire("jrfDA");


var $lQSkW = parcelRequire("lQSkW");

const $99bf16152ad1d840$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $99bf16152ad1d840$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $2lNr8.COMPONENT_NAME),
    source: (0, $2lNr8.COMPONENT_NAME)
};
const $99bf16152ad1d840$var$DefaultRootComponent = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $99bf16152ad1d840$var$fixedWidthContainerStyles = null;
const $99bf16152ad1d840$var$FixedWidthContainer = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_1bsb1ubl"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb1ubl"
        ])
    });
};
const $99bf16152ad1d840$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $99bf16152ad1d840$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: $99bf16152ad1d840$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $knjgj.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lQSkW.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $2lNr8.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bf16152ad1d840$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $918lS.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jyd5r.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrfDA.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RootComponent, {
            ...props,
            "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $99bf16152ad1d840$export$922eb685ceb4a294;

});

parcelRegister("2lNr8", function(module, exports) {
const $7282d690d6f118fb$export$85183a312807388d = 'media';
const $7282d690d6f118fb$export$fc44104665f4d1e5 = 'linkPicker';
const $7282d690d6f118fb$export$452f1062ecf44be7 = 5;
const $7282d690d6f118fb$export$bf31a09f182d5584 = 342;
const $7282d690d6f118fb$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $7282d690d6f118fb$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $7282d690d6f118fb$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $7282d690d6f118fb$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $7282d690d6f118fb$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $7282d690d6f118fb$export$542fb16962bf430c;

});

parcelRegister("knjgj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $hzd6s = parcelRequire("hzd6s");

const $56c0565d5892d700$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $56c0565d5892d700$export$3285420c698bc605 = /*#__PURE__*/ (0, $42omo.createContext)($56c0565d5892d700$export$c07727f5eddb98f);
const $56c0565d5892d700$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $42omo.useRef)((0, $dQl1W.v4)());
    (0, $42omo.useEffect)(()=>{
        (0, $hzd6s.startUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
        return ()=>(0, $hzd6s.abortUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($56c0565d5892d700$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $56c0565d5892d700$export$36ecc935abdc3636 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
} : ()=>(0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $56c0565d5892d700$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $56c0565d5892d700$export$36ecc935abdc3636;

});

parcelRegister("hzd6s", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $f665373313765471$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $f665373313765471$var$ufoExperiences = {
    [$f665373313765471$export$f9c7780c574346a2.mounted]: new (0, $9801n.ConcurrentExperience)($f665373313765471$export$f9c7780c574346a2.mounted, {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $f665373313765471$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $f665373313765471$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $f665373313765471$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $f665373313765471$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $f665373313765471$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $f665373313765471$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $f665373313765471$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $f665373313765471$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $f665373313765471$export$b1021040eb94cdca;

});

parcelRegister("918lS", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hzd6s = parcelRequire("hzd6s");


var $2lNr8 = parcelRequire("2lNr8");


var $abGcM = parcelRequire("abGcM");


var $knjgj = parcelRequire("knjgj");


var $khavy = parcelRequire("khavy");


var $3blls = parcelRequire("3blls");

const $4548d496336bec74$export$e926676385687eaf = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $frIzR.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $abGcM.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
            (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $khavy.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $3blls.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    const handleError = (0, $42omo.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $abGcM.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $khavy.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3blls.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $4548d496336bec74$export$e926676385687eaf;

});

parcelRegister("abGcM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $1d2d80882026b768$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $1d2d80882026b768$export$2e2bcd8739ae039 = $1d2d80882026b768$var$createEventPayload;
module.exports["default"] = $1d2d80882026b768$export$2e2bcd8739ae039;

});

parcelRegister("khavy", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $096b317da4a8d9ff$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $096b317da4a8d9ff$export$688779ac61ee945f;

});

parcelRegister("3blls", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2lNr8 = parcelRequire("2lNr8");


var $c2ARh = parcelRequire("c2ARh");


var $atwsN = parcelRequire("atwsN");


var $lO9iE = parcelRequire("lO9iE");

const $6fbfcea2b9f5c943$var$errorBoundaryFallbackStyles = null;
const $6fbfcea2b9f5c943$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $6fbfcea2b9f5c943$export$8a28b7e38e4685dd = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_11c8i4vh"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
            minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $42omo.createElement((0, $atwsN.EmptyState), {
            header: header,
            renderImage: $6fbfcea2b9f5c943$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const header = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
    const description = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
    return /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
        minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $atwsN.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $42omo.createElement((0, $c2ARh.GenericErrorSVG), null),
        description: description
    }));
};
function $6fbfcea2b9f5c943$var$_temp() {
    return /*#__PURE__*/ $42omo.createElement((0, $c2ARh.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $6fbfcea2b9f5c943$export$8a28b7e38e4685dd;

});

parcelRegister("c2ARh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2890d1e9307e8ae4$var$SIZE = 96;
const $2890d1e9307e8ae4$var$genericErrorStyles = null;
const $2890d1e9307e8ae4$export$e54420a1a27457a4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]);
        t1 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $42omo.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $2890d1e9307e8ae4$export$e54420a1a27457a4;

});

parcelRegister("atwsN", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");

const $e8c7333955d8c82e$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $e8c7333955d8c82e$export$fddf379e22a74b00 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] !== renderImage) {
        t1 = renderImage?.();
        $[0] = renderImage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== header) {
        t2 = /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
            size: "small",
            as: "h2"
        }, header);
        $[2] = header;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== description) {
        t3 = description && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            as: "p",
            color: "color.text"
        }, description);
        $[4] = description;
        $[5] = t3;
    } else t3 = $[5];
    const t4 = action && action;
    let t5;
    if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== testId) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            xcss: $e8c7333955d8c82e$var$styles.containerV2,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t1, t2, t3, t4);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = testId;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        xcss: $e8c7333955d8c82e$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $e8c7333955d8c82e$export$fddf379e22a74b00;

});

parcelRegister("lO9iE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $562443300071d672$var$minHeightComponentStyles = null;
const $562443300071d672$export$42134e2a251518b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $562443300071d672$export$42134e2a251518b3;

});

parcelRegister("jrfDA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $lO9iE = parcelRequire("lO9iE");

const $c92e1a3420d5d33f$var$styles = null;
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $c92e1a3420d5d33f$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $c92e1a3420d5d33f$export$d96e921133238c41 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_4cvr1h6o"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $gMc0m.default)([
            "_4cvr1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $c92e1a3420d5d33f$export$d96e921133238c41;

});

parcelRegister("lQSkW", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ab7LA = parcelRequire("ab7LA");

const $6958f3d9e68e6f8d$export$54320b51a950d54a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab7LA.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab7LA.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $6958f3d9e68e6f8d$export$54320b51a950d54a;

});

parcelRegister("ab7LA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $iaMDd = parcelRequire("iaMDd");


var $3lHRF = parcelRequire("3lHRF");

const $42f9fe6b4d8a0292$export$d013d33430f9fb4b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
            defaultMessages: (0, $iaMDd.default),
            loaderFn: (0, $3lHRF.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
        defaultMessages: (0, $iaMDd.default),
        loaderFn: (0, $3lHRF.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $42f9fe6b4d8a0292$export$d013d33430f9fb4b;

});

parcelRegister("3lHRF", function(module, exports) {

var $aWYpi = parcelRequire("aWYpi");

const $b1e230aff09883c2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $b1e230aff09883c2$export$2b153a2030b0feb2;

});

parcelRegister("aWYpi", function(module, exports) {

























const $c4ed7fdc8607c9f9$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("7QabG")),
    da: ()=>(parcelRequire("fZ5cF")),
    de: ()=>(parcelRequire("et5rH")),
    en_GB: ()=>(parcelRequire("9iJaf")),
    en_ZZ: ()=>(parcelRequire("4Cnvr")),
    en: ()=>Promise.resolve((parcelRequire("iaMDd"))),
    es: ()=>(parcelRequire("98LT8")),
    fi: ()=>(parcelRequire("g7yUI")),
    fr: ()=>(parcelRequire("54msv")),
    hu: ()=>(parcelRequire("gwZUB")),
    it: ()=>(parcelRequire("xztHG")),
    ja: ()=>(parcelRequire("2KyfN")),
    ko: ()=>(parcelRequire("9Acpd")),
    nb: ()=>(parcelRequire("16lF4")),
    nl: ()=>(parcelRequire("2kH7F")),
    pl: ()=>(parcelRequire("aXcVD")),
    pt_BR: ()=>(parcelRequire("5zlIO")),
    ru: ()=>(parcelRequire("k2mlL")),
    sv: ()=>(parcelRequire("fHEUp")),
    th: ()=>(parcelRequire("khF3L")),
    tr: ()=>(parcelRequire("3Shvv")),
    uk: ()=>(parcelRequire("7MpfQ")),
    vi: ()=>(parcelRequire("bbM1s")),
    zh_TW: ()=>(parcelRequire("fbVgU")),
    zh: ()=>(parcelRequire("hDdXe"))
};
module.exports["locales"] = $c4ed7fdc8607c9f9$export$df1c34db1371eeed;

});

parcelRegister("7QabG", function(module, exports) {

let $5b554ac0a4775ef8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b554ac0a4775ef8$var$load("4Mixi"),
    $5b554ac0a4775ef8$var$load("1jsQH"),
    $5b554ac0a4775ef8$var$load("bv8GZ"),
    $5b554ac0a4775ef8$var$load("i9sd0"),
    $5b554ac0a4775ef8$var$load("i5eMd"),
    $5b554ac0a4775ef8$var$load("4DYJ5"),
    $5b554ac0a4775ef8$var$load("gyXEE"),
    $5b554ac0a4775ef8$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("fZ5cF", function(module, exports) {

let $ba3096ce98de807c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ba3096ce98de807c$var$load("cjveN"),
    $ba3096ce98de807c$var$load("deyvi"),
    $ba3096ce98de807c$var$load("cdeuH"),
    $ba3096ce98de807c$var$load("aNg21"),
    $ba3096ce98de807c$var$load("4UPfH"),
    $ba3096ce98de807c$var$load("hfFxJ"),
    $ba3096ce98de807c$var$load("1Mp9N"),
    $ba3096ce98de807c$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("et5rH", function(module, exports) {

let $a887ff903b710b1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a887ff903b710b1b$var$load("8XGJb"),
    $a887ff903b710b1b$var$load("6dERU"),
    $a887ff903b710b1b$var$load("7gF8f"),
    $a887ff903b710b1b$var$load("YEGhv"),
    $a887ff903b710b1b$var$load("gd4qs"),
    $a887ff903b710b1b$var$load("gofGr"),
    $a887ff903b710b1b$var$load("dBb6q"),
    $a887ff903b710b1b$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("9iJaf", function(module, exports) {

let $6c58d42f4a0edd59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c58d42f4a0edd59$var$load("hdvZr"),
    $6c58d42f4a0edd59$var$load("kTurq"),
    $6c58d42f4a0edd59$var$load("djb49"),
    $6c58d42f4a0edd59$var$load("d8WL7"),
    $6c58d42f4a0edd59$var$load("fviv5"),
    $6c58d42f4a0edd59$var$load("2RQvP"),
    $6c58d42f4a0edd59$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("4Cnvr", function(module, exports) {

let $35ccf1dd50685b5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35ccf1dd50685b5f$var$load("4ViGN"),
    $35ccf1dd50685b5f$var$load("j0PWv"),
    $35ccf1dd50685b5f$var$load("ksTQ6"),
    $35ccf1dd50685b5f$var$load("j5F5K"),
    $35ccf1dd50685b5f$var$load("eBoC7"),
    $35ccf1dd50685b5f$var$load("7NpX8"),
    $35ccf1dd50685b5f$var$load("cukQS"),
    $35ccf1dd50685b5f$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("98LT8", function(module, exports) {

let $6a7a020a351d74e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a7a020a351d74e8$var$load("32vlK"),
    $6a7a020a351d74e8$var$load("dlmud"),
    $6a7a020a351d74e8$var$load("5CGnz"),
    $6a7a020a351d74e8$var$load("dXu4x"),
    $6a7a020a351d74e8$var$load("bNv64"),
    $6a7a020a351d74e8$var$load("bFU3Y"),
    $6a7a020a351d74e8$var$load("3CucM"),
    $6a7a020a351d74e8$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("g7yUI", function(module, exports) {

let $bbc861f37c3af690$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bbc861f37c3af690$var$load("bjoGV"),
    $bbc861f37c3af690$var$load("cbkj0"),
    $bbc861f37c3af690$var$load("9Oxgj"),
    $bbc861f37c3af690$var$load("18TX5"),
    $bbc861f37c3af690$var$load("4Afgd"),
    $bbc861f37c3af690$var$load("exaJ2"),
    $bbc861f37c3af690$var$load("lp8Wm"),
    $bbc861f37c3af690$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("54msv", function(module, exports) {

let $3b0ebf4c93ba50be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3b0ebf4c93ba50be$var$load("8oiz7"),
    $3b0ebf4c93ba50be$var$load("17m16"),
    $3b0ebf4c93ba50be$var$load("kAg8V"),
    $3b0ebf4c93ba50be$var$load("9Cdzw"),
    $3b0ebf4c93ba50be$var$load("cMubu"),
    $3b0ebf4c93ba50be$var$load("hcCcg"),
    $3b0ebf4c93ba50be$var$load("cHWSM"),
    $3b0ebf4c93ba50be$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("gwZUB", function(module, exports) {

let $c08fa8ef165abe34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c08fa8ef165abe34$var$load("hFxmj"),
    $c08fa8ef165abe34$var$load("b4NO6"),
    $c08fa8ef165abe34$var$load("fM2oh"),
    $c08fa8ef165abe34$var$load("guNAg"),
    $c08fa8ef165abe34$var$load("3fLE9"),
    $c08fa8ef165abe34$var$load("j9KTb"),
    $c08fa8ef165abe34$var$load("b37xN"),
    $c08fa8ef165abe34$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("xztHG", function(module, exports) {

let $064e9a642f5294af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $064e9a642f5294af$var$load("BXOZB"),
    $064e9a642f5294af$var$load("1K1Fj"),
    $064e9a642f5294af$var$load("xnqy2"),
    $064e9a642f5294af$var$load("cM3gY"),
    $064e9a642f5294af$var$load("8hOn0"),
    $064e9a642f5294af$var$load("3hjAq"),
    $064e9a642f5294af$var$load("7PjNK"),
    $064e9a642f5294af$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("2KyfN", function(module, exports) {

let $200a72bdd603d235$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $200a72bdd603d235$var$load("9Xiuh"),
    $200a72bdd603d235$var$load("38sfA"),
    $200a72bdd603d235$var$load("awkVi"),
    $200a72bdd603d235$var$load("6yRq3"),
    $200a72bdd603d235$var$load("h4OCL"),
    $200a72bdd603d235$var$load("2bCHJ"),
    $200a72bdd603d235$var$load("ktSfi"),
    $200a72bdd603d235$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("9Acpd", function(module, exports) {

let $6fa1195a67639e91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6fa1195a67639e91$var$load("7Odo3"),
    $6fa1195a67639e91$var$load("bjmre"),
    $6fa1195a67639e91$var$load("11DLa"),
    $6fa1195a67639e91$var$load("cft22"),
    $6fa1195a67639e91$var$load("bcQs2"),
    $6fa1195a67639e91$var$load("fdXnq"),
    $6fa1195a67639e91$var$load("iouLY"),
    $6fa1195a67639e91$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("16lF4", function(module, exports) {

let $0cd7277e754619f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0cd7277e754619f9$var$load("4VkvT"),
    $0cd7277e754619f9$var$load("asvK9"),
    $0cd7277e754619f9$var$load("barSq"),
    $0cd7277e754619f9$var$load("gctEz"),
    $0cd7277e754619f9$var$load("aBa7j"),
    $0cd7277e754619f9$var$load("cItJR"),
    $0cd7277e754619f9$var$load("hPZE5"),
    $0cd7277e754619f9$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("2kH7F", function(module, exports) {

let $1b2ee6483a0770cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b2ee6483a0770cc$var$load("g5qJV"),
    $1b2ee6483a0770cc$var$load("7v6wU"),
    $1b2ee6483a0770cc$var$load("a8heY"),
    $1b2ee6483a0770cc$var$load("9PPH7"),
    $1b2ee6483a0770cc$var$load("b544F"),
    $1b2ee6483a0770cc$var$load("SctKm"),
    $1b2ee6483a0770cc$var$load("dzIm8"),
    $1b2ee6483a0770cc$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("aXcVD", function(module, exports) {

let $7f997165c7ba8892$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f997165c7ba8892$var$load("dPa6p"),
    $7f997165c7ba8892$var$load("aEpRh"),
    $7f997165c7ba8892$var$load("6hlNE"),
    $7f997165c7ba8892$var$load("1y1eN"),
    $7f997165c7ba8892$var$load("K6fhx"),
    $7f997165c7ba8892$var$load("1fJz1"),
    $7f997165c7ba8892$var$load("jqwnR"),
    $7f997165c7ba8892$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("5zlIO", function(module, exports) {

let $40e1121b9ee6c93d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40e1121b9ee6c93d$var$load("iG4uh"),
    $40e1121b9ee6c93d$var$load("3fuR9"),
    $40e1121b9ee6c93d$var$load("2bqSD"),
    $40e1121b9ee6c93d$var$load("e8jpx"),
    $40e1121b9ee6c93d$var$load("gZU54"),
    $40e1121b9ee6c93d$var$load("9yA8o"),
    $40e1121b9ee6c93d$var$load("bGhLc"),
    $40e1121b9ee6c93d$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("k2mlL", function(module, exports) {

let $e96554c98c9bc495$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e96554c98c9bc495$var$load("9tVE8"),
    $e96554c98c9bc495$var$load("fMrUo"),
    $e96554c98c9bc495$var$load("bJykp"),
    $e96554c98c9bc495$var$load("fjbzp"),
    $e96554c98c9bc495$var$load("4Wdqb"),
    $e96554c98c9bc495$var$load("448N7"),
    $e96554c98c9bc495$var$load("9v6ER"),
    $e96554c98c9bc495$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("fHEUp", function(module, exports) {

let $b6ea9acd9e8be017$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b6ea9acd9e8be017$var$load("6UAlo"),
    $b6ea9acd9e8be017$var$load("9eNkX"),
    $b6ea9acd9e8be017$var$load("dh2Er"),
    $b6ea9acd9e8be017$var$load("1pFHs"),
    $b6ea9acd9e8be017$var$load("k10Cs"),
    $b6ea9acd9e8be017$var$load("gBDdh"),
    $b6ea9acd9e8be017$var$load("8Mz40"),
    $b6ea9acd9e8be017$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("khF3L", function(module, exports) {

let $ec453ec2806faba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec453ec2806faba2$var$load("jYGxH").then(()=>parcelRequire('hlxQj'));

});

parcelRegister("3Shvv", function(module, exports) {

let $2d23fecbe4644720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d23fecbe4644720$var$load("czAFw").then(()=>parcelRequire('gQkbc'));

});

parcelRegister("7MpfQ", function(module, exports) {

let $5aa09b1e53b19903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa09b1e53b19903$var$load("c0Efy").then(()=>parcelRequire('lC9hp'));

});

parcelRegister("bbM1s", function(module, exports) {

let $8255f915989d7a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8255f915989d7a01$var$load("dKBuH").then(()=>parcelRequire('fzD7h'));

});

parcelRegister("fbVgU", function(module, exports) {

let $b0f44f1323f5f3cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0f44f1323f5f3cb$var$load("ia9y3"),
    $b0f44f1323f5f3cb$var$load("j9OUx"),
    $b0f44f1323f5f3cb$var$load("bV8sS"),
    $b0f44f1323f5f3cb$var$load("kKXTS"),
    $b0f44f1323f5f3cb$var$load("l079e"),
    $b0f44f1323f5f3cb$var$load("ebljE"),
    $b0f44f1323f5f3cb$var$load("hF4v3"),
    $b0f44f1323f5f3cb$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("hDdXe", function(module, exports) {

let $cd60e73a24cb5f53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd60e73a24cb5f53$var$load("15ncj"),
    $cd60e73a24cb5f53$var$load("gDiIK"),
    $cd60e73a24cb5f53$var$load("eLlpV"),
    $cd60e73a24cb5f53$var$load("7sItg"),
    $cd60e73a24cb5f53$var$load("f1B4n"),
    $cd60e73a24cb5f53$var$load("j4dSZ"),
    $cd60e73a24cb5f53$var$load("1Tuyb"),
    $cd60e73a24cb5f53$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("bciVA", function(module, exports) {

let $826f7f5a9202e719$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $826f7f5a9202e719$var$load("6wr18"),
    $826f7f5a9202e719$var$load("7EorR"),
    $826f7f5a9202e719$var$load("ffEVr"),
    $826f7f5a9202e719$var$load("Wowvf"),
    $826f7f5a9202e719$var$load("hhss7"),
    $826f7f5a9202e719$var$load("oTA4y"),
    $826f7f5a9202e719$var$load("fPbCp"),
    $826f7f5a9202e719$var$load("c0JsV")
]).then(()=>parcelRequire('cDSVd'));

});

parcelRegister("1MUpo", function(module, exports) {
const $72d61fc920bbc248$export$27903d543b563e39 = (attrs)=>(...content)=>({
            type: 'bodiedExtension',
            attrs: attrs,
            content: content
        });
module.exports["bodiedExtension"] = $72d61fc920bbc248$export$27903d543b563e39;

});

parcelRegister("cc99d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0cd8dd83f623ffc8a93c918c96c1a11>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e0db38dacc0710f$var$_react = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("42omo")));

var $8e0db38dacc0710f$var$_baseNew = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8e0db38dacc0710f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e0db38dacc0710f$var$FieldTextIcon = (props)=>/*#__PURE__*/ $8e0db38dacc0710f$var$_react.default.createElement($8e0db38dacc0710f$var$_baseNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$8e0db38dacc0710f$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $8e0db38dacc0710f$var$_default = module.exports.default = $8e0db38dacc0710f$var$FieldTextIcon;

});

parcelRegister("kYvrE", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $f451cd8c9de7a9df$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $f451cd8c9de7a9df$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $42omo.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $676464c7222bdee0$export$68e22604851d391b = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
};
const $676464c7222bdee0$export$8ebf7a2378ada555 = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
};
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("liGyh", function(module, exports) {

var $dIPzP = parcelRequire("dIPzP");


var $42omo = parcelRequire("42omo");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");


var $jMyy4 = parcelRequire("jMyy4");


var $1rdvc = parcelRequire("1rdvc");

const $ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery = (0, $dIPzP.default);
const $ba57c93125c5375a$var$logger = (0, $7W8i8.getLogger)('comment-query-params');
const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location, queryArchivedContent: queryArchivedContent = false } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: legacyData, error: legacyError } = (0, $jMyy4.useQueryInterop)($ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery, {
        variables: {
            commentId: targetCommentId,
            contentStatus: [
                queryArchivedContent ? (0, $1rdvc.GraphQLContentStatus).ARCHIVED : (0, $1rdvc.GraphQLContentStatus).DRAFT,
                (0, $1rdvc.GraphQLContentStatus).CURRENT
            ]
        },
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        __callerPackage__: "@confluence/comment"
    });
    if (legacyError) $ba57c93125c5375a$var$logger.error`Error: Unable to query comment location for ${commentId}`;
    // Determine error state - use new flow error or old flow error
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? commentError : legacyError;
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    // Extract location and container ID from either new or old flow
    const commentLocation = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location?.type : legacyData?.comments?.nodes?.[0]?.location?.type;
    // Extract container ID from either new or old flow
    let commentContainerId;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
        commentContainerId = comment.container?.id;
        else commentContainerId = undefined;
    } else commentContainerId = legacyData?.comments?.nodes?.[0]?.container?.id;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === commentLocation) && (pageId === commentContainerId || commentContainerId === undefined && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false));
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParams = (0, $42omo.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("dIPzP", function(module, exports) {
/**
 * @generated SignedSource<<221cd0274b1b44eaf8c01d1dd00eeb04>>
 * @relayHash ab6c713571991d15a172cc151a881572
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae
const $c1e2aac1eea196bd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ]
                        },
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentQueryParamsCommentLocationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentQueryParamsCommentLocationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ab6c713571991d15a172cc151a881572",
            "id": "f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae",
            "metadata": {},
            "name": "useCommentQueryParamsCommentLocationQuery",
            "operationKind": "query",
            "text": "query useCommentQueryParamsCommentLocationQuery($commentId:ID,$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId,contentStatus:$contentStatus){nodes{container{id},location{__typename,type},id}}}"
        }
    };
}();
$c1e2aac1eea196bd$var$node.hash = "60bed37eee2f8a7739db095067b4457b";
var $c1e2aac1eea196bd$export$2e2bcd8739ae039 = $c1e2aac1eea196bd$var$node;
module.exports["default"] = $c1e2aac1eea196bd$export$2e2bcd8739ae039;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");


var $6mKj3 = parcelRequire("6mKj3");

const $6b00aa328c211ce7$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_offline_fix', 'isEnabled', true)
            }
        }
    };
};
const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["buildMutationContextForNoNetworkError"] = $6b00aa328c211ce7$export$5c24224d7e29c719;
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: explicitlySkipped = false } = options;
    // Skip queries if experiment is disabled or explicitly skipped through options
    const skip = explicitlySkipped || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $42omo.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && processedCommentsData.isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "@confluence/comments-data-manager"
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $42omo.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (processedCommentsData.isDataProcessed) {
            if (commentId) {
                const cachedComment = processedCommentsData.flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = processedCommentsData.flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.map((node)=>node).filter((node)=>node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        processedCommentsData.flatCommentsMap,
        processedCommentsData.flatMarkerRefMap,
        processedCommentsData.isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $42omo.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && processedCommentsData.isDataProcessed && !oneCommentData.loading && !processedCommentsData.error && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        processedCommentsData.isDataProcessed,
        processedCommentsData.error,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $42omo.useMemo)(()=>{
        return validationError || processedCommentsData.error || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsData.error,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $42omo.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !processedCommentsData.isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "@confluence/comments-data-manager"
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<1ab88c86ecf711245680266df88d829b>>
 * @relayHash 30943931b9ef970914fcabde1ec18427
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v9 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v25 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v26 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "number"
    }, v28 = {
        "kind": "ScalarField",
        "name": "when"
    }, v29 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        v26 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v27 /*: any*/ ,
                                v28 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ 
        },
        "params": {
            "cacheID": "30943931b9ef970914fcabde1ec18427",
            "id": "e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "e144cc71550d14f94a82d8439ed2ba0e";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("NYiei", function(module, exports) {

var $1Pttz = parcelRequire("1Pttz");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");

const $bd3b81debc212a33$export$ef1591875b2a95ef = 1500;
const $bd3b81debc212a33$export$a1c5d5765ca44631 = [
    'DRAFT',
    'CURRENT',
    'ARCHIVED',
    'DELETED'
];
const $bd3b81debc212a33$export$a5752cd8da7feaeb = (0, $1Pttz.default);
const $bd3b81debc212a33$export$66fa4e722aa8c832 = (contentId)=>({
        pageId: contentId,
        contentStatus: $bd3b81debc212a33$export$a1c5d5765ca44631,
        first: $bd3b81debc212a33$export$ef1591875b2a95ef
    });
const $bd3b81debc212a33$var$addCommentRootToCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount })=>{
    const updatedRootComments = [
        ...cachedRootComments
    ];
    let updatedTotalCount = totalCount;
    // If there is already a comment with the same ID in the root array, replace it
    // Normally this shouldn't happen because new comments should always have unique IDs, but there
    // is a case were this can happen with replies (see below) - so let's be safe and handle it just
    // in case it ever happens with root comments as well.
    const existingRootIndex = updatedRootComments.findIndex((comment)=>newComment?.id && comment?.id === newComment?.id);
    if (existingRootIndex !== -1) updatedRootComments[existingRootIndex] = newComment;
    else {
        // Else add the newly added comment to the end of the root comments list
        updatedRootComments.push(newComment);
        // Increment total count. Note that we can only add individual comments without any replies, but
        // let's be safe and adjust for any replies in case this ever changes
        updatedTotalCount += repliesCount + 1;
    }
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$addCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to add the reply from the top-level parent's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE). So to add a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array, as the original is readonly
        const updatedReplies = [
            ...parentComment.replies
        ];
        // If there is already a reply with the same ID in the parent's replies, replace it
        // Normally this shouldn't happen because new comments should always have unique IDs, but there
        // is a case were this can happen - when we're in edit mode and another user who is also in
        // edit mode also adds a reply to comment on the new text and then Updates the page -> we get
        // the new reply via the pubsub events and again when the new text is added by the Update.
        const existingReplyIndex = updatedReplies.findIndex((reply)=>newComment?.id && reply?.id === newComment?.id);
        if (existingReplyIndex !== -1) updatedReplies[existingReplyIndex] = newComment;
        else {
            // Else add the new  reply to the array
            updatedReplies.push(newComment);
            // Increment total count. We can only add individual comments without any replies, but let's be
            // safe and adjust for any replies in case this ever changes
            updatedTotalCount += 1 + repliesCount;
        }
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
    } else // Parent comment not found
    error = Error(`Cannot add reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$addCommentToCache = ({ cachedRootComments: cachedRootComments, newComment: newComment, totalCount: totalCount })=>{
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = newComment?.parentId;
    const repliesCount = newComment?.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$addCommentRootToCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$addCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$var$deleteRootCommentInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount })=>{
    let updatedTotalCount = totalCount;
    // Remove the newly resolved comment from the list if we can find it
    // Create a copy of the root comment array without the deleted reply, as the original is readonly
    const updatedRootComments = cachedRootComments.filter((comment)=>comment?.id !== commentId);
    // Decrement total count - currently we can't delete a reply that has any comments, but
    // let's be safe and adjust for any replies in case this ever changes
    updatedTotalCount -= 1 + repliesCount;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$deleteCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to remove the reply from the top-level comment's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE).  So to remove a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array without the deleted reply, as the original
        // is readonly
        const updatedReplies = (parentComment.replies || []).filter((reply)=>reply?.id !== commentId);
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Decrement total count. Currently we can't delete a reply that has any comments. Also
        // since we can’t have spread fragments in Relay-friendly queries yet, the current
        // CommentReply type doesn't have a `replies` field. And the backend, sends the nested
        // replies to us in a flat list with the correct parentIDs so the FE must manually nest
        // them. But let's adjust the count for replies just in case this ever changes.
        updatedTotalCount -= 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot delete reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$removeCommentFromCache = ({ cachedRootComments: cachedRootComments, commentId: commentId, totalCount: totalCount })=>{
    // Find the comment to delete to determine if it's a root comment or a reply
    const commentToDelete = (0, $kgNLQ.findCommentInData)(cachedRootComments, commentId);
    if (!commentToDelete) return {
        updatedRootComments: [],
        updatedTotalCount: 0,
        error: new Error(`Cannot delete comment in cache: comment with ID ${commentId} not found`)
    };
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = commentToDelete.parentId;
    const repliesCount = commentToDelete.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$deleteRootCommentInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$deleteCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$export$19f817fe57f17368 = ({ contentId: contentId, options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onCompleted: parentOnCompleted, onError: onError } = options;
    // Shared handling for query errors (initial load and refetch): mark certain errors as handled, then invoke callback.
    // WS-3494 / COMMENTS-188
    const applyQueryErrorHandling = (0, $42omo.useCallback)((error, callback)=>{
        if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        callback?.(error);
    }, []);
    const handleQueryError = (0, $42omo.useCallback)((error)=>applyQueryErrorHandling(error, onError), [
        applyQueryErrorHandling,
        onError
    ]);
    // Skip query if experiment is disabled, no content ID, or explicitly skipped
    const shouldSkip = !contentId || !!options.skip || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    const queryResponse = (0, $jMyy4.useQueryInterop)($bd3b81debc212a33$export$a5752cd8da7feaeb, {
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId ?? ''),
        skip: shouldSkip,
        context: {
            single: true
        },
        fetchPolicy: // We auto-batch queries that fire within 10ms of eachother. Since this query is slow, this unbatches it to avoid slowing down everything else
        fetchPolicy,
        onCompleted: (data)=>{
            parentOnCompleted?.(data);
        },
        onError: handleQueryError,
        __callerPackage__: "@confluence/comments-data-manager"
    });
    const refetch = (0, $42omo.useCallback)(async ({ onError: refetchOnError } = {})=>{
        try {
            return await queryResponse.refetch();
        } catch (error) {
            applyQueryErrorHandling(error, refetchOnError ?? onError);
        }
    }, [
        queryResponse,
        applyQueryErrorHandling,
        onError
    ]);
    const addCommentInCache = (0, $42omo.useCallback)(({ newComment: newComment, onError: onError })=>{
        // If the new comment is a root comment, we need to add it to the root comments list and
        // update the main query's cache and totalCount. If it's a reply, we need to add it to its
        // parent comments's replies list in the cache - but we still  update the whole main query
        // (vs. just update the parent comment itself via a fragment update) because we need to
        // update the main query's totalCount in the cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                __callerPackage__: "@confluence/comments-data-manager"
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$addCommentToCache({
                cachedRootComments: cachedRootComments,
                newComment: newComment,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "@confluence/comments-data-manager"
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when adding new comment to cache with ID ${newComment?.id}: ${err}`));
        }
    }, [
        contentId
    ]);
    const deleteCommentInCache = (0, $42omo.useCallback)(({ commentId: commentId, onError: onError })=>{
        // First, we try to find the comment to determine if it's a root comment or a reply.  If it's a
        // root comment, we need to remove it from the root comments list and update the main query's
        // cache and totalCount. If it's a reply, we need to update its parent comments's replies list
        // in the cache - but we still  update the whole main query (vs. just update the parent comment
        // itself via a fragment update) because we need to update the main query's totalCount in the
        // cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                __callerPackage__: "@confluence/comments-data-manager"
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$removeCommentFromCache({
                cachedRootComments: cachedRootComments,
                commentId: commentId,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return false;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "@confluence/comments-data-manager"
            });
            return true;
        } catch (err) {
            onError?.(new Error(`An error occurred when deleting cached comment with ID ${commentId}: ${err}`));
            return false;
        }
    }, [
        contentId
    ]);
    return {
        loading: queryResponse.loading,
        error: queryResponse.error,
        refetch: refetch,
        data: queryResponse.data,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    };
};
const $bd3b81debc212a33$export$713a041e7ad7d7c4 = (contentId)=>{
    const dataProxy = (0, $l1uFv.readQueryInterop)({
        query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
        __callerPackage__: "@confluence/comments-data-manager"
    });
    return dataProxy;
};
module.exports["MAX_COMMENTS_TO_RETURN"] = $bd3b81debc212a33$export$ef1591875b2a95ef;
module.exports["allContentStatuses"] = $bd3b81debc212a33$export$a1c5d5765ca44631;
module.exports["useAllCommentsData"] = $bd3b81debc212a33$export$19f817fe57f17368;
module.exports["getCommentsDataFromCache"] = $bd3b81debc212a33$export$713a041e7ad7d7c4;

});

parcelRegister("1Pttz", function(module, exports) {
/**
 * @generated SignedSource<<88a71c42d0cb01ab5e7d98601a8ad2dc>>
 * @relayHash e661073d22fa388ab2cfa6921674c35d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6
const $e5d3dc3314ebdbc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "e661073d22fa388ab2cfa6921674c35d",
            "id": "a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6",
            "metadata": {},
            "name": "useAllCommentsDataQuery",
            "operationKind": "query",
            "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$e5d3dc3314ebdbc2$var$node.hash = "776a014f361baa317c627109df7aaaa3";
var $e5d3dc3314ebdbc2$export$2e2bcd8739ae039 = $e5d3dc3314ebdbc2$var$node;
module.exports["default"] = $e5d3dc3314ebdbc2$export$2e2bcd8739ae039;

});

parcelRegister("1rdvc", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $39a1d37ae379d69e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["GraphQLContentStatus"] = $39a1d37ae379d69e$export$b634e5de755b7d35;

});

parcelRegister("9Z1sw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $eq95w = parcelRequire("eq95w");


var $42omo = parcelRequire("42omo");


var $iRRvH = parcelRequire("iRRvH");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $frIzR.c)(3);
    const batchContext = (0, $42omo.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $frIzR.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    if (!panelHasContent) return children;
    const t1 = `web-panel-${locationName}`;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: t1
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "@confluence/web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $42omo.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $42omo.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $42omo.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "@confluence/web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("1eaCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $frIzR.c)(18);
    const { html: html, panelId: panelId } = t0;
    const containerRef = (0, $42omo.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $42omo.useState)(true);
    let t1;
    if ($[0] !== html) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[2] = t2;
        } else t2 = $[2];
        t1 = html.match(t2);
        $[0] = html;
        $[1] = t1;
    } else t1 = $[1];
    const moduleLocationMatch = t1;
    let t2;
    if ($[3] !== moduleLocationMatch) {
        t2 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[3] = moduleLocationMatch;
        $[4] = t2;
    } else t2 = $[4];
    const isMatchForActivatable = t2;
    let t3;
    if ($[5] !== isMatchForActivatable || $[6] !== ssrSuccess) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[5] = isMatchForActivatable;
        $[6] = ssrSuccess;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== html || $[9] !== isMatchForActivatable || $[10] !== panelId || $[11] !== ssrSuccess) {
        t4 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[8] = html;
        $[9] = isMatchForActivatable;
        $[10] = panelId;
        $[11] = ssrSuccess;
        $[12] = t4;
    } else t4 = $[12];
    (0, $42omo.useLayoutEffect)(t3, t4);
    let t5;
    if ($[13] !== html || $[14] !== isMatchForActivatable || $[15] !== panelId || $[16] !== ssrSuccess) {
        t5 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[13] = html;
        $[14] = isMatchForActivatable;
        $[15] = panelId;
        $[16] = ssrSuccess;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("6UM2Q", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

const $68e0b10beef6f399$export$1db2f2faaee8467f = (0, $3u0dr.isReactCompilerActiveV2)() ? function ActivatableComponent(t0) {
    const $ = (0, $frIzR.c)(26);
    const { children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9s45p.makeGate)();
        $[0] = t1;
    } else t1 = $[0];
    const gate = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[1] !== children) {
        t2 = ()=>children;
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    const renderChildren = t2;
    let t3;
    if ($[3] !== analyticsName || $[4] !== createAnalyticsEvent || $[5] !== id || $[6] !== onActivate || $[7] !== triggers) {
        t3 = (reason)=>{
            if (gate?.getStatus() === "suspended") {
                onActivate?.(reason);
                if (analyticsName) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "activatableComponent",
                        action: "activated",
                        actionSubject: "activatableComponent",
                        attributes: {
                            analyticsName: analyticsName,
                            triggers: triggers,
                            boundaryId: id,
                            activationReason: reason
                        }
                    }
                }).fire();
                gate.resolve();
            }
        };
        $[3] = analyticsName;
        $[4] = createAnalyticsEvent;
        $[5] = id;
        $[6] = onActivate;
        $[7] = triggers;
        $[8] = t3;
    } else t3 = $[8];
    const activateComponent = t3;
    let t4;
    if ($[9] !== activateComponent || $[10] !== analyticsName || $[11] !== id || $[12] !== triggers) {
        t4 = {
            triggers: triggers,
            gate: gate,
            activateComponent: activateComponent,
            boundaryId: id,
            analyticsName: analyticsName
        };
        $[9] = activateComponent;
        $[10] = analyticsName;
        $[11] = id;
        $[12] = triggers;
        $[13] = t4;
    } else t4 = $[13];
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)(t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = gate?.getStatus?.();
        $[14] = t5;
    } else t5 = $[14];
    const t6 = analyticsName || id;
    let t7;
    if ($[15] !== activateComponent || $[16] !== id || $[17] !== renderChildren || $[18] !== ssrSuccess || $[19] !== t6 || $[20] !== triggers) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75bK2.Boundary), {
            gate: gate,
            id: id,
            render: renderChildren,
            ssrSuccess: ssrSuccess,
            activateComponent: activateComponent,
            resolved: t5 === "resolved",
            boundaryName: t6,
            triggers: triggers
        });
        $[15] = activateComponent;
        $[16] = id;
        $[17] = renderChildren;
        $[18] = ssrSuccess;
        $[19] = t6;
        $[20] = triggers;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== hostRefWithActivation || $[23] !== id || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: hostRefWithActivation,
            "data-hydration-shield": id
        }, t7);
        $[22] = hostRefWithActivation;
        $[23] = id;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function ActivatableComponent({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $42omo.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const renderChildren = (0, $42omo.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $42omo.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
};
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("i6UMJ", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $422HI = parcelRequire("422HI");


var $7Oxky = parcelRequire("7Oxky");


var $8i27m = parcelRequire("8i27m");


var $6faGq = parcelRequire("6faGq");


var $9wGTI = parcelRequire("9wGTI");


var $3mVfX = parcelRequire("3mVfX");

const $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $6ed006a18ff2d87d$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $6ed006a18ff2d87d$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
var $6ed006a18ff2d87d$export$50c823aead020a09 = /*#__PURE__*/ function(LocationValue) {
    LocationValue["PANEL"] = "panel";
    LocationValue["FOOTER"] = "footer";
    LocationValue["STANDALONE"] = "standalone";
    return LocationValue;
}({});
const $6ed006a18ff2d87d$export$68e3ad656cdca3ec = (orderedActiveAnnotationIdList)=>{
    return orderedActiveAnnotationIdList.slice(0, Math.min(orderedActiveAnnotationIdList.length, (0, $7Oxky.COMMENT_BATCH_SIZE))).filter((item)=>!item.isLoaded) // only get the ones that are not loaded yet
    .map((item)=>item.threadKey);
};
const $6ed006a18ff2d87d$var$getDanglingComments = ({ commentsDataMap: commentsDataMap, annotationsSet: annotationsSet, openCommentThreads: openCommentThreads })=>{
    // Add dangling comments and handle real-time changes
    for(const threadKey in commentsDataMap.inline){
        const commentThread = commentsDataMap.inline[threadKey];
        const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling;
        if (commentThread?.isOpen) {
            // if the comment is already dangling, we want to add it to the list
            if (isDanglingComment) {
                const markerRef = commentThread?.location?.inlineMarkerRef;
                // comment is no longer dangling if it has a marker ref and is in the annotations set
                if (markerRef && annotationsSet && annotationsSet.has(markerRef)) {
                    const inlineLocation = commentThread.location;
                    const updatedCommentThread = {
                        ...commentThread,
                        location: {
                            ...commentThread.location,
                            inlineResolveProperties: {
                                ...inlineLocation.inlineResolveProperties,
                                isDangling: false
                            }
                        }
                    };
                    openCommentThreads.push(updatedCommentThread);
                } else openCommentThreads.push(commentThread);
                continue;
            }
            // check for real time dangling comments
            const markerRef = commentThread?.location?.inlineMarkerRef;
            // comment is dangling if it has a marker ref and is not in the annotations set
            // deleted and resolved comments are not in commentsDataMap so we know it's only dangling scenario
            // we do this here so the view will update immediately, but the actual mutation is handled in useDanglingOperations
            if (markerRef && annotationsSet && !annotationsSet.has(markerRef)) {
                const inlineLocation = commentThread.location;
                const updatedCommentThread = {
                    ...commentThread,
                    location: {
                        ...commentThread.location,
                        inlineResolveProperties: {
                            ...inlineLocation.inlineResolveProperties,
                            isDangling: true
                        }
                    }
                };
                openCommentThreads.push(updatedCommentThread);
            }
        }
    }
};
const $6ed006a18ff2d87d$export$aa9a5ed6405f18d6 = ({ commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, removedThreadsMap: removedThreadsMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const openCommentThreads = [];
    const annotationsSet = new Set(orderedActiveAnnotationIdList.map((item)=>item.threadKey));
    // inline comments
    if (showInlineComments && location === "panel") {
        const removedAnnotationIds = new Set(Object.values(removedThreadsMap.inline));
        const filteredActiveAnnotationIds = orderedActiveAnnotationIdList.filter((item)=>!removedAnnotationIds.has(item.threadKey));
        const totalAnnotationsCount = filteredActiveAnnotationIds.length + Object.keys(removedThreadsMap).length;
        let activeIndex = 0; // Track position in filteredActiveAnnotationIds
        for(let i = 0; i < totalAnnotationsCount; i++){
            let threadKey = '';
            if (removedThreadsMap.inline.hasOwnProperty(i)) {
                threadKey = removedThreadsMap.inline[i];
                const commentThread = commentsDataMap.inline[threadKey];
                if (commentThread) openCommentThreads.push(commentThread);
            } else if (activeIndex < filteredActiveAnnotationIds.length) {
                threadKey = filteredActiveAnnotationIds[activeIndex].threadKey;
                const commentThread = commentsDataMap.inline[threadKey];
                // dangling comments had a marker ref and will be inside commentsDataMap, so we want to ignore these first
                const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                // Don't add if it's dangling or might become dangling (has marker ref but not in annotations set)
                const markerRef = commentThread?.location?.inlineMarkerRef;
                const mightBecomeDangling = markerRef && annotationsSet && !annotationsSet.has(markerRef);
                if (commentThread?.isOpen && !isDanglingComment && !mightBecomeDangling) openCommentThreads.push(commentThread);
                activeIndex++;
            }
        }
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) $6ed006a18ff2d87d$var$getDanglingComments({
            commentsDataMap: commentsDataMap,
            openCommentThreads: openCommentThreads,
            annotationsSet: annotationsSet
        });
    }
    // general comments
    if (showGeneralComments || location === "footer") {
        // We can just push these in the order we have them because we have no concept of "active"
        const generalComments = Object.values(commentsDataMap.general).filter((generalComment)=>{
            return generalComment.isOpen || generalComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
        });
        openCommentThreads.push(...generalComments);
    }
    return openCommentThreads;
};
const $6ed006a18ff2d87d$export$4fc364cd63a9b204 = ({ commentsDataMap: commentsDataMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const resolvedCommentThreads = [];
    // inline comments
    if (showInlineComments && location === "panel") for(const key in commentsDataMap.inline){
        const comment = commentsDataMap.inline[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    // general comments
    if (showGeneralComments) for(const key in commentsDataMap.general){
        const comment = commentsDataMap.general[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    return resolvedCommentThreads;
};
const $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime = (comment)=>{
    const commentLocation = comment.location;
    const resolvedTime = commentLocation?.inlineResolveProperties?.resolvedTime || commentLocation?.commentResolveProperties?.resolvedTime; // from the BE, this is for both reopened and resolved time, in milliseconds
    return resolvedTime || (0, $6faGq.getValidDate)(comment.createdAtNonLocalized).getTime(); // getTime() returns milliseconds
};
const $6ed006a18ff2d87d$export$d2935240a910e26e = (currentSort, commentThreads)=>{
    if (currentSort === (0, $3mVfX.SortValues).MOST_RECENT) return [
        ...commentThreads
    ].sort((a, b)=>$6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(b) - $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(a));
    return commentThreads;
};
const $6ed006a18ff2d87d$export$47f9a121266175f = (annotations)=>annotations.map((annotation)=>annotation.threadKey);
const $6ed006a18ff2d87d$export$7119b2a60583b6dc = (marks = [])=>marks.map((mark)=>mark.attrs.id);
const $6ed006a18ff2d87d$export$b02d74cde949c060 = (commentA, commentB)=>(0, $6faGq.getValidDate)(commentA?.createdAtNonLocalized).getTime() - (0, $6faGq.getValidDate)(commentB?.createdAtNonLocalized).getTime();
const $6ed006a18ff2d87d$export$5425fcea1abfd6f7 = (error)=>{
    if (!error) // if falsy, consider it as NOT containing non-reactionsSummary errors
    return true;
    else if (error instanceof (0, $422HI.ApolloErrorInterop) || error instanceof (0, $9wEpK.ApolloError)) {
        // TODO we will need to migrate to ApolloRelayInterops to get proper error type of ApolloErrorInterop instead of ApolloError
        // after migration, we can remove the instanceof ApolloError check here
        const hasOtherGqlErrors = error.graphQLErrors?.filter((e)=>!e.path?.includes('reactionsSummary'))?.length > 0;
        return !hasOtherGqlErrors && !error.networkError;
    } else // if truthy but not an ApolloErrorInterop, consider it as containing non-reactionsSummary errors
    return false;
};
module.exports["LocationValue"] = $6ed006a18ff2d87d$export$50c823aead020a09;
module.exports["getOpenCommentThreads"] = $6ed006a18ff2d87d$export$aa9a5ed6405f18d6;
module.exports["getResolvedCommentThreads"] = $6ed006a18ff2d87d$export$4fc364cd63a9b204;
module.exports["getSortedCommentThreads"] = $6ed006a18ff2d87d$export$d2935240a910e26e;
module.exports["getAnnotationThreadKeys"] = $6ed006a18ff2d87d$export$47f9a121266175f;
module.exports["getMarkIds"] = $6ed006a18ff2d87d$export$7119b2a60583b6dc;
module.exports["getCommentsSortedOldestToNewest"] = $6ed006a18ff2d87d$export$b02d74cde949c060;
module.exports["onlyHasReactionsSummaryErrors"] = $6ed006a18ff2d87d$export$5425fcea1abfd6f7;

});

parcelRegister("7Oxky", function(module, exports) {

var $9j86J = parcelRequire("9j86J");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $jMyy4 = parcelRequire("jMyy4");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery = (0, $9j86J.default);
const $9d95853344936385$export$e8d93aa39e79e9aa = 1000; // setting to 1000 for now until we implement infinite scroll for the comments panel
const $9d95853344936385$export$6ddede7674b6d70f = ({ pageId: pageId, markerRefList: markerRefList, skip: skip = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || markerRefList.length === 0 || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0;
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery, {
        variables: {
            pageId: pageId,
            inlineMarkerRefList: markerRefList,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ]
        },
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: skipQuery ? 'cache-only' : 'cache-and-network',
        // We want to utilize the cache as much as possible, but keep the list up to date if it changes
        skip: skipQuery,
        onCompleted: (result)=>{
            (0, $3ZsvI.updateCommentsDataState)({
                data: result,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            setLoading(false);
        },
        onError: (err)=>{
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (err.message.search(/reactions/i) !== -1 || err.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(err);
            setLoading(false);
        },
        __callerPackage__: "@confluence/comments-data"
    });
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    return {
        loading: !skipQuery ? loading : false,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["COMMENT_BATCH_SIZE"] = $9d95853344936385$export$e8d93aa39e79e9aa;

});

parcelRegister("9j86J", function(module, exports) {
/**
 * @generated SignedSource<<c36f8ff279465cc8e51c147ad27df0fc>>
 * @relayHash 7f2f5b1f8eabf86158412fc6d30f35d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13f41a7981b1d0d7a2ba4907ee0baedf14ff9510a934a126d5407f86dc09ff15
const $1a28e5c1a6e6a8b1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRefList"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRefList",
            "variableName": "inlineMarkerRefList"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v19 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v21 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v29 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v32 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7f2f5b1f8eabf86158412fc6d30f35d6",
            "id": "13f41a7981b1d0d7a2ba4907ee0baedf14ff9510a934a126d5407f86dc09ff15",
            "metadata": {},
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "operationKind": "query",
            "text": "query useActiveInlineCommentsQueryActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$1a28e5c1a6e6a8b1$var$node.hash = "55c0fbf12929f614cd8832ad8c70d69e";
var $1a28e5c1a6e6a8b1$export$2e2bcd8739ae039 = $1a28e5c1a6e6a8b1$var$node;
module.exports["default"] = $1a28e5c1a6e6a8b1$export$2e2bcd8739ae039;

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $aXWIB.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $42omo.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


});

parcelRegister("1YXTQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $aXWIB.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    const localeLanguage = new Intl.Locale(locale).language;
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $42omo.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $42omo.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "@confluence/page-info"
    });
    return (0, $42omo.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<a52aa17c9371e87ad68639adf48d413b>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("a6t12", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $8j9VY = parcelRequire("8j9VY");


var $2TEGg = parcelRequire("2TEGg");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("5XsiK");
var $lfSOe = parcelRequire("lfSOe");


var $6OL2O = parcelRequire("6OL2O");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $aXWIB.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $6OL2O.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = (0, $lfSOe.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $42omo.useMemo)(()=>(0, $lfSOe.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        }), [
        push,
        userId,
        userProfile
    ]);
    const followUserAction = (0, $42omo.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $42omo.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $42omo.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        if ((0, $lfSOe.isTeamsAppEnabled)()) {
            getReportingLinesUserProfile(clickedUserId_0).onNavigate();
            return false;
        }
        if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, '', (0, $jlIaF.CONTEXT_PATH)), '_blank', 'noreferrer');
        else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, ()=>{});
    };
    if ((0, $9wGTI.fg)('people-teams_migrate-user-profile-card')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2TEGg.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        trigger: trigger,
        actions: [
            followUserActionNext
        ],
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("5XsiK", function(module, exports) {
$parcel$export(module.exports, "isTeamsAppEnabled", () => (parcelRequire("lfSOe")).isTeamsAppEnabled);

var $lfSOe = parcelRequire("lfSOe");


});

parcelRegister("lfSOe", function(module, exports) {

var $hbEOA = parcelRequire("hbEOA");

const $6739d59719e0930b$export$5921b2a93a401547 = ()=>{
    return (0, $hbEOA.isTeamsAppEnabled)({
        userHasNav4Enabled: true,
        hostProduct: 'confluence'
    });
};
module.exports["isTeamsAppEnabled"] = $6739d59719e0930b$export$5921b2a93a401547;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("bedVD", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3gadb = parcelRequire("3gadb");

const $e4e11ee9fe4a88c9$var$i18n = (0, $aXWIB.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("l7wqU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error),
        __callerPackage__: "@confluence/profile"
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ],
        __callerPackage__: "@confluence/profile"
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = followedUsersRaw ? followedUsersRaw.map((id)=>id ?? null) : undefined;
    const getToggleFollowUser = (0, $42omo.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    return (0, $42omo.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers ?? []
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<faabaa80182918f5d00c229b25800acb>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<597a7b2d7b3333c8532a887f4cdcbd48>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("bumSD", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $7c52C = parcelRequire("7c52C");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $2XqLN.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $7c52C.default)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $8zKPT = parcelRequire("8zKPT");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $8zKPT.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            },
            __callerPackage__: "@confluence/profile"
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("gj42z", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $aXWIB = parcelRequire("aXWIB");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        defaultMessage: "We\u2019re having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("dklIa", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");

const $c3a6d60a3494ed40$var$defaultCommentState = Object.freeze({
    optimisticReactions: Object.freeze([]),
    inFlightEmojiIds: Object.freeze(new Set()),
    rollbackMap: Object.freeze(new Map()),
    error: undefined
});
const $c3a6d60a3494ed40$var$getCommentState = (state, commentId)=>state.commentReactionState[commentId] ?? $c3a6d60a3494ed40$var$defaultCommentState;
const $c3a6d60a3494ed40$var$setCommentState = (state, commentId, patch)=>({
        ...state.commentReactionState,
        [commentId]: {
            ...$c3a6d60a3494ed40$var$getCommentState(state, commentId),
            ...patch
        }
    });
const $c3a6d60a3494ed40$var$DEFAULT_STALENESS = Object.freeze({
    changed: 0,
    fetched: 0
});
const $c3a6d60a3494ed40$export$64e3401c254cca65 = (commentId, emojiId)=>`${commentId}::${emojiId}`;
/**
 * Merges server reaction data into the existing display order.
 * Existing emojis keep their position; their values are updated from `server`
 * (or from `inFlightOverrides` when a mutation is in-flight).
 * Emojis absent from both `server` and `inFlightOverrides` are dropped.
 * New emojis (from server or still-in-flight) are appended at the end.
 */ const $c3a6d60a3494ed40$var$stabilizeReactions = (current, server, inFlightOverrides = new Map(), deletedInFlight = new Set())=>{
    const serverMap = new Map();
    for (const r of server)if (!deletedInFlight.has(r.emojiId)) serverMap.set(r.emojiId, r);
    const result = [];
    const seenIds = new Set();
    for (const r of current){
        if (deletedInFlight.has(r.emojiId)) continue;
        const inFlight = inFlightOverrides.get(r.emojiId);
        if (inFlight) {
            result.push(inFlight);
            seenIds.add(r.emojiId);
        } else if (serverMap.has(r.emojiId)) {
            result.push(serverMap.get(r.emojiId));
            seenIds.add(r.emojiId);
        }
    // not in server and not in-flight → removed, omit
    }
    for (const r of server)if (!seenIds.has(r.emojiId) && !deletedInFlight.has(r.emojiId)) {
        result.push(r);
        seenIds.add(r.emojiId);
    }
    for (const [emojiId, optimistic] of inFlightOverrides)if (!seenIds.has(emojiId)) {
        result.push(optimistic);
        seenIds.add(emojiId);
    }
    return result;
};
const $c3a6d60a3494ed40$var$initialState = {
    opener: null,
    picker: null,
    optimisticReactionMarkerMap: {},
    optimisticResolvedMarkerRefs: new Set(),
    optimisticDeletedMarkerRefs: new Set(),
    commentReactionState: {},
    reactedUsersStaleness: {}
};
const $c3a6d60a3494ed40$var$registerOpener = (opener)=>({ setState: setState })=>{
        setState({
            opener: opener
        });
    };
const $c3a6d60a3494ed40$var$triggerOpen = ()=>({ getState: getState })=>{
        getState().opener?.();
    };
const $c3a6d60a3494ed40$var$openPicker = ({ anchorTop: anchorTop, anchorLeft: anchorLeft, contentType: contentType, pageId: pageId, onCreate: onCreate, step: step, originalSelection: originalSelection, onClose: onClose })=>({ setState: setState, getState: getState })=>{
        if (getState().picker) return;
        setState({
            picker: {
                anchorTop: anchorTop,
                anchorLeft: anchorLeft,
                contentType: contentType,
                pageId: pageId,
                onCreate: onCreate,
                step: step,
                originalSelection: originalSelection,
                onClose: onClose
            }
        });
    };
const $c3a6d60a3494ed40$var$closePicker = ()=>({ setState: setState, getState: getState })=>{
        const { picker: picker } = getState();
        if (!picker) return;
        picker.onClose?.();
        setState({
            picker: null
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticReaction = (markerRef, commentId)=>({ setState: setState, getState: getState })=>{
        setState({
            optimisticReactionMarkerMap: {
                ...getState().optimisticReactionMarkerMap,
                [markerRef]: commentId
            }
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticResolvedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (current.has(markerRef)) return;
        setState({
            optimisticResolvedMarkerRefs: new Set([
                ...current,
                markerRef
            ])
        });
    };
/**
 * Roll back an optimistic resolve — removes the ref from the set so the
 * highlight reappears. Called when the resolve mutation fails.
 */ const $c3a6d60a3494ed40$var$removeOptimisticResolvedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (!current.has(markerRef)) return;
        const next = new Set(current);
        next.delete(markerRef);
        setState({
            optimisticResolvedMarkerRefs: next
        });
    };
/**
 * Drain any optimistic-resolved refs that are no longer present in the
 * server-confirmed marker refs (meaning the server has confirmed removal).
 * No-ops when the set is empty to avoid an extra re-render.
 */ const $c3a6d60a3494ed40$var$pruneOptimisticResolvedMarkerRefs = (serverMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (current.size === 0) return;
        const serverSet = new Set(serverMarkerRefs);
        const next = new Set();
        for (const ref of current)// Keep only refs that the server still returns (not yet confirmed removed).
        if (serverSet.has(ref)) next.add(ref);
        if (next.size !== current.size) setState({
            optimisticResolvedMarkerRefs: next
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticDeletedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticDeletedMarkerRefs;
        if (current.has(markerRef)) return;
        setState({
            optimisticDeletedMarkerRefs: new Set([
                ...current,
                markerRef
            ])
        });
    };
const $c3a6d60a3494ed40$var$pruneOptimisticDeletedMarkerRefs = (serverMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticDeletedMarkerRefs;
        if (current.size === 0) return;
        const serverSet = new Set(serverMarkerRefs);
        const next = new Set();
        for (const ref of current)if (serverSet.has(ref)) next.add(ref);
        if (next.size !== current.size) setState({
            optimisticDeletedMarkerRefs: next
        });
    };
/**
 * Drop any optimistic entries whose markerRef is now in the server-confirmed map.
 * Called from `useRendererAnnotationProviderOptions` whenever `useActiveInlineData`
 * returns a new `reactionMarkerMap`, so the optimistic store does not grow forever.
 * No-ops (and skips the setState) when nothing needs to be pruned to avoid an
 * extra re-render cycle.
 */ const $c3a6d60a3494ed40$var$pruneOptimisticReactions = (confirmedMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticReactionMarkerMap;
        if (Object.keys(current).length === 0 || confirmedMarkerRefs.length === 0) return;
        const confirmedSet = new Set(confirmedMarkerRefs);
        let changed = false;
        const next = {};
        for (const [markerRef, commentId] of Object.entries(current)){
            if (confirmedSet.has(markerRef)) {
                changed = true;
                continue;
            }
            next[markerRef] = commentId;
        }
        if (changed) setState({
            optimisticReactionMarkerMap: next
        });
    };
/**
 * Sync server reactions into the store for a given comment.
 *
 * When nothing is in-flight, the server data replaces the optimistic array.
 * When mutations are in-flight, server data is merged: in-flight emojis keep
 * their optimistic values while everything else updates to the server truth.
 */ const $c3a6d60a3494ed40$var$syncServerReactions = (commentId, serverReactions)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.size === 0) {
            setState({
                commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                    optimisticReactions: $c3a6d60a3494ed40$var$stabilizeReactions(comment.optimisticReactions, serverReactions)
                })
            });
            return;
        }
        // Merge: keep optimistic values for in-flight emojis, use server for the rest.
        // Build the snapshot as a Map for O(1) lookup (avoids quadratic nested iteration).
        const inFlightSnapshot = new Map();
        for (const r of comment.optimisticReactions)if (comment.inFlightEmojiIds.has(r.emojiId)) inFlightSnapshot.set(r.emojiId, r);
        // Track emojis that were optimistically deleted (in-flight but absent from
        // optimisticReactions because their count hit 0). We must suppress these from
        // the server payload so they don't get resurrected before the mutation settles.
        const deletedInFlight = new Set();
        for (const id of comment.inFlightEmojiIds)if (!inFlightSnapshot.has(id)) deletedInFlight.add(id);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: $c3a6d60a3494ed40$var$stabilizeReactions(comment.optimisticReactions, serverReactions, inFlightSnapshot, deletedInFlight)
            })
        });
    };
/**
 * Apply an optimistic toggle (add or remove) for an existing emoji.
 * Returns `null` if the emoji is already in-flight or not found (no-op).
 * Otherwise applies the optimistic update, marks in-flight, and returns
 * `true` if removing or `false` if adding, so the caller knows which
 * mutation to fire.
 *
 * This combines the guard, optimistic update, and in-flight marking into a
 * single synchronous store transaction so that rapid-fire calls (e.g. double
 * clicks) are properly de-duped even before React re-renders.
 */ const $c3a6d60a3494ed40$var$applyOptimisticToggle = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.has(emojiId)) return null;
        const currentReaction = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        if (!currentReaction) return null;
        const isRemoving = currentReaction.reacted;
        // Save rollback snapshot
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.set(emojiId, comment.optimisticReactions);
        // Mark in-flight
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.add(emojiId);
        let nextReactions;
        if (isRemoving) {
            const newCount = currentReaction.count - 1;
            if (newCount <= 0) nextReactions = comment.optimisticReactions.filter((r)=>r.emojiId !== emojiId);
            else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: newCount,
                    reacted: false
                } : r);
        } else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                ...r,
                count: r.count + 1,
                reacted: true
            } : r);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions,
                rollbackMap: nextRollback,
                inFlightEmojiIds: nextInFlight,
                error: undefined
            })
        });
        return isRemoving;
    };
/**
 * Apply an optimistic add for a new or existing-but-not-reacted emoji.
 * Returns `false` if already in-flight or already reacted (no-op).
 * Otherwise applies the optimistic update, marks in-flight, and returns `true`.
 *
 * Like `applyOptimisticToggle`, this combines guard + update + in-flight
 * into a single synchronous transaction.
 */ const $c3a6d60a3494ed40$var$applyOptimisticAdd = (commentId, emojiId, templateAri, templateContainerAri)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.has(emojiId)) return false;
        const existingReaction = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        if (existingReaction?.reacted) return false;
        // Save rollback snapshot
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.set(emojiId, comment.optimisticReactions);
        // Mark in-flight
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.add(emojiId);
        let nextReactions;
        if (existingReaction) nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                ...r,
                count: r.count + 1,
                reacted: true
            } : r);
        else nextReactions = [
            ...comment.optimisticReactions,
            {
                ari: templateAri,
                containerAri: templateContainerAri,
                emojiId: emojiId,
                count: 1,
                reacted: true
            }
        ];
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions,
                rollbackMap: nextRollback,
                inFlightEmojiIds: nextInFlight,
                error: undefined
            })
        });
        return true;
    };
/** Clear in-flight and rollback state for a settled mutation. */ const $c3a6d60a3494ed40$var$onEmojiSettled = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.delete(emojiId);
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.delete(emojiId);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                inFlightEmojiIds: nextInFlight,
                rollbackMap: nextRollback
            })
        });
    };
/** Roll back optimistic state on mutation error. */ const $c3a6d60a3494ed40$var$onEmojiMutationError = (commentId, emojiId, error)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const rollback = comment.rollbackMap.get(emojiId);
        // Clear in-flight and rollback for this emoji
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.delete(emojiId);
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.delete(emojiId);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: rollback ?? comment.optimisticReactions,
                inFlightEmojiIds: nextInFlight,
                rollbackMap: nextRollback,
                error: error
            })
        });
    };
/** Remove all state for a comment (call on unmount). */ const $c3a6d60a3494ed40$var$cleanupComment = (commentId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { [commentId]: _, ...rest } = state.commentReactionState;
        // Drop any reacted-users freshness entries for this comment's pairs so the
        // registry does not grow unbounded across a long session.
        const keyPrefix = `${commentId}::`;
        let removedStaleness = false;
        const nextStaleness = {};
        for (const [key, value] of Object.entries(state.reactedUsersStaleness)){
            if (key.startsWith(keyPrefix)) {
                removedStaleness = true;
                continue;
            }
            nextStaleness[key] = value;
        }
        setState({
            commentReactionState: rest,
            ...removedStaleness ? {
                reactedUsersStaleness: nextStaleness
            } : {}
        });
    };
/**
 * Record that the reactor list for a comment+emoji pair changed (local mutation
 * or remote pubsub event), bumping its `changed` counter so the next mounted
 * facepile fetcher refetches from the network.
 */ const $c3a6d60a3494ed40$var$markReactedUsersChanged = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const key = $c3a6d60a3494ed40$export$64e3401c254cca65(commentId, emojiId);
        const current = state.reactedUsersStaleness[key] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS;
        setState({
            reactedUsersStaleness: {
                ...state.reactedUsersStaleness,
                [key]: {
                    changed: current.changed + 1,
                    fetched: current.fetched
                }
            }
        });
    };
/**
 * Record that a facepile fetcher has refetched the reactor list for a
 * comment+emoji pair, catching `fetched` up to `changed`. No-ops when already
 * caught up to avoid a redundant re-render.
 */ const $c3a6d60a3494ed40$var$markReactedUsersFetched = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const key = $c3a6d60a3494ed40$export$64e3401c254cca65(commentId, emojiId);
        const current = state.reactedUsersStaleness[key];
        if (!current || current.fetched === current.changed) return;
        setState({
            reactedUsersStaleness: {
                ...state.reactedUsersStaleness,
                [key]: {
                    changed: current.changed,
                    fetched: current.changed
                }
            }
        });
    };
/**
 * Apply a remote pubsub delta (add or remove) from another user.
 *
 * On +1: increment the existing emoji count, or create a new entry with
 *        count=1 and reacted=false if it doesn't exist yet.
 * On -1: decrement the count, removing the entry if it reaches zero.
 *        No-ops if the comment has no state yet (nothing to decrement).
 */ const $c3a6d60a3494ed40$var$applyRemoteDelta = (commentId, emojiId, delta, templateAri = '', templateContainerAri = '')=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const existing = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        let nextReactions;
        if (delta === 1) {
            if (existing) // Increment existing entry, preserve `reacted` (current user's state)
            nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: r.count + 1
                } : r);
            else {
                // If this comment has no store entry yet, skip writing: persisting a new
                // CommentReactionState here would create a leaked record (ari: '', containerAri: '')
                // for a comment that is not currently mounted. syncServerReactions will provide
                // authoritative state when the component does mount and refetches.
                if (state.commentReactionState[commentId] === undefined) return;
                // Create a new entry - 'reacted' is false since this is a remote user's reaction
                nextReactions = [
                    ...comment.optimisticReactions,
                    {
                        ari: templateAri,
                        containerAri: templateContainerAri,
                        emojiId: emojiId,
                        count: 1,
                        reacted: false
                    }
                ];
            }
        } else {
            // delta === -1
            if (!existing) // No emoji found in store - nothing to decrement
            return;
            const newCount = existing.count - 1;
            if (newCount <= 0) nextReactions = comment.optimisticReactions.filter((r)=>r.emojiId !== emojiId);
            else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: newCount
                } : r);
        }
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions
            })
        });
    };
const $c3a6d60a3494ed40$var$actions = {
    registerOpener: $c3a6d60a3494ed40$var$registerOpener,
    triggerOpen: $c3a6d60a3494ed40$var$triggerOpen,
    openPicker: $c3a6d60a3494ed40$var$openPicker,
    closePicker: $c3a6d60a3494ed40$var$closePicker,
    addOptimisticReaction: $c3a6d60a3494ed40$var$addOptimisticReaction,
    pruneOptimisticReactions: $c3a6d60a3494ed40$var$pruneOptimisticReactions,
    addOptimisticResolvedMarkerRef: $c3a6d60a3494ed40$var$addOptimisticResolvedMarkerRef,
    removeOptimisticResolvedMarkerRef: $c3a6d60a3494ed40$var$removeOptimisticResolvedMarkerRef,
    pruneOptimisticResolvedMarkerRefs: $c3a6d60a3494ed40$var$pruneOptimisticResolvedMarkerRefs,
    addOptimisticDeletedMarkerRef: $c3a6d60a3494ed40$var$addOptimisticDeletedMarkerRef,
    pruneOptimisticDeletedMarkerRefs: $c3a6d60a3494ed40$var$pruneOptimisticDeletedMarkerRefs,
    syncServerReactions: $c3a6d60a3494ed40$var$syncServerReactions,
    applyOptimisticToggle: $c3a6d60a3494ed40$var$applyOptimisticToggle,
    applyOptimisticAdd: $c3a6d60a3494ed40$var$applyOptimisticAdd,
    onEmojiSettled: $c3a6d60a3494ed40$var$onEmojiSettled,
    onEmojiMutationError: $c3a6d60a3494ed40$var$onEmojiMutationError,
    cleanupComment: $c3a6d60a3494ed40$var$cleanupComment,
    applyRemoteDelta: $c3a6d60a3494ed40$var$applyRemoteDelta,
    markReactedUsersChanged: $c3a6d60a3494ed40$var$markReactedUsersChanged,
    markReactedUsersFetched: $c3a6d60a3494ed40$var$markReactedUsersFetched
};
const $c3a6d60a3494ed40$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: $c3a6d60a3494ed40$var$initialState,
    actions: $c3a6d60a3494ed40$var$actions,
    name: 'inlineReactionStore'
});
const $c3a6d60a3494ed40$export$4bea784acc47afc0 = (0, $9zUhf.createActionsHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9);
const $c3a6d60a3494ed40$export$95648a16d8bcb2ae = (0, $9zUhf.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.picker
});
const $c3a6d60a3494ed40$export$a2df1890187165d2 = (0, $9zUhf.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticReactionMarkerMap
});
function $c3a6d60a3494ed40$export$8adad8a188e9f237() {
    return (0, $4HDYO.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().optimisticReactionMarkerMap;
}
function $c3a6d60a3494ed40$export$ff40a497e226daf7(markerRef) {
    return (0, $4HDYO.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().optimisticResolvedMarkerRefs.has(markerRef);
}
function $c3a6d60a3494ed40$export$e0bbeb963dd9ccf1(markerRef) {
    (0, $4HDYO.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).actions.addOptimisticDeletedMarkerRef(markerRef);
}
const $c3a6d60a3494ed40$export$acabd5c13c46827c = (0, $9zUhf.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticResolvedMarkerRefs
});
const $c3a6d60a3494ed40$export$15ea3ad646d59eec = (0, $9zUhf.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticDeletedMarkerRefs
});
const $c3a6d60a3494ed40$export$c2b73a32145e6e04 = (0, $9zUhf.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state, commentId)=>state.commentReactionState[commentId] ?? $c3a6d60a3494ed40$var$defaultCommentState
});
const $c3a6d60a3494ed40$export$2b46bd66d45480ef = (0, $9zUhf.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state, pairKey)=>state.reactedUsersStaleness[pairKey] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS
});
function $c3a6d60a3494ed40$export$20c2e9914ef136a5(pairKey) {
    return (0, $4HDYO.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().reactedUsersStaleness[pairKey] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS;
}
module.exports["reactedUsersPairKey"] = $c3a6d60a3494ed40$export$64e3401c254cca65;
module.exports["useInlineReactionActions"] = $c3a6d60a3494ed40$export$4bea784acc47afc0;
module.exports["useInlineReactionPicker"] = $c3a6d60a3494ed40$export$95648a16d8bcb2ae;
module.exports["useOptimisticReactionMarkerMap"] = $c3a6d60a3494ed40$export$a2df1890187165d2;
module.exports["getOptimisticReactionMarkerMap"] = $c3a6d60a3494ed40$export$8adad8a188e9f237;
module.exports["isOptimisticallyResolvedMarkerRef"] = $c3a6d60a3494ed40$export$ff40a497e226daf7;
module.exports["markOptimisticDeletedMarkerRef"] = $c3a6d60a3494ed40$export$e0bbeb963dd9ccf1;
module.exports["useOptimisticResolvedMarkerRefs"] = $c3a6d60a3494ed40$export$acabd5c13c46827c;
module.exports["useOptimisticDeletedMarkerRefs"] = $c3a6d60a3494ed40$export$15ea3ad646d59eec;
module.exports["useCommentReactionState"] = $c3a6d60a3494ed40$export$c2b73a32145e6e04;
module.exports["useReactedUsersStaleness"] = $c3a6d60a3494ed40$export$2b46bd66d45480ef;
module.exports["getReactedUsersStaleness"] = $c3a6d60a3494ed40$export$20c2e9914ef136a5;

});

parcelRegister("3B9cR", function(module, exports) {

var $6kgLu = parcelRequire("6kgLu");

const $7d2c123586cab1f2$export$5fa1043645dd2c26 = (0, $6kgLu.default);
module.exports["InlineCommentQuery"] = $7d2c123586cab1f2$export$5fa1043645dd2c26;

});

parcelRegister("6kgLu", function(module, exports) {
/**
 * @generated SignedSource<<be9673dafa8094e7a6e9dd947e0cfee1>>
 * @relayHash 1565f9a21fb928625638bc549e846634
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 66870dba275f9b13105b9633c348af8de6c6550db6806aaa7794cf5e03af8e86
const $91432cb47dad508a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "annotationId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRef",
            "variableName": "annotationId"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v16 = {
        "kind": "ScalarField",
        "name": "type"
    }, v17 = {
        "kind": "ScalarField",
        "name": "when"
    }, v18 = {
        "kind": "ScalarField",
        "name": "number"
    }, v19 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    },
                    v5 /*: any*/ 
                ]
            }
        ]
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedTime"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    }
                ]
            }
        ],
        "type": "InlineComment"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InlineCommentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InlineCommentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v24 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1565f9a21fb928625638bc549e846634",
            "id": "66870dba275f9b13105b9633c348af8de6c6550db6806aaa7794cf5e03af8e86",
            "metadata": {},
            "name": "InlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentQuery($annotationId:String,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRef:$annotationId,pageId:$pageId,contentStatus:$contentStatus){nodes{replies{id,parentId,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,links{webui,editui},author{__typename,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},location{__typename,type},version{by{__typename,displayName},when,number},permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}},version{by{__typename,displayName},when,number},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,resolvedTime,resolvedUser}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$91432cb47dad508a$var$node.hash = "97a27177dfbb0afcc0c9bf12ba1b9268";
var $91432cb47dad508a$export$2e2bcd8739ae039 = $91432cb47dad508a$var$node;
module.exports["default"] = $91432cb47dad508a$export$2e2bcd8739ae039;

});

parcelRegister("1C8XP", function(module, exports) {

var $3cQo5 = parcelRequire("3cQo5");

const $087454af48047e63$export$c9407390b0cf740d = (0, $3cQo5.default);
module.exports["ActiveInlineCommentsQuery"] = $087454af48047e63$export$c9407390b0cf740d;

});

parcelRegister("3cQo5", function(module, exports) {
/**
 * @generated SignedSource<<131ed4823645958609337a2481f00b28>>
 * @relayHash 0c90169da883bac60f8fe8cfefab06a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4
const $487b4c2a573008bb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRefList"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRefList",
            "variableName": "inlineMarkerRefList"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v19 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v21 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v29 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v32 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0c90169da883bac60f8fe8cfefab06a0",
            "id": "552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4",
            "metadata": {},
            "name": "ActiveInlineCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$487b4c2a573008bb$var$node.hash = "93367b15ee96494c20452626f5b23b5d";
var $487b4c2a573008bb$export$2e2bcd8739ae039 = $487b4c2a573008bb$var$node;
module.exports["default"] = $487b4c2a573008bb$export$2e2bcd8739ae039;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("8QQGs", function(module, exports) {
"use strict";
var $671c0bfbaf864118$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $671c0bfbaf864118$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $671c0bfbaf864118$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $671c0bfbaf864118$var$catchError;
var $671c0bfbaf864118$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $671c0bfbaf864118$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $671c0bfbaf864118$var$CatchSubscriber = function(_super) {
    $671c0bfbaf864118$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($dZ9AU.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("2mnXV", function(module, exports) {
"use strict";
var $1b8039eb254298fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $1b8039eb254298fd$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $1b8039eb254298fd$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $1b8039eb254298fd$var$distinctUntilChanged;
var $1b8039eb254298fd$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1b8039eb254298fd$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1b8039eb254298fd$var$DistinctUntilChangedSubscriber = function(_super) {
    $1b8039eb254298fd$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $3FcLR.tryCatch(this.keySelector)(value);
            if (key === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $3FcLR.tryCatch(this.compare)(this.key, key);
            if (result === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($axeml.Subscriber);

});

parcelRegister("3VDUL", function(module, exports) {
"use strict";
var $2dc5a83127dcb05a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $2dc5a83127dcb05a$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $2dc5a83127dcb05a$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $2dc5a83127dcb05a$var$skipWhile;
var $2dc5a83127dcb05a$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dc5a83127dcb05a$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dc5a83127dcb05a$var$SkipWhileSubscriber = function(_super) {
    $2dc5a83127dcb05a$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($axeml.Subscriber);

});

parcelRegister("j8M4E", function(module, exports) {
"use strict";
var $def40e2be1e8c847$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $def40e2be1e8c847$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $def40e2be1e8c847$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $def40e2be1e8c847$var$switchMap;
var $def40e2be1e8c847$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $def40e2be1e8c847$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $def40e2be1e8c847$var$SwitchMapSubscriber = function(_super) {
    $def40e2be1e8c847$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $dZ9AU.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("i3vZV", function(module, exports) {
"use strict";
var $d25153e5d88b6a52$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

function $d25153e5d88b6a52$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $d25153e5d88b6a52$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $d25153e5d88b6a52$var$timeInterval;
var $d25153e5d88b6a52$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $d25153e5d88b6a52$var$TimeInterval;
var $d25153e5d88b6a52$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $d25153e5d88b6a52$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d25153e5d88b6a52$var$TimeIntervalSubscriber = function(_super) {
    $d25153e5d88b6a52$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $d25153e5d88b6a52$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ePuNq", function(module, exports) {
"use strict";
var $acbdb7992e24bbb8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6GdLZ = parcelRequire("6GdLZ");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $acbdb7992e24bbb8$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteTimeout = $kVeeY.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $acbdb7992e24bbb8$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $6GdLZ.TimeoutError()));
    };
}
module.exports.timeout = $acbdb7992e24bbb8$var$timeout;
var $acbdb7992e24bbb8$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $acbdb7992e24bbb8$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $acbdb7992e24bbb8$var$TimeoutSubscriber = function(_super) {
    $acbdb7992e24bbb8$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6GdLZ", function(module, exports) {
"use strict";
var $4dd15960f755eae6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $4dd15960f755eae6$var$TimeoutError = function(_super) {
    $4dd15960f755eae6$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $4dd15960f755eae6$var$TimeoutError;

});

parcelRegister("5h38X", function(module, exports) {
"use strict";
var $3d70fa8830a46307$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $bGuMq = parcelRequire("bGuMq");

/**
 * @class BehaviorSubject<T>
 */ var $3d70fa8830a46307$var$BehaviorSubject = function(_super) {
    $3d70fa8830a46307$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($augeV.Subject);
module.exports.BehaviorSubject = $3d70fa8830a46307$var$BehaviorSubject;

});

parcelRegister("5k6WH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $uRQKa = parcelRequire("uRQKa");


var $6ttbq = parcelRequire("6ttbq");

const $479e1e8ac650b5b6$export$c537e63161742ce3 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $42omo.useState)((0, $6ttbq.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $uRQKa.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $fFa3V.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $42omo.useState)((0, $6ttbq.isReducedMotion));
    (0, $42omo.useEffect)(()=>{
        if (!(0, $uRQKa.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $479e1e8ac650b5b6$export$c537e63161742ce3;

});

parcelRegister("7VJPz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a2xFu = parcelRequire("a2xFu");

var $kYvrE = parcelRequire("kYvrE");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $1lyRS = parcelRequire("1lyRS");

const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $a2xFu.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $kYvrE.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lyRS.SmartButtonLoader), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("1lyRS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("1btD6"))).SmartButton
});
module.exports["SmartButtonLoader"] = $16e92128cf9491a8$export$32d8d71ddecea49c;

});

parcelRegister("1btD6", function(module, exports) {

let $0dcdcd5719f23103$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0dcdcd5719f23103$var$load("jXx9i"),
    $0dcdcd5719f23103$var$load("b9CA3"),
    $0dcdcd5719f23103$var$load("6wr18"),
    $0dcdcd5719f23103$var$load("gctwz"),
    $0dcdcd5719f23103$var$load("hhss7"),
    $0dcdcd5719f23103$var$load("ffEVr"),
    $0dcdcd5719f23103$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $42omo.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $b847dc1d37d68706$export$dcf9d4e77de27956 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInterop(query, options) {
    const $ = (0, $frIzR.c)(11);
    const resolversRef = (0, $42omo.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options || $[3] !== t0) {
        t1 = [
            t0,
            options
        ];
        $[2] = options;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const [doQuery, t2] = (0, $jxs8y.useLazyQuery)(...t1);
    const { data: data, error: error } = t2;
    let t3;
    let t4;
    if ($[5] !== data || $[6] !== error) {
        t3 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t4 = [
            data,
            error
        ];
        $[5] = data;
        $[6] = error;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== doQuery) {
        t5 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[9] = doQuery;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function useLazyQueryPromiseInterop(query, options) {
    const resolversRef = (0, $42omo.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("4cOi8", function(module, exports) {
var $c7f67cb608b5916f$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $c7f67cb608b5916f$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $c7f67cb608b5916f$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $c7f67cb608b5916f$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $c7f67cb608b5916f$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $c7f67cb608b5916f$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $c7f67cb608b5916f$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $c7f67cb608b5916f$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $c7f67cb608b5916f$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $c7f67cb608b5916f$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $c7f67cb608b5916f$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $c7f67cb608b5916f$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $c7f67cb608b5916f$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $c7f67cb608b5916f$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $c7f67cb608b5916f$export$a6e645fda5339bf8;
module.exports["Height"] = $c7f67cb608b5916f$export$8954cfac7c08d16a;
module.exports["Alignment"] = $c7f67cb608b5916f$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $c7f67cb608b5916f$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $c7f67cb608b5916f$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $c7f67cb608b5916f$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $c7f67cb608b5916f$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $c7f67cb608b5916f$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $c7f67cb608b5916f$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $c7f67cb608b5916f$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $c7f67cb608b5916f$export$bf7ebf7fed6e7189;

});

parcelRegister("lOeVN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $42omo.useRef)();
    propsRef.current = props;
    return (0, $42omo.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("1421M"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("1421M", function(module, exports) {

let $0c67bcd931c05ad3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c67bcd931c05ad3$var$load("6wr18"),
    $0c67bcd931c05ad3$var$load("ffEVr"),
    $0c67bcd931c05ad3$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: true,
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    return (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("4o1RV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $frIzR.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2XqLN = parcelRequire("2XqLN");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $frIzR.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("7EIq6", function(module, exports) {

var $dd33Q = parcelRequire("dd33Q");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, spaceEnabledContentTypesQueryOptions);
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = isDefaultSpaceKeyLoading || isAnyContentTypesLoading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("bMPhU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "@confluence/space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("1l37u", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a816caaccdbc6f4f$export$6107f09ca09b8b5f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    embeddedParentModalKey: undefined,
    setEmbeddedParentModalKey: ()=>{},
    forwarder: ()=>Promise.resolve()
});
module.exports["EmbeddedModalContext"] = $a816caaccdbc6f4f$export$6107f09ca09b8b5f;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("kvJHJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $cbc8g.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("18R9N", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $42omo.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("7boqA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("62fWd", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jIiuI = parcelRequire("jIiuI");

var $5U2YR = parcelRequire("5U2YR");


var $3Spjc = parcelRequire("3Spjc");

const $3c9dbf4421667f34$export$64f0f7e9be5f8ff = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children } = t0;
    let t1;
    if ($[0] !== page || $[1] !== product) {
        t1 = {
            product: product,
            page: page
        };
        $[0] = page;
        $[1] = product;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== page) {
        t2 = {
            moduleType: page
        };
        $[3] = page;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== analyticsWebClient || $[6] !== children || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Spjc.default), {
            client: analyticsWebClient,
            commonAttributes: t2
        }, children);
        $[5] = analyticsWebClient;
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U2YR.MetricsContextProvider), {
            value: t1
        }, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== environment || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIiuI.EnvironmentContext).Provider, {
            value: environment
        }, t4);
        $[12] = environment;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIiuI.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U2YR.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Spjc.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $3c9dbf4421667f34$export$64f0f7e9be5f8ff;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3wBuN = parcelRequire("3wBuN");


var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");


var $chO1Z = parcelRequire("chO1Z");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $gMc0m.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $42omo.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $42omo.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $7sObp.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $7sObp.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $gMc0m.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $2XqLN = parcelRequire("2XqLN");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $aXWIB.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
// Templates that should not show the Create with Rovo button:
// legacy editor (tiny editor), blog post, and team calendar blueprints
const $f4c21c880d0229da$var$CWR_EXCLUDED_BLUEPRINT_KEYS = [
    'com.atlassian.confluence.plugins.confluence-business-blueprints:tinyeditor-blueprint',
    'com.atlassian.confluence.extra.team-calendars:tc-on-space-blueprint'
];
const $f4c21c880d0229da$export$d2b7a52bdf90089f = (template)=>{
    const { blueprintModuleCompleteKey: blueprintModuleCompleteKey, contentBlueprintId: contentBlueprintId, name: name } = template;
    return !$f4c21c880d0229da$var$CWR_EXCLUDED_BLUEPRINT_KEYS.includes(blueprintModuleCompleteKey ?? '') && contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b && !name?.toLowerCase().includes('blog');
};
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $2XqLN.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $2XqLN.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $2XqLN.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $2XqLN.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["shouldShowCWRButton"] = $f4c21c880d0229da$export$d2b7a52bdf90089f;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $2XqLN.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("4eJH6", function(module, exports) {
var $7dcc17f1ea6ba5ae$export$b573856c46cc9357 = /*#__PURE__*/ function(CalendarView) {
    CalendarView["dayGridMonth"] = "dayGridMonth";
    CalendarView["timeGridWeek"] = "timeGridWeek";
    CalendarView["listMonth"] = "listMonth";
    CalendarView["list"] = "list";
    CalendarView["timeline"] = "timeline";
    return CalendarView;
}({});
var $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8 = /*#__PURE__*/ function(CalendarViewPreference) {
    CalendarViewPreference["month"] = "month";
    CalendarViewPreference["agendaWeek"] = "agendaWeek";
    CalendarViewPreference["basicDay"] = "basicDay";
    CalendarViewPreference["timeline"] = "timeline";
    return CalendarViewPreference;
}({});
module.exports["CalendarView"] = $7dcc17f1ea6ba5ae$export$b573856c46cc9357;
module.exports["CalendarViewPreference"] = $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8;

});

parcelRegister("j4RIK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cdc6aab464c1fae2$export$6122306715c85017 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qKe_8",
    name: "PageTreeMacroHandler",
    loader: async ()=>(await (parcelRequire("kfSWE"))).PageTreeMacroRenderer
});
module.exports["PageTreeMacroHandler"] = $cdc6aab464c1fae2$export$6122306715c85017;

});

parcelRegister("kfSWE", function(module, exports) {

let $ebefd44b05b60429$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ebefd44b05b60429$var$load("6wr18"),
    $ebefd44b05b60429$var$load("ffEVr"),
    $ebefd44b05b60429$var$load("Wowvf"),
    $ebefd44b05b60429$var$load("5is1n"),
    $ebefd44b05b60429$var$load("3PgFB")
]).then(()=>parcelRequire('hD0Hb'));

});

parcelRegister("2w2Hu", function(module, exports) {
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ const $8cf96aaaf31dfd76$export$75ebf2388340a0ba = {
    ClassicRendererLoader: 'ClassicRendererLoader',
    ClassicEditorContextProviderLoader: 'ClassicEditorContextProviderLoader',
    NativeCollabLoader: 'NativeCollabLoader',
    FullPageEditorLoader: 'FullPageEditorLoader',
    ViewPageRouteComponentLoader: 'ViewPageRouteComponentLoader',
    LivePageComponentLoader: 'LivePageComponentLoader',
    EditorByLineArea: 'EditorByLineArea'
};
module.exports["MustPreloadLoadableNames"] = $8cf96aaaf31dfd76$export$75ebf2388340a0ba;

});

parcelRegister("ZJvdP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $543e3a9ad9cfc398$export$3ad73c971369d052 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sYDyD",
    name: "PageIncludeMacroHandler",
    loader: async ()=>(await (parcelRequire("cqkhv"))).PageIncludeMacroRenderer
});
module.exports["PageIncludeMacroHandler"] = $543e3a9ad9cfc398$export$3ad73c971369d052;

});

parcelRegister("cqkhv", function(module, exports) {

let $90b7a532fd6dc45f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $90b7a532fd6dc45f$var$load("5h4De").then(()=>parcelRequire('doY9Y'));

});

parcelRegister("8Ksv7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $11414ac1857ca883$export$cfa4ed6e2f4ad26 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lJE6O",
    name: "BlogPostsMacroHandler",
    loader: async ()=>(await (parcelRequire("6PsSZ"))).BlogPostsMacroRenderer
});
module.exports["BlogPostsMacroHandler"] = $11414ac1857ca883$export$cfa4ed6e2f4ad26;

});

parcelRegister("6PsSZ", function(module, exports) {

let $4f8de9a2aa04e4ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f8de9a2aa04e4ca$var$load("oTA4y"),
    $4f8de9a2aa04e4ca$var$load("fPbCp"),
    $4f8de9a2aa04e4ca$var$load("1GCFv"),
    $4f8de9a2aa04e4ca$var$load("dZsGY"),
    $4f8de9a2aa04e4ca$var$load("bV5bW"),
    $4f8de9a2aa04e4ca$var$load("28h7Y")
]).then(()=>parcelRequire('5iRsI'));

});

parcelRegister("jJli4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $f9KPY = parcelRequire("f9KPY");


const $7549d063fe593b21$export$2800e3d415e59020 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8zrD8",
    name: "ExcerptIncludeLoader",
    loader: async ()=>(await (parcelRequire("lOZaN"))).ExcerptInclude,
    // Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
    // expects the prop types to match.
    // @ts-expect-error
    loading: (0, $f9KPY.ExcerptIncludeComponentShadow)
});
module.exports["ExcerptIncludeLoader"] = $7549d063fe593b21$export$2800e3d415e59020;

});

parcelRegister("f9KPY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lOkIA = parcelRequire("lOkIA");


var $dhEYL = parcelRequire("dhEYL");

class $747c563e4499b240$export$8f88facf076a2d46 extends (0, $42omo.PureComponent) {
    render() {
        const { shouldPanelBeDisplayed: shouldPanelBeDisplayed, targetContentTitle: targetContentTitle } = this.props;
        return shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "excerpt-include-panel",
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle || // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "editor.excerpt.include.panel.title.loading"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        });
    }
}
module.exports["ExcerptIncludeComponentShadow"] = $747c563e4499b240$export$8f88facf076a2d46;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $42omo.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $gMc0m.default)([
                "_kqswstnw _1ltv1ssb _154i1ssb _1pbyb4wl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("dhEYL", function(module, exports) {
const $9b021e0aba5455d5$export$21f42ab9b6679f44 = {
    display: 'block',
    // DEBUGGING
    borderWidth: "var(--ds-border-width, 1px)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    borderImage: 'initial'
};
const $9b021e0aba5455d5$export$92937d9937dc7ce9 = {
    display: 'block',
    // DEBUGGING
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    minWidth: '128px',
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $9b021e0aba5455d5$export$d763905bda51ef54 = {
    display: 'block',
    // DEBUGGING
    minWidth: '128px',
    borderWidth: `${"var(--ds-border-width, 1px)"} 0px 0px 0px`,
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    padding: "var(--ds-space-100, 8px)"
};
const $9b021e0aba5455d5$export$99e3f651fb62ec86 = {
    color: "var(--ds-text-subtlest, #6B6E76)",
    paddingLeft: "var(--ds-space-050, 4px)"
};
module.exports["panel"] = $9b021e0aba5455d5$export$21f42ab9b6679f44;
module.exports["panelHeader"] = $9b021e0aba5455d5$export$92937d9937dc7ce9;
module.exports["panelBody"] = $9b021e0aba5455d5$export$d763905bda51ef54;
module.exports["panelHeaderExcerpt"] = $9b021e0aba5455d5$export$99e3f651fb62ec86;

});

parcelRegister("lOZaN", function(module, exports) {

let $fe2db82e21f02113$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe2db82e21f02113$var$load("cbazH"),
    $fe2db82e21f02113$var$load("hH53H"),
    $fe2db82e21f02113$var$load("3QXpo"),
    $fe2db82e21f02113$var$load("6wr18"),
    $fe2db82e21f02113$var$load("Wowvf"),
    $fe2db82e21f02113$var$load("ffEVr"),
    $fe2db82e21f02113$var$load("jXx9i"),
    $fe2db82e21f02113$var$load("9tNcH")
]).then(()=>parcelRequire('c6u22'));

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("3s7IL"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("3s7IL", function(module, exports) {

let $2839f9de99f8341c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2839f9de99f8341c$var$load("khyhL"),
    $2839f9de99f8341c$var$load("YAi2k"),
    $2839f9de99f8341c$var$load("adNrA"),
    $2839f9de99f8341c$var$load("oTA4y"),
    $2839f9de99f8341c$var$load("fPbCp"),
    $2839f9de99f8341c$var$load("6wr18"),
    $2839f9de99f8341c$var$load("ffEVr"),
    $2839f9de99f8341c$var$load("hhss7"),
    $2839f9de99f8341c$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});

parcelRegister("l7BGZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("9ddze"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("9ddze"))).LiveSearch
});
module.exports["LiveSearchLoader"] = $076f2e82bb035170$export$b5586d12ffc2e1b;
module.exports["LazyLiveSearchLoader"] = $076f2e82bb035170$export$e7e4bc50f3fd132e;

});

parcelRegister("9ddze", function(module, exports) {

let $6b4fda216313e64a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b4fda216313e64a$var$load("oTA4y"),
    $6b4fda216313e64a$var$load("fPbCp"),
    $6b4fda216313e64a$var$load("6wr18"),
    $6b4fda216313e64a$var$load("jYRaq"),
    $6b4fda216313e64a$var$load("hUmZG"),
    $6b4fda216313e64a$var$load("8059b"),
    $6b4fda216313e64a$var$load("ffEVr"),
    $6b4fda216313e64a$var$load("7s1i1"),
    $6b4fda216313e64a$var$load("Wowvf"),
    $6b4fda216313e64a$var$load("1F7LX"),
    $6b4fda216313e64a$var$load("7EorR"),
    $6b4fda216313e64a$var$load("hhss7"),
    $6b4fda216313e64a$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("80XcX"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("80XcX"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("80XcX", function(module, exports) {

let $5d5c404acc9255ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d5c404acc9255ac$var$load("cbazH"),
    $5d5c404acc9255ac$var$load("hH53H"),
    $5d5c404acc9255ac$var$load("3QXpo"),
    $5d5c404acc9255ac$var$load("jXx9i"),
    $5d5c404acc9255ac$var$load("9ftJe"),
    $5d5c404acc9255ac$var$load("hhss7"),
    $5d5c404acc9255ac$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("31HPn", function(module, exports) {
const $23fc703b824b091d$export$38c6526d67de94bb = 'xen:macro';
const $23fc703b824b091d$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $23fc703b824b091d$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $23fc703b824b091d$export$46fc26821adc3495 = 'connectAddon';
const $23fc703b824b091d$export$95077f102dafd025 = 'migratedServerP2Addon';
const $23fc703b824b091d$export$981e47da3e2dfc13 = 'bodiedExtension';
const $23fc703b824b091d$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $23fc703b824b091d$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $23fc703b824b091d$export$bf4c163a4c708db1 = 'forgeDocUpdated';
module.exports["MODULE_NAME"] = $23fc703b824b091d$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $23fc703b824b091d$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $23fc703b824b091d$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $23fc703b824b091d$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $23fc703b824b091d$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $23fc703b824b091d$export$bf4c163a4c708db1;

});

parcelRegister("2igSQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fb3kw = parcelRequire("fb3kw");


var $2xdp1 = parcelRequire("2xdp1");


var $kwjRd = parcelRequire("kwjRd");


var $idCCS = parcelRequire("idCCS");

const $f852cc0c808326c8$export$cdee65ffaf9b2fb7 = ({ parameters: parameters })=>{
    // https://github.com/final-form/react-final-form/issues/103
    // If users name variables using numbers it breaks the form
    // hacky fix added a $ character in front
    const inputName = `$${parameters?.name}`;
    const inputPlaceholder = `${parameters?.placeholder || parameters?.name}`;
    // . [ or ] in the variable name causes Final Form to throw an error
    const validInputName = inputName.replace(/[`.\[\]\/]/gi, '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableInputWrapper), null, parameters?.type === (0, $2xdp1.MULTI_LINES_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableTextareaInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            display: 'inline-block',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.TemplateVariableInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: '0px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))));
};
module.exports["TemplateVariableInput"] = $f852cc0c808326c8$export$cdee65ffaf9b2fb7;

});

parcelRegister("2xdp1", function(module, exports) {

var $55ggG = parcelRequire("55ggG");

const $df54c7f294e74661$export$178c63c1bbc65458 = (0, $55ggG.i18n).templateVariableDefault.defaultMessage;
const $df54c7f294e74661$export$ae3b897442224943 = 'text';
const $df54c7f294e74661$export$a43e313f04be91d7 = 'textarea';
const $df54c7f294e74661$export$22c50a44ec8aa5dd = 'select';
const $df54c7f294e74661$export$d1952e7dbe0fefc9 = 5;
const $df54c7f294e74661$export$777b44f8413b254e = 100;
module.exports["defaultVariableName"] = $df54c7f294e74661$export$178c63c1bbc65458;
module.exports["TEXT_TYPE"] = $df54c7f294e74661$export$ae3b897442224943;
module.exports["MULTI_LINES_TYPE"] = $df54c7f294e74661$export$a43e313f04be91d7;
module.exports["LIST_TYPE"] = $df54c7f294e74661$export$22c50a44ec8aa5dd;
module.exports["ROWS_DEFAULT"] = $df54c7f294e74661$export$d1952e7dbe0fefc9;
module.exports["COLUMNS_DEFAULT"] = $df54c7f294e74661$export$777b44f8413b254e;

});

parcelRegister("55ggG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $446fbea06bd2a31f$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    propertyPanelVariableDisplayString: {
        id: "template-variable.property.panel.variable.display.string",
        defaultMessage: "Text"
    },
    propertyPanelVariableDisplayStringTooltip: {
        id: "template-variable.property.panel.variable.display.string.tooltip",
        defaultMessage: "Single line text input field."
    },
    propertyPanelVariableDisplayTextArea: {
        id: "template-variable.property.panel.variable.display.textarea",
        defaultMessage: "Multi-line Text"
    },
    propertyPanelVariableDisplayTextAreaTooltip: {
        id: "template-variable.property.panel.variable.display.textarea.tooltip",
        defaultMessage: "Multi-line text input field."
    },
    propertyPanelVariableDisplayList: {
        id: "template-variable.property.panel.variable.display.list",
        defaultMessage: "List"
    },
    propertyPanelVariableDisplayListTooltip: {
        id: "template-variable.property.panel.variable.display.list.tooltip",
        defaultMessage: "Drop down list."
    },
    templateEditorChangingVariableDialogTitle: {
        id: "template-variable.template.editor.changing.variable.dialog.title",
        defaultMessage: "Edit template variable"
    },
    templateEditorVariableNameField: {
        id: "template-variable.template.editor.variable.name.field",
        defaultMessage: "Variable name"
    },
    propertyPanelVariableDisplayTextAreaRowsTooltip: {
        id: "template-variable.property.panel.variable.textarea.rows.tooltip",
        defaultMessage: "Number of rows to display for the field."
    },
    propertyPanelVariableDisplayTextAreaColumnsTooltip: {
        id: "template-variable.property.panel.variable.textarea.columns.tooltip",
        defaultMessage: "Number of columns to display for the field."
    },
    propertyPanelVariableListValuesTooltip: {
        id: "template-variable.property.panel.variable.list.values.tooltip",
        defaultMessage: "Enter each item for the list, separating each with a comma."
    },
    templateEditorVariableListFieldPlaceholder: {
        id: "template-variable.template.editor.variable.list.field.placeholder",
        defaultMessage: "option 1, option 2, option 3"
    },
    templateEditorVariableSaveButtonLabel: {
        id: "template-variable.template.editor.variable.save.button.label",
        defaultMessage: "Save"
    },
    templateVariableDefault: {
        id: "template-variable.template.editor.variable.name.default",
        defaultMessage: "variable_name"
    }
});
module.exports["i18n"] = $446fbea06bd2a31f$export$a7357cdd1f0b0168;

});

parcelRegister("kwjRd", function(module, exports) {
/* SharedComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f809923cf8cfa046$export$4af78215734bfe2b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkxmi2 _otyrpxbi _n3tdv77o _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$59d0bfd82baefce0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41e2s _2rko458z _bfhk1s93",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$8eff3c6bf5b8c758 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1nmz9jpi _syazi7uo _k48p4jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$b4ff36272a61159f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41e2s _2rko18r2 _syaz1rpy _bfhk1s93 _1nmz9jpi",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _o5724jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e9df20cb66227872 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _p12f1osq _kqswh2mm _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_vr2wn7od",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$c996e1cc40266f34 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
module.exports["TemplateVariableInputWrapper"] = $f809923cf8cfa046$export$4af78215734bfe2b;
module.exports["TemplateVariableNameWrapper"] = $f809923cf8cfa046$export$59d0bfd82baefce0;
module.exports["TemplateVariableName"] = $f809923cf8cfa046$export$8eff3c6bf5b8c758;
module.exports["TemplateVariableType"] = $f809923cf8cfa046$export$b4ff36272a61159f;
module.exports["TemplateVariableInputFieldWrapper"] = $f809923cf8cfa046$export$e3cad7a6d45ce703;
module.exports["TemplateVariableTextareaInputFieldWrapper"] = $f809923cf8cfa046$export$e9df20cb66227872;
module.exports["ButtonStyle"] = $f809923cf8cfa046$export$bdc3c19374266b98;
module.exports["DropDownInputWrapper"] = $f809923cf8cfa046$export$c996e1cc40266f34;

});

parcelRegister("idCCS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $9EtP6 = parcelRequire("9EtP6");


var $4noo5 = parcelRequire("4noo5");


var $6Ipjn = parcelRequire("6Ipjn");


var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $kwjRd = parcelRequire("kwjRd");


var $2xdp1 = parcelRequire("2xdp1");

const $ab3c5e793706abd9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    invalidVariableNameError: {
        id: "template-variable.description.invalid.variable.name",
        defaultMessage: "This template contains a variable using invalid character(s) (. , [ , ], /). Please have the template owner remove these characters from the variable to use it."
    }
});
const $ab3c5e793706abd9$var$generateDropdownOptionsList = (options)=>options ? options.map((option)=>({
            label: option,
            value: option
        })) : [];
const $ab3c5e793706abd9$var$styles = {
    option: (provided)=>({
            ...provided,
            wordBreak: 'break-word'
        })
};
const $ab3c5e793706abd9$var$checkTemplateVariableValidity = (variableName)=>{
    const invalidVariableCharacters = [
        '.',
        '[',
        ']',
        '/'
    ];
    return invalidVariableCharacters.some((invalidVariableCharacter)=>variableName?.includes(invalidVariableCharacter));
};
const $ab3c5e793706abd9$export$25a5c8174bd010d5 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $aXWIB.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    const parameterOptions = parameters.params && parameters.params.options;
    const options = (0, $42omo.useMemo)(()=>$ab3c5e793706abd9$var$generateDropdownOptionsList(parameterOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        parameterOptions
    ]);
    const onChangeHandler = (0, $42omo.useMemo)(()=>(option)=>{
            onChange(option.value);
        }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: hasInvalidVariableName
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: parameters.isDisabled
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    })));
};
const $ab3c5e793706abd9$export$b9055edfa32ac8b4 = ({ onChange: onChange, value: value, inputName: inputName, parameters: parameters, placeholder: placeholder })=>{
    const intl = (0, $aXWIB.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ...tooltipProps,
            testId: "text-field-input",
            name: inputName,
            onChange: onChange,
            value: value || '',
            placeholder: placeholder,
            isDisabled: hasInvalidVariableName,
            width: 200,
            isCompact: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        testId: "text-field-input",
        name: inputName,
        onChange: onChange,
        value: value || '',
        placeholder: placeholder,
        isDisabled: parameters?.isDisabled,
        width: 200,
        isCompact: true
    }));
};
const $ab3c5e793706abd9$export$9a5caaaacb4c92d3 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $aXWIB.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
            ...tooltipProps,
            testId: "text-area-input",
            onChange: onChange,
            value: value || '',
            minimumRows: parameters.params && parameters.params.rows || 1,
            cols: parameters.params && parameters.params.columns || 30,
            resize: "vertical",
            isDisabled: hasInvalidVariableName,
            placeholder: placeholder
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        testId: "text-area-input",
        onChange: onChange,
        value: value || '',
        minimumRows: parameters.params && parameters.params.rows || 1,
        cols: parameters.params && parameters.params.columns || 30,
        resize: "vertical",
        isDisabled: parameters?.isDisabled,
        placeholder: placeholder
    }));
};
const $ab3c5e793706abd9$export$f57c870ff73570c7 = (props)=>{
    const { parameters: parameters } = props;
    switch(parameters.type){
        case 0, $2xdp1.LIST_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$25a5c8174bd010d5, props);
        case 0, $2xdp1.MULTI_LINES_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$9a5caaaacb4c92d3, props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab3c5e793706abd9$export$b9055edfa32ac8b4, props);
    }
};
module.exports["TemplateVariableInputComponent"] = $ab3c5e793706abd9$export$f57c870ff73570c7;

});

parcelRegister("hHZWk", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $42omo.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $frIzR.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("aMfLn", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $kDIns = parcelRequire("kDIns");

const $194c389c7ab5ab2c$export$bbbd7ccaedea9691 = async ({ rendererActions: rendererActions, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const allAnnotationMarks = rendererActions?.getAnnotationMarks();
    const allAnnotationIds = allAnnotationMarks?.map((mark)=>mark.attrs.id) || [];
    (0, $kDIns.getRendererAnnotationStates)({
        annotations: allAnnotationIds,
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        validAnnotationsCallback: updateUnresolvedInlineComment,
        isNestedRender: false
    }).catch(()=>{
    //intentional no-op
    });
};
const $194c389c7ab5ab2c$export$2600439b3e609c06 = (step, pos)=>{
    // AddMarkStep has additional properties that aren't allowed in the mutation variables
    const markInfo = {
        mark: {
            attrs: {
                annotationType: 'inlineComment',
                id: step.mark.attrs.id
            },
            type: 'annotation'
        }
    };
    // TODO: remove this logic since pos should be read from step
    if (pos !== undefined) return {
        pos: pos,
        ...markInfo
    };
    if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) {
        const { from: from, to: to } = step;
        return {
            from: from,
            to: to,
            ...markInfo
        };
    }
    return {
        pos: step.pos,
        ...markInfo
    };
};
module.exports["updateRendererAnnotations"] = $194c389c7ab5ab2c$export$bbbd7ccaedea9691;
module.exports["constructStepForGql"] = $194c389c7ab5ab2c$export$2600439b3e609c06;

});

parcelRegister("kDIns", function(module, exports) {

var $kmYOg = parcelRequire("kmYOg");


var $2XqLN = parcelRequire("2XqLN");


var $a4TK8 = parcelRequire("a4TK8");


var $cUycv = parcelRequire("cUycv");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $vNBpg = parcelRequire("vNBpg");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $gtj7V = parcelRequire("gtj7V");


var $cD1qu = parcelRequire("cD1qu");


var $c0rhi = parcelRequire("c0rhi");

const $655a1f23a26f4e27$export$c53aa0aa4a7c5e4 = (0, $kmYOg.default);
const $655a1f23a26f4e27$export$7037a4d88a618a89 = (contentId, pageMode)=>({
        pageId: contentId,
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        first: (0, $NYiei.MAX_COMMENTS_TO_RETURN)
    });
const $655a1f23a26f4e27$var$logger = (0, $7W8i8.getLogger)('inline-comments-common:state-resolver');
const $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData = async ({ contentId: contentId, pageMode: pageMode })=>{
    if (!contentId) return [];
    // Check if processed comments data is available
    const processedData = (0, $4L9ve.getProcessedCommentsDataState)();
    // If data is processed, use it directly
    if (processedData.isDataProcessed) return processedData.openInlineComments;
    // Data not processed yet - fetch fresh data directly with network-only
    // This is simpler (albeit slightly slower) than preloading and guarantees fresh data
    // If we do preload in the future - keep in mind that we have to satisfy the following use cases
    // 1. We load in SSR and preload fails --> no cache data
    // 2. We load in SPA and preload hasn't completed before we check the cache value
    // 3. We load in SPA and have a stale value in the cache
    // If preloading you can also show stale data initially and refresh by manually updating annotations states
    // However if you do this, be careful for integrations w/ focused comments
    try {
        const result = await (0, $c0rhi.queryInterop)({
            query: $655a1f23a26f4e27$export$c53aa0aa4a7c5e4,
            variables: $655a1f23a26f4e27$export$7037a4d88a618a89(contentId, pageMode),
            fetchPolicy: 'network-only',
            __callerPackage__: "@confluence/comments-util"
        });
        return result?.data?.comments?.nodes?.filter((node)=>node?.location) || [];
    } catch  {
        return [];
    }
};
const $655a1f23a26f4e27$export$8f0e4480674935ab = (0, $2XqLN.default)((annotations, validAnnotationsCallback, states, reactionMarkerRefs, optimisticResolvedMarkerRefs)=>{
    const rendererAnnotationMap = {};
    const annotationState = [];
    const optimisticResolvedMarkerRefSet = new Set(optimisticResolvedMarkerRefs);
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Renderer
        rendererAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: (0, $cUycv.AnnotationMarkStates).RESOLVED
        });
    });
    states?.forEach((state)=>{
        const annotationId = state.location.inlineMarkerRef;
        const isResolved = Boolean(state.location?.inlineResolveProperties?.resolved) || (annotationId ? optimisticResolvedMarkerRefSet.has(annotationId) : false);
        // mark all unresolved annotations to be displayed by the renderer
        if (!isResolved) {
            if (annotationId) {
                const index = rendererAnnotationMap[annotationId];
                /**
         * If the BE returns an annotation that the Renderer did not
         * provide, we could error here. Also account for 0 index.
         */ if (index || index === 0) annotationState[index].state = (0, $cUycv.AnnotationMarkStates).ACTIVE;
            }
        }
    });
    // Mark inline reaction annotations as ACTIVE so they render as highlights
    reactionMarkerRefs?.forEach((markerRef)=>{
        const index = rendererAnnotationMap[markerRef];
        if ((index || index === 0) && !optimisticResolvedMarkerRefSet.has(markerRef)) annotationState[index].state = (0, $cUycv.AnnotationMarkStates).ACTIVE;
    });
    const validAnnotations = annotations.filter((annotation)=>{
        const index = rendererAnnotationMap[annotation];
        return annotationState[index].state === (0, $cUycv.AnnotationMarkStates).ACTIVE;
    });
    // Record the valid annotations to use for navigation and query params
    validAnnotationsCallback(validAnnotations);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $655a1f23a26f4e27$export$228a0d958905d789 = (0, $2XqLN.default)((annotations, states, updateUnresolvedInlineComment, optimisticResolvedMarkerRefs)=>{
    /**
   * Build a map of annotation states with a default of true for resolved.
   * This is to accommodate deleted annotations that still exist in the ADF.
   */ const editorAnnotationMap = {};
    const annotationState = [];
    const optimisticResolvedMarkerRefSet = new Set(optimisticResolvedMarkerRefs);
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Editor
        editorAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: {
                resolved: true
            }
        });
    });
    states.forEach((state)=>{
        const annotationId = state?.location?.inlineMarkerRef || '';
        const isResolved = Boolean(state?.location?.inlineResolveProperties?.resolved) || (annotationId ? optimisticResolvedMarkerRefSet.has(annotationId) : false);
        // mark all unresolved annotations to be displayed by the editor
        if (!isResolved) {
            const index = editorAnnotationMap[annotationId];
            /**
       * If the BE returns an annotation that the Editor did not
       * provide, we could error here. Also account for 0 index.
       */ if (index || index === 0) annotationState[index].state.resolved = false;
        }
    });
    //Ordered list of unresolved inline comments
    const unresolvedInlineComments = annotations.filter((annotationId)=>{
        const index = editorAnnotationMap[annotationId];
        if (!annotationState[index].state.resolved) return annotationId;
    });
    updateUnresolvedInlineComment(unresolvedInlineComments);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $655a1f23a26f4e27$export$38c1ce6adefc79a5 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs })=>{
    if (!annotations.length) {
        updateUnresolvedInlineComment([]);
        return Promise.resolve([]);
    }
    try {
        let annotationStateNodes;
        // Check if we should use the new comments data manager flow
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Use preload-aware annotations data utility
        annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).LIVE // same as PageMode.EDIT for our case
        });
        else {
            // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
            const data = await (0, $c0rhi.queryInterop)({
                query: (0, $vNBpg.AnnotationStateQuery),
                fetchPolicy: 'network-only',
                variables: {
                    pageId: pageId,
                    // @ts-ignore - Legacy contentStatus values passed before typecheck changes
                    contentStatus: [
                        'DRAFT',
                        'CURRENT'
                    ]
                },
                __callerPackage__: "@confluence/comments-util"
            });
            // Filter null elements
            annotationStateNodes = data.data.comments?.nodes?.filter((node)=>node !== null);
        }
        // Common logic: map annotation state nodes to editor states
        return $655a1f23a26f4e27$export$228a0d958905d789(annotations, annotationStateNodes, updateUnresolvedInlineComment, optimisticResolvedMarkerRefs);
    } catch (error) {
        // COMMENTS-211 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                data: {
                    source: 'editorComponent',
                    action: 'failed',
                    actionSubject: 'annotationState',
                    actionSubjectId: 'inlineComments',
                    attributes: {
                        errorName: error.name,
                        errorMessage: error.message
                    }
                },
                type: 'sendOperationalEvent'
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
let $655a1f23a26f4e27$var$rendererAnnotationsIds;
const $655a1f23a26f4e27$export$a0fcca613dd8b2c7 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, validAnnotationsCallback: validAnnotationsCallback, isNestedRender: isNestedRender, reactionMarkerRefs: reactionMarkerRefs, optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs })=>{
    // We need to have the page level renderer annotations
    // When the page renders the value of isNestedRender is false as per PageContentRendererFabrics
    // Later, when the macro renders isNestedRender is true
    // so, we will hold the value of annotations for the page renderer when isNestedRender is false
    if (!annotations.length) {
        validAnnotationsCallback([]);
        return Promise.resolve([]);
    }
    if (!isNestedRender) $655a1f23a26f4e27$var$rendererAnnotationsIds = annotations;
    try {
        let annotationStateNodes;
        // Check if we should use the new comments data manager flow
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Use preload-aware annotations data utility
        annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).VIEW
        });
        else {
            // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
            const data = await (0, $c0rhi.queryInterop)({
                query: (0, $vNBpg.AnnotationStateQuery),
                fetchPolicy: isNestedRender ? 'cache-first' : 'network-only',
                variables: {
                    pageId: pageId
                },
                __callerPackage__: "@confluence/comments-util"
            });
            // Filter null elements
            annotationStateNodes = data.data.comments?.nodes?.filter((node)=>node !== null);
        }
        // Common logic: map annotation state nodes to renderer states
        return $655a1f23a26f4e27$export$8f0e4480674935ab($655a1f23a26f4e27$var$rendererAnnotationsIds, validAnnotationsCallback, annotationStateNodes, reactionMarkerRefs, optimisticResolvedMarkerRefs);
    } catch (error) {
        // COMMENTS-1131 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                source: 'rendererComponent',
                action: 'failed',
                actionSubject: 'annotationState',
                actionSubjectId: 'inlineComments',
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    errorName: error.name,
                    errorMessage: error.message
                }
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
module.exports["getEditorResolvedState"] = $655a1f23a26f4e27$export$38c1ce6adefc79a5;
module.exports["getRendererAnnotationStates"] = $655a1f23a26f4e27$export$a0fcca613dd8b2c7;

});

parcelRegister("kmYOg", function(module, exports) {
/**
 * @generated SignedSource<<8fc743fa44c5cd210e605b4e8ce0cf28>>
 * @relayHash d689c46cc95f36419f19f207f3ceb687
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f
const $f5022931ec1c887f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "INLINE"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "INLINE"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "inlineMarkerRef"
                                        },
                                        {
                                            "concreteType": "InlineCommentResolveProperties",
                                            "kind": "LinkedField",
                                            "name": "inlineResolveProperties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "resolved"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "InlineComment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v3 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "d689c46cc95f36419f19f207f3ceb687",
            "id": "da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f",
            "metadata": {},
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "operationKind": "query",
            "text": "query stateResolverPreloadAnnotationsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:INLINE},type:[INLINE],depth:ROOT,first:$first){nodes{id,contentStatus,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}},totalCount,__typename}}"
        }
    };
}();
$f5022931ec1c887f$var$node.hash = "af92d028ec6cef46bb981d53522dfe18";
var $f5022931ec1c887f$export$2e2bcd8739ae039 = $f5022931ec1c887f$var$node;
module.exports["default"] = $f5022931ec1c887f$export$2e2bcd8739ae039;

});

parcelRegister("vNBpg", function(module, exports) {

var $hRVfm = parcelRequire("hRVfm");

const $951c06b69b244c75$export$dedc8dce0be2f721 = (0, $hRVfm.default);
module.exports["AnnotationStateQuery"] = $951c06b69b244c75$export$dedc8dce0be2f721;

});

parcelRegister("hRVfm", function(module, exports) {
/**
 * @generated SignedSource<<46b3ab55d6477d87980ae5cdc67e4862>>
 * @relayHash 0a59fed9dfa6599d230495f1a47dbc7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26bdeb44b2916ab641fa116a225079027626cb4cc6f97c58a4313672060fb97b
const $791a5813533710f7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1500
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": [
                "INLINE",
                "UNRESOLVED"
            ]
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    }
                ]
            }
        ],
        "type": "InlineComment"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AnnotationStateQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AnnotationStateQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0a59fed9dfa6599d230495f1a47dbc7c",
            "id": "26bdeb44b2916ab641fa116a225079027626cb4cc6f97c58a4313672060fb97b",
            "metadata": {},
            "name": "AnnotationStateQuery",
            "operationKind": "query",
            "text": "query AnnotationStateQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,type:[INLINE,UNRESOLVED],depth:ROOT,first:1500){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved,resolvedUser}}}}}}"
        }
    };
}();
$791a5813533710f7$var$node.hash = "40ea3762a17ce85bcac23a6ef83d3cbe";
var $791a5813533710f7$export$2e2bcd8739ae039 = $791a5813533710f7$var$node;
module.exports["default"] = $791a5813533710f7$export$2e2bcd8739ae039;

});

parcelRegister("804Ue", function(module, exports) {

var $lFugL = parcelRequire("lFugL");


var $42omo = parcelRequire("42omo");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $flE5X = parcelRequire("flE5X");


var $cAdj8 = parcelRequire("cAdj8");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $6mKj3 = parcelRequire("6mKj3");

var $11771bad87ca0882$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["ACTIVE"] = 0] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 1] = "TERMINATED";
    return PubSubState;
}({});
var $11771bad87ca0882$export$77deeade63afd3a6 = /*#__PURE__*/ function(CommentEventType) {
    CommentEventType[CommentEventType["ALL"] = 0] = "ALL";
    CommentEventType[CommentEventType["FOOTER"] = 1] = "FOOTER";
    CommentEventType[CommentEventType["INLINE"] = 2] = "INLINE";
    return CommentEventType;
}({});
const $11771bad87ca0882$export$5a33be95ac52bdad = 2000;
const $11771bad87ca0882$export$f09c511f29ef2d = 3000;
const $11771bad87ca0882$export$45c0a7c4ba2fbb03 = ({ contentId: contentId, eventType: eventType, subscribeToPubSubEvents: subscribeToPubSubEvents, unsubscribeFromPubSubEvents: unsubscribeFromPubSubEvents, onEventFetchSuccess: onEventFetchSuccess, onFetchContentVersionEvent: onFetchContentVersionEvent, onDocumentReturn: onDocumentReturn, lastPollTime: lastPollTime, inactiveInterval: inactiveInterval = $11771bad87ca0882$export$5a33be95ac52bdad, returnInterval: returnInterval = $11771bad87ca0882$export$f09c511f29ef2d, isAutoReloadPageComments: isAutoReloadPageComments = false })=>{
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const lastEventCheckTimeRef = (0, $42omo.useRef)(lastPollTime || Date.now());
    const subscriptionShutdownTimer = (0, $42omo.useRef)(null);
    const missedEventQueryTimeout = (0, $42omo.useRef)(null);
    // Check if document is undefined to handle SSR playwright tests
    const [documentVisible, setDocumentVisible] = (0, $42omo.useState)(typeof document !== 'undefined' ? !document.hidden : true);
    const [pubSubState, setPubSubState] = (0, $42omo.useState)(0);
    const { pageInfo: pageInfo, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        // this is required for page navigation using the page tree
        onCompleted: (data)=>{
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
                const number = data?.content?.nodes?.[0]?.version?.number;
                if (number) setPublishedDocumentVersion(number);
            }
        }
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    (0, $42omo.useEffect)(()=>{
        const latestVersion = pageInfo?.version?.number;
        if (latestVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
            setPublishedDocumentVersion(latestVersion);
            if ((0, $6mKj3.expValEquals)('confluence_fe_correct_document_needs_update', 'isEnabled', true)) // Set documentNeedsUpdate to true only if all of the following are true:
            // 1. pageMode is VIEW
            // 2. currentDocumentVersion is set to a valid version number
            // 3. latestVersion is different from currentDocumentVersion
            // Otherwise, set documentNeedsUpdate to false.
            setDocumentNeedsUpdate(pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion > 0 && latestVersion !== currentDocumentVersion);
            else setDocumentNeedsUpdate(latestVersion !== currentDocumentVersion);
        }
    }, [
        pageInfo?.version?.number,
        currentDocumentVersion,
        setPublishedDocumentVersion,
        setDocumentNeedsUpdate,
        pageMode
    ]);
    const fetchContentVersionNumber = async ()=>{
        try {
            if (refetch) {
                const { data: data } = await refetch();
                return data?.content?.nodes?.[0]?.version?.number;
            }
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            return;
        }
    };
    const fetchMissingCommentEventsSinceTime = async (contentId, since)=>{
        try {
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $lFugL.default),
                variables: {
                    contentId: contentId,
                    since: since
                },
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
                __callerPackage__: "@confluence/comments-pubsub"
            });
            const comments = response.data?.quickReload?.comments || [];
            let filteredCommentEvents = comments;
            // Filter out comment events tha we're not subscribed to
            if (eventType !== 0) filteredCommentEvents = comments.filter((comment)=>eventType === 1 ? comment.comment?.location.type === 'FOOTER' : comment.comment?.location.type === 'INLINE');
            const commentEvents = filteredCommentEvents.map((comment)=>{
                const commentId = comment.comment?.id;
                const type = comment.comment?.location.type;
                const accountId = comment.comment?.author?.accountId || '';
                return {
                    id: commentId,
                    type: type,
                    accountId: accountId
                };
            });
            const time = response.data?.quickReload?.time;
            return {
                commentEvents: commentEvents,
                time: time,
                contentId: contentId
            };
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            // Just do nothing
            return;
        }
    };
    const clearMissedEventTimeout = ()=>{
        if (missedEventQueryTimeout.current) {
            clearTimeout(missedEventQueryTimeout.current);
            missedEventQueryTimeout.current = null;
        }
    };
    const checkAndHandleMissedEvents = ()=>{
        // If we already have a timeout queued clear it
        clearMissedEventTimeout();
        // Check for the missed events on a timeout after the user has been back for 3 seconds
        missedEventQueryTimeout.current = setTimeout(async ()=>{
            if (documentNeedsUpdate) return;
            const contentLatestVersion = await fetchContentVersionNumber();
            if (!isAutoReloadPageComments && contentLatestVersion !== publishedDocumentVersion) {
                if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // when experiment is ON, this is done in the useEffect block above
                setPublishedDocumentVersion(contentLatestVersion);
                onFetchContentVersionEvent && onFetchContentVersionEvent();
                return;
            }
            // Call passed in fetch function
            fetchMissingCommentEventsSinceTime(contentId, lastEventCheckTimeRef.current || Date.now()).then((res)=>{
                // This check of content types is needed in case the promise resolves after a user has already changed pages
                if (res && contentId === res.contentId) {
                    lastEventCheckTimeRef.current = res.time ?? Date.now();
                    // Return the result to the caller
                    onEventFetchSuccess(res);
                }
            // If the call fails, do nothing, just assume the events were missed
            });
        }, returnInterval);
    };
    // Wire up pub sub events when the component mounts
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window.removeEventListener('beforeunload', unsubscribeFromPubSubEvents);
            unsubscribeFromPubSubEvents();
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
            clearMissedEventTimeout();
        };
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Need to subscribe to the pubsub when component mounts or contentId, publishedDocumentVersion changes
    (0, $42omo.useEffect)(()=>{
        // No need to subscribe to the pubsub when doc version is 0
        // We need the events only when we have a valid version number i.e published
        if (publishedDocumentVersion === 0) return;
        subscribeToPubSubEvents();
        // Make sure to unsubscribe from pubsub events if the browser closes
        window.addEventListener('beforeunload', unsubscribeFromPubSubEvents);
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        publishedDocumentVersion,
        documentNeedsUpdate
    ]);
    // Listen to document visibility changes
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        const changeVisibility = ()=>setDocumentVisible(!document.hidden);
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>{
            document.removeEventListener('visibilitychange', changeVisibility);
        };
    }, [
        setDocumentVisible
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        if (documentVisible && subscriptionShutdownTimer.current) {
            clearTimeout(subscriptionShutdownTimer.current);
            subscriptionShutdownTimer.current = null;
        }
        // When the document becomes hidden, record the current time as the last check time
        if (!documentVisible) lastEventCheckTimeRef.current = Date.now();
        // If the document is no longer visible, set a timeout to unsubscribe from pubsub events
        if (!documentVisible && !subscriptionShutdownTimer.current && pubSubState === 0) subscriptionShutdownTimer.current = setTimeout(()=>{
            unsubscribeFromPubSubEvents();
            setPubSubState(1);
        }, inactiveInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    // Resubscribe to the pubsub events when we come back and handle any missed events
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        setPubSubState((prevState)=>{
            if (documentVisible && prevState === 1) {
                onDocumentReturn && onDocumentReturn();
                checkAndHandleMissedEvents();
                subscribeToPubSubEvents();
                return 0;
            }
            return prevState;
        });
    // We only want this to fire when the document visibility has changed, not the pubsub state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    return null;
};
module.exports["CommentEventType"] = $11771bad87ca0882$export$77deeade63afd3a6;
module.exports["MissedPubSubCommentEventsHandler"] = $11771bad87ca0882$export$45c0a7c4ba2fbb03;

});

parcelRegister("lFugL", function(module, exports) {
/**
 * @generated SignedSource<<ec37448e00124aacfed3c0e6870df73b>>
 * @relayHash 7477557bbdcb7cd2b6d07a81a3bcb66a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559
const $f560d9e78fe64cde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "since"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "since",
            "variableName": "since"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "time"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "KnownUser"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "UnknownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7477557bbdcb7cd2b6d07a81a3bcb66a",
            "id": "b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559",
            "metadata": {},
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "operationKind": "query",
            "text": "query MissedPubSubCommentEventsHandlerQuery($contentId:Long!,$since:Long!){quickReload(pageId:$contentId,since:$since){time,comments{comment{id,location{__typename,type},author{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}"
        }
    };
}();
$f560d9e78fe64cde$var$node.hash = "7c3b6fa82a316ebe81a0bcd5cab2114e";
var $f560d9e78fe64cde$export$2e2bcd8739ae039 = $f560d9e78fe64cde$var$node;
module.exports["default"] = $f560d9e78fe64cde$export$2e2bcd8739ae039;

});

parcelRegister("a8ZQ3", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0e1f4810033038ec$export$82f0a2c62bb8fbf = /*#__PURE__*/ (0, $42omo.createContext)({
    documentUpdated: false,
    documentNeedsUpdate: false,
    publishedDocumentVersion: 0,
    currentDocumentVersion: 0
});
$0e1f4810033038ec$export$82f0a2c62bb8fbf.displayName = 'DocumentUpdateStatusContext';
const $0e1f4810033038ec$export$d35f8c93092bdd5a = /*#__PURE__*/ (0, $42omo.createContext)({
    setDocumentUpdated: ()=>{},
    setDocumentNeedsUpdate: ()=>{},
    setPublishedDocumentVersion: ()=>{},
    setCurrentDocumentVersion: ()=>{}
});
$0e1f4810033038ec$export$d35f8c93092bdd5a.displayName = 'DocumentUpdateStatusDispatchContext';
const $0e1f4810033038ec$export$e1e6df7f9af5d046 = ({ children: children })=>{
    const [documentUpdated, setDocumentUpdated] = (0, $42omo.useState)(false);
    const [documentNeedsUpdate, setDocumentNeedsUpdate] = (0, $42omo.useState)(false);
    const [publishedDocumentVersion, setPublishedDocumentVersion] = (0, $42omo.useState)(0);
    const [currentDocumentVersion, setCurrentDocumentVersion] = (0, $42omo.useState)(0);
    const providerValue = (0, $42omo.useMemo)(()=>({
            documentUpdated: documentUpdated,
            documentNeedsUpdate: documentNeedsUpdate,
            publishedDocumentVersion: publishedDocumentVersion,
            currentDocumentVersion: currentDocumentVersion
        }), [
        documentUpdated,
        documentNeedsUpdate,
        publishedDocumentVersion,
        currentDocumentVersion
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setDocumentUpdated: setDocumentUpdated,
            setDocumentNeedsUpdate: setDocumentNeedsUpdate,
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            setCurrentDocumentVersion: setCurrentDocumentVersion
        }), [
        setDocumentUpdated,
        setDocumentNeedsUpdate,
        setPublishedDocumentVersion,
        setCurrentDocumentVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$82f0a2c62bb8fbf.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$d35f8c93092bdd5a.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $0e1f4810033038ec$export$ff9e1d20f8dc4075 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$82f0a2c62bb8fbf);
};
const $0e1f4810033038ec$export$317fac591d89e2e3 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$d35f8c93092bdd5a);
};
module.exports["DocumentUpdateStatusProvider"] = $0e1f4810033038ec$export$e1e6df7f9af5d046;
module.exports["useDocumentUpdateStatus"] = $0e1f4810033038ec$export$ff9e1d20f8dc4075;
module.exports["useDocumentUpdateStatusDispatch"] = $0e1f4810033038ec$export$317fac591d89e2e3;

});

parcelRegister("b11gn", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gtj7V = parcelRequire("gtj7V");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

var $c84c3a6392bd7f68$export$4dc7cc9100b67c07 = /*#__PURE__*/ function(CommentsPubSubSource) {
    CommentsPubSubSource["EditorInlineCommentsPubSub"] = "editorInlineCommentsPubSub";
    CommentsPubSubSource["RendererInlineCommentsPubSub"] = "rendererInlineCommentsPubSub";
    CommentsPubSubSource["PageCommentsPubSub"] = "pageCommentsPubSub";
    return CommentsPubSubSource;
}({});
const $c84c3a6392bd7f68$export$c83a826d1956bd57 = (source)=>{
    // Unique per event invocation; lets us detect concurrent-event collisions
    // by matching initialTrackingId === terminalTrackingId in logs.
    let trackingId;
    return {
        start: (event)=>{
            if (!(0, $9wGTI.fg)('cc_comments_pubsub_experience_tracking_enabled')) return;
            // IMPORTANT - because this is in a factory method, it is deliberate that mixing
            // & matching starts / failures / successes across invocations will lead to different trackingIDs.
            // If you need to refactor this to be cross-file, or cross-function for a valid case,
            // you'll probably need to lift this out of the factory
            trackingId = crypto.randomUUID();
            (0, $fGzMp.getExperienceTracker)().start({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                // 15s — above the AGG client's ~10s network timeout.
                timeout: 15000,
                attributes: {
                    event: event,
                    source: source,
                    initialTrackingId: trackingId,
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
                }
            });
        },
        succeed: ()=>{
            if (!(0, $9wGTI.fg)('cc_comments_pubsub_experience_tracking_enabled')) return;
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                attributes: {
                    terminalTrackingId: trackingId
                }
            });
        },
        fail: (err)=>{
            if (!(0, $9wGTI.fg)('cc_comments_pubsub_experience_tracking_enabled')) return;
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                error: err instanceof Error ? err : new Error(String(err)),
                attributes: {
                    terminalTrackingId: trackingId
                }
            });
        }
    };
};
module.exports["CommentsPubSubSource"] = $c84c3a6392bd7f68$export$4dc7cc9100b67c07;
module.exports["createCommentsPubSubExperienceTracker"] = $c84c3a6392bd7f68$export$c83a826d1956bd57;

});

parcelRegister("a3q17", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $60a54f1e533f2ef6$export$52ff686bd4414bc5 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$ac7f79e65475cee7 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$321e1f68b293bf76 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'highlightsRendered',
            endMark: 'highlightsRendered'
        }
    ]
});
const $60a54f1e533f2ef6$export$fc794218ec0a6fa5 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: 'direct-comment-data-flow',
    timings: [
        {
            key: 'commentCreationStart',
            startMark: 'commentCreationStart'
        },
        {
            key: 'commentCreationEnd',
            endMark: 'commentCreationEnd'
        },
        {
            key: 'commentDataLoad',
            startMark: 'commentDataLoadStart',
            endMark: 'commentDataLoadEnd'
        }
    ]
});
module.exports["EDITOR_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$52ff686bd4414bc5;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$ac7f79e65475cee7;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_METRIC"] = $60a54f1e533f2ef6$export$321e1f68b293bf76;
module.exports["DIRECT_COMMENT_DATA_FLOW_METRIC"] = $60a54f1e533f2ef6$export$fc794218ec0a6fa5;

});

parcelRegister("4gEXU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $bSvtO = parcelRequire("bSvtO");

function $4ccc472e1abe9fa4$export$b3246a2f66464d01({ onConfirm: onConfirm }) {
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    // This hook enables the new preemptive gate for the editor comment API manager to catch the situation
    // where the user tries to start a draft while there is unsaved content in the editor.
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            if (hasContentChanged) annotationManager.setPreemptiveGate(()=>{
                return new Promise((resolve)=>{
                    showModal((0, $cMvMc.CommentWarningDialog), {
                        onConfirm: ()=>{
                            resetContentChanged();
                            onConfirm();
                            // Allow the draft to be started or the comment viewed.
                            resolve(true);
                        },
                        onCancel: ()=>{
                            // Cancel the start draft or view attempt.
                            resolve(false);
                        },
                        onClose: ()=>{
                            // Just in case the user closes the modal by some other means we need to ensure the
                            // promise is resolved. We do not want to leave the preemptive gate open.
                            resolve(false);
                        }
                    });
                });
            });
            else annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            return ()=>{
                annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            };
        }
    }, [
        hasContentChanged,
        annotationManager,
        showModal,
        resetContentChanged,
        onConfirm
    ]);
}
module.exports["usePreemptiveGate"] = $4ccc472e1abe9fa4$export$b3246a2f66464d01;

});

parcelRegister("WheoQ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b0ecc354fcdb9645$export$23b7aa19be1bc1ad = (callbacks)=>(0, $42omo.useCallback)((annotationsList)=>{
        callbacks.forEach((callback)=>callback(annotationsList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, callbacks);
module.exports["useUpdateAnnotations"] = $b0ecc354fcdb9645$export$23b7aa19be1bc1ad;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("3D6uL", function(module, exports) {

var $3w2O3 = parcelRequire("3w2O3");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $dc4cdd28902d8267$export$6bf92d32985d66db = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $3w2O3.default), {
        fetchPolicy: 'cache-and-network',
        skip: !userId,
        __callerPackage__: "@confluence/comments-util"
    });
    return (0, $42omo.useMemo)(()=>{
        // We always want to default to true until we get a result
        let isHighlightOptionPanelEnabled = true;
        if (error) // We always want to handle errors caused from this, just default to existing behavior
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!loading && data?.userPreferences) isHighlightOptionPanelEnabled = data?.userPreferences.highlightOptionPanelEnabled;
        return {
            isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled
        };
    }, [
        data,
        loading,
        error
    ]);
};
module.exports["useIsHighlightOptionPanelEnabled"] = $dc4cdd28902d8267$export$6bf92d32985d66db;

});

parcelRegister("3w2O3", function(module, exports) {
/**
 * @generated SignedSource<<270a8763bde6e8a6b1f015f9a7a2f8e7>>
 * @relayHash 8a0218b2e1c99a56ce8c33454f5c992d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0cf895ac8ba230224c74d275c984b0c91d2ac44dddcf2fde63e3993339c6b240
const $9a2dad19e5d5deeb$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "highlightOptionPanelEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsHighlightOptionPanelEnabledQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsHighlightOptionPanelEnabledQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "8a0218b2e1c99a56ce8c33454f5c992d",
            "id": "0cf895ac8ba230224c74d275c984b0c91d2ac44dddcf2fde63e3993339c6b240",
            "metadata": {},
            "name": "useIsHighlightOptionPanelEnabledQuery",
            "operationKind": "query",
            "text": "query useIsHighlightOptionPanelEnabledQuery{userPreferences{highlightOptionPanelEnabled}}"
        }
    };
}();
$9a2dad19e5d5deeb$var$node.hash = "f1838f0592c7a8f202fdc84d54752216";
var $9a2dad19e5d5deeb$export$2e2bcd8739ae039 = $9a2dad19e5d5deeb$var$node;
module.exports["default"] = $9a2dad19e5d5deeb$export$2e2bcd8739ae039;

});

parcelRegister("3BPrE", function(module, exports) {
var $e3661bd3089bf51c$export$7309710dd8a888d9 = /*#__PURE__*/ function(InlineCommentPubSubEvents) {
    InlineCommentPubSubEvents["InlineCommentCreated"] = "avi:confluence:created:inline_comment";
    InlineCommentPubSubEvents["RendererInlineCommentCreated"] = "avi:confluence:created:renderer_inline_comment";
    InlineCommentPubSubEvents["EditorInlineCommentCreated"] = "avi:confluence:created:editor_inline_comment";
    InlineCommentPubSubEvents["InlineCommentDeleted"] = "avi:confluence:deleted:inline_comment";
    InlineCommentPubSubEvents["InlineCommentResolved"] = "avi:confluence:resolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUnresolved"] = "avi:confluence:unresolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUpdated"] = "avi:confluence:updated:inline_comment";
    InlineCommentPubSubEvents["InlineCommentReattached"] = "avi:confluence:reattach:inline_comment";
    return InlineCommentPubSubEvents;
}({});
var $e3661bd3089bf51c$export$d05a35896d8f557d = /*#__PURE__*/ function(InlineCommentSubscriptionEvents) {
    InlineCommentSubscriptionEvents["InlineCommentCreated"] = "inlineCommentCreated";
    InlineCommentSubscriptionEvents["RendererInlineCommentCreated"] = "rendererInlineCommentCreated";
    InlineCommentSubscriptionEvents["EditorInlineCommentCreated"] = "editorInlineCommentCreated";
    InlineCommentSubscriptionEvents["InlineCommentDeleted"] = "inlineCommentDeleted";
    InlineCommentSubscriptionEvents["InlineCommentResolved"] = "inlineCommentResolved";
    InlineCommentSubscriptionEvents["InlineCommentUnresolved"] = "inlineCommentUnresolved";
    InlineCommentSubscriptionEvents["InlineCommentUpdated"] = "inlineCommentUpdated";
    InlineCommentSubscriptionEvents["InlineCommentReattached"] = "inlineCommentReattached";
    return InlineCommentSubscriptionEvents;
}({});
var $e3661bd3089bf51c$export$5d941a2346cc8f6a = /*#__PURE__*/ function(PagePubSubEvents) {
    PagePubSubEvents["PagePublished"] = "avi:confluence:publish:page";
    PagePubSubEvents["BlogPublished"] = "avi:confluence:publish:blogpost";
    return PagePubSubEvents;
}({});
var $e3661bd3089bf51c$export$15c104b3df413bde = /*#__PURE__*/ function(PageSubscriptionEvents) {
    PageSubscriptionEvents["PageUpdated"] = "pageUpdated";
    return PageSubscriptionEvents;
}({});
module.exports["InlineCommentPubSubEvents"] = $e3661bd3089bf51c$export$7309710dd8a888d9;
module.exports["InlineCommentSubscriptionEvents"] = $e3661bd3089bf51c$export$d05a35896d8f557d;
module.exports["PagePubSubEvents"] = $e3661bd3089bf51c$export$5d941a2346cc8f6a;
module.exports["PageSubscriptionEvents"] = $e3661bd3089bf51c$export$15c104b3df413bde;

});

parcelRegister("03oqz", function(module, exports) {

var $8i27m = parcelRequire("8i27m");


var $3B9cR = parcelRequire("3B9cR");


var $1C8XP = parcelRequire("1C8XP");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");

const $895e8bda1c5e4d1e$export$15e2805385ec0eed = (contentId, markerRef)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return (0, $c0rhi.queryInterop)({
        query: (0, $3B9cR.InlineCommentQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            annotationId: markerRef,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        },
        __callerPackage__: "@confluence/comments-pubsub"
    });
    else return (0, $c0rhi.queryInterop)({
        query: (0, $1C8XP.ActiveInlineCommentsQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            inlineMarkerRefList: [
                markerRef
            ],
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        },
        __callerPackage__: "@confluence/comments-pubsub"
    });
};
const $895e8bda1c5e4d1e$export$90e382997b4dc102 = async (contentId, markerRef)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        const commentThreadDataResult = await (0, $c0rhi.queryInterop)({
            query: (0, $3B9cR.InlineCommentQuery),
            fetchPolicy: 'network-only',
            variables: {
                pageId: contentId,
                annotationId: markerRef,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            },
            __callerPackage__: "@confluence/comments-pubsub"
        });
        return commentThreadDataResult.data;
    } else {
        const commentThreadDataResult = await (0, $c0rhi.queryInterop)({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            fetchPolicy: 'network-only',
            variables: {
                pageId: contentId,
                inlineMarkerRefList: [
                    markerRef
                ],
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            },
            __callerPackage__: "@confluence/comments-pubsub"
        });
        return commentThreadDataResult.data;
    }
};
const $895e8bda1c5e4d1e$export$e136ff0cd91112e0 = async ({ contentId: contentId, markerRef: markerRef, addNewCommentThreads: addNewCommentThreads })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) addNewCommentThreads && addNewCommentThreads({
        inline: {
            [markerRef]: {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false,
                type: (0, $8i27m.CommentType).INLINE
            }
        },
        general: {}
    });
};
const $895e8bda1c5e4d1e$export$120fd6a8527dd6bd = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, addReplyToCommentThread: addReplyToCommentThread, commentType: commentType, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const replies = comment?.replies;
    const reply = replies?.filter((r)=>r?.id === commentId)[0];
    if (reply) {
        // Update storedCommentData if it exists by adding the new reply
        if (storedCommentData && setStoredCommentData) {
            const updatedCommentData = {
                ...storedCommentData,
                replies: [
                    ...storedCommentData.replies || [],
                    reply
                ]
            };
            // Only update if inlineMarkerRef matches between stored and fetched comment
            if (storedCommentData.location?.inlineMarkerRef === comment?.location?.inlineMarkerRef) setStoredCommentData(updatedCommentData);
        }
        addReplyToCommentThread && addReplyToCommentThread(markerRef, {
            ...reply
        }, commentType);
    }
};
const $895e8bda1c5e4d1e$export$7652b163bd2668c5 = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, updateCommentBody: updateCommentBody })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const targetComment = comment?.id === commentId ? comment : comment?.replies?.find((r)=>r?.id === commentId);
    if (targetComment && updateCommentBody) updateCommentBody(commentId, markerRef, targetComment.body.value, (0, $8i27m.CommentType).INLINE, targetComment.version.by?.displayName);
};
module.exports["refreshCommentThread"] = $895e8bda1c5e4d1e$export$15e2805385ec0eed;
module.exports["handleAddNewCommentThread"] = $895e8bda1c5e4d1e$export$e136ff0cd91112e0;
module.exports["handleAddedReplyInCommentThread"] = $895e8bda1c5e4d1e$export$120fd6a8527dd6bd;
module.exports["handleEditedComment"] = $895e8bda1c5e4d1e$export$7652b163bd2668c5;

});

parcelRegister("2HGN8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $42omo.useState)();
    // Clear the override state when navigating to a different page
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_appearance_override_reset')) setContentAppearanceOverride(undefined);
    }, [
        contentId
    ]);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const editorWidth = metadata?.editorWidth;
            const widthValue = editorWidth?.value;
            const version = editorWidth?.version;
            if (widthValue && version !== undefined) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    /*
  	Previous check was:
  	const draftAppearanceQuery = getContentAppearanceQuery(ContentAppearancePropertyKey.DRAFT);
  	which always returns contentAppearanceQuery
  */ const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $jMyy4.useQueryInterop)((0, $8VcPj.contentAppearanceQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        __callerPackage__: "@confluence/content-appearance"
    });
    const context = (0, $42omo.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        // Under certain circumstances due to a previous bug with the content appearance during legacy editor autoconvert, an incorrect value may have been sent to collab service.
        // In this circumstance favour the initial content appearance value.
        const shouldUseInitial = contentAppearanceOverride && initialContentAppearance && contentAppearanceOverride.version === initialContentAppearance.version && contentAppearanceOverride.appearance !== initialContentAppearance.appearance;
        return {
            contentAppearance: shouldUseInitial ? initialContentAppearance : contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $42omo.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("dGzwg", function(module, exports) {
"use strict";
var $9f6ac0077b20b014$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $9f6ac0077b20b014$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $9f6ac0077b20b014$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $9f6ac0077b20b014$var$debounceTime;
var $9f6ac0077b20b014$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9f6ac0077b20b014$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9f6ac0077b20b014$var$DebounceTimeSubscriber = function(_super) {
    $9f6ac0077b20b014$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($9f6ac0077b20b014$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($axeml.Subscriber);
function $9f6ac0077b20b014$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

});

parcelRegister("dmKyV", function(module, exports) {
$parcel$export(module.exports, "WRM", () => (parcelRequire("1UB3e")).default);
$parcel$export(module.exports, "withWRMDependencies", () => (parcelRequire("6u5YI")).default);

var $1UB3e = parcelRequire("1UB3e");


var $6u5YI = parcelRequire("6u5YI");


});

parcelRegister("1UB3e", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 */ const $1647c2fd90c2cc68$var$WRM = {
    require (dependencies, callback) {
        return new Promise((resolve)=>{
            (0, $cpjd2.requireLegacyWRM)(dependencies, (modules)=>{
                resolve(modules);
                if (callback) callback(modules);
            }, ()=>{});
        });
    }
};
var $1647c2fd90c2cc68$export$2e2bcd8739ae039 = $1647c2fd90c2cc68$var$WRM;
module.exports["default"] = $1647c2fd90c2cc68$export$2e2bcd8739ae039;

});

parcelRegister("6u5YI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 *
 * withWRMDependencies is a decorator for loading WRM dependencies.
 *
 * It's a helper which besides loading dependencies will also hide the component
 * while the dependencies are not loaded avoiding FOUC and weird behaviours.
 *
 * usage:
 *
 * withWRMDependencies('wr!mypluginkey')(
 *  class MyComponent extends Component {}
 * )
 *
 * or
 *
 * withWRMDependencies(['wrc!myContext', 'wr!myWebResource'])(
 *  class MyComponent extends Component {}
 * )
 */ function $4b8a2e9a57493429$var$withWRMDependencies(dependencies, options) {
    const configs = {
        isBlocking: true,
        ...options
    };
    return (BaseComponent)=>{
        class WRMComponent extends (0, $42omo.Component) {
            componentDidMount() {
                this.mounted = true;
                if (dependencies && dependencies.length > 0) (0, $cpjd2.requireLegacyWRM)(dependencies, this.markAsLoaded, ()=>{});
                else this.markAsLoaded();
            }
            componentWillUnmount() {
                this.mounted = false;
            }
            render() {
                const { dependenciesLoaded: dependenciesLoaded } = this.state;
                if (dependenciesLoaded || !configs.isBlocking) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, {
                    ...this.props,
                    wrmDependenciesLoaded: dependenciesLoaded
                });
                else return null;
            }
            constructor(...args){
                super(...args);
                this.state = {
                    dependenciesLoaded: false
                };
                this.markAsLoaded = ()=>{
                    if (this.mounted) this.setState({
                        dependenciesLoaded: true
                    });
                };
            }
        }
        WRMComponent.displayName = `WRMComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return WRMComponent;
    };
}
var $4b8a2e9a57493429$export$2e2bcd8739ae039 = $4b8a2e9a57493429$var$withWRMDependencies;
module.exports["default"] = $4b8a2e9a57493429$export$2e2bcd8739ae039;

});

parcelRegister("6O2BV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f497007dae01ffa$export$25fb473e92ff8332 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PT7yD",
    name: "ClassicEditorContextProviderLoader",
    loader: ()=>(parcelRequire("kx2WO"))
});
module.exports["ClassicEditorContextProviderLoader"] = $4f497007dae01ffa$export$25fb473e92ff8332;

});

parcelRegister("kx2WO", function(module, exports) {

let $ef292d0981fc0e61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef292d0981fc0e61$var$load("h3ABO"),
    $ef292d0981fc0e61$var$load("2YffH"),
    $ef292d0981fc0e61$var$load("fUl3O"),
    $ef292d0981fc0e61$var$load("kuluX"),
    $ef292d0981fc0e61$var$load("eXKRO"),
    $ef292d0981fc0e61$var$load("eBRUf"),
    $ef292d0981fc0e61$var$load("cSTi7"),
    $ef292d0981fc0e61$var$load("499Dr"),
    $ef292d0981fc0e61$var$load("dr1mZ"),
    $ef292d0981fc0e61$var$load("3SEnm"),
    $ef292d0981fc0e61$var$load("jbxHq"),
    $ef292d0981fc0e61$var$load("8YSo7"),
    $ef292d0981fc0e61$var$load("5Wqrg"),
    $ef292d0981fc0e61$var$load("hs6P3"),
    $ef292d0981fc0e61$var$load("lMqM5"),
    $ef292d0981fc0e61$var$load("6wr18"),
    $ef292d0981fc0e61$var$load("h9S8v"),
    $ef292d0981fc0e61$var$load("dl2qY"),
    $ef292d0981fc0e61$var$load("kL5FA"),
    $ef292d0981fc0e61$var$load("cHb2G"),
    $ef292d0981fc0e61$var$load("3GuOt"),
    $ef292d0981fc0e61$var$load("jbM5v"),
    $ef292d0981fc0e61$var$load("lE8tR"),
    $ef292d0981fc0e61$var$load("alA4m"),
    $ef292d0981fc0e61$var$load("3VIZM"),
    $ef292d0981fc0e61$var$load("gyh6H"),
    $ef292d0981fc0e61$var$load("gBV5J"),
    $ef292d0981fc0e61$var$load("djjX5"),
    $ef292d0981fc0e61$var$load("cX4Bp"),
    $ef292d0981fc0e61$var$load("dawn8"),
    $ef292d0981fc0e61$var$load("cyGuT"),
    $ef292d0981fc0e61$var$load("ffEVr"),
    $ef292d0981fc0e61$var$load("7huND"),
    $ef292d0981fc0e61$var$load("jBZJd"),
    $ef292d0981fc0e61$var$load("2rRRp"),
    $ef292d0981fc0e61$var$load("aQh37"),
    $ef292d0981fc0e61$var$load("bJVDE"),
    $ef292d0981fc0e61$var$load("bhtkd"),
    $ef292d0981fc0e61$var$load("14zRe"),
    $ef292d0981fc0e61$var$load("gwwqw"),
    $ef292d0981fc0e61$var$load("cbazH"),
    $ef292d0981fc0e61$var$load("2Ws5B"),
    $ef292d0981fc0e61$var$load("YAi2k"),
    $ef292d0981fc0e61$var$load("adNrA"),
    $ef292d0981fc0e61$var$load("oTA4y"),
    $ef292d0981fc0e61$var$load("fPbCp"),
    $ef292d0981fc0e61$var$load("zSp86"),
    $ef292d0981fc0e61$var$load("7tgvK"),
    $ef292d0981fc0e61$var$load("fRtVQ"),
    $ef292d0981fc0e61$var$load("b9CA3"),
    $ef292d0981fc0e61$var$load("dIjeS"),
    $ef292d0981fc0e61$var$load("Wowvf"),
    $ef292d0981fc0e61$var$load("1F7LX"),
    $ef292d0981fc0e61$var$load("c6DIp"),
    $ef292d0981fc0e61$var$load("dgH7p"),
    $ef292d0981fc0e61$var$load("hH53H"),
    $ef292d0981fc0e61$var$load("jZLnv"),
    $ef292d0981fc0e61$var$load("6edij"),
    $ef292d0981fc0e61$var$load("3QXpo"),
    $ef292d0981fc0e61$var$load("iHdyB"),
    $ef292d0981fc0e61$var$load("hhss7"),
    $ef292d0981fc0e61$var$load("f2Ovh"),
    $ef292d0981fc0e61$var$load("lAHER"),
    $ef292d0981fc0e61$var$load("7EorR"),
    $ef292d0981fc0e61$var$load("lsb09")
]).then(()=>parcelRequire('gnN3I'));

});


//# sourceMappingURL=Renderer.d94191cf.js.map
